export default {
  en: {
    // Nav
    home: 'Home',
    features: 'Features',
    pricing: 'Pricing',
    clinicsNav: 'Clinics',
    aiAssistant: 'AI Assistant',
    forBusiness: 'For Business',
    dashboard: 'Dashboard',
    getStarted: 'Get Started',
    tryDemo: 'Try Live Demo',
    viewPitch: 'View Pitch Deck',

    // Landing Hero
    heroTagline: 'Dental Platform for Georgia',
    heroTitle: 'All dental clinics hub',
    heroSubtitle: 'Your AI assistant to find the best dental care in Georgia',
    searchPlaceholder: 'Search clinics, services, or ask anything...',
    chipImplant: 'Best implant clinics in Tbilisi',
    chipWhitening: 'Teeth whitening near me',
    chipEmergency: 'Emergency dental care',
    chipOrtho: 'Orthodontics for adults',
    scrollExplore: 'Scroll to explore',
    topRated: 'Top-rated dental clinics in Tbilisi',
    viewAllClinics: 'View all clinics',
    shareLocation: 'Share location for nearby clinics',
    locationShared: 'Location shared — showing nearby',

    // Landing Stats
    statClinics: 'Clinics',
    statNoShows: 'Less No-shows',
    statBooking: 'Online Booking',
    statDentists: 'Dentists',
    statRating: 'Avg Rating',
    statPatients: 'Patients',

    // Landing Actions
    findClinics: 'Find Best Clinics',
    forBusinessBtn: 'For Business',

    // Landing Claim
    ownClinic: 'Do you own a dental clinic?',
    claimText: "Claim your listing or add it to our database. We'll help people find your clinic.",
    getListed: 'Get Listed →',

    // Clinics Page
    clinicsTitle: 'Dental Clinics in Georgia',
    verifiedClinics: 'verified clinics with ratings and reviews',
    searchByName: 'Search by name, district, or service...',
    hideMap: 'Hide Map',
    showMap: 'Map',
    nearMe: 'Near Me',
    clinicsMatch: 'clinics match',
    reviews: 'reviews',
    loadingMore: 'Loading more...',

    // Clinic Detail
    callClinic: 'Call',
    bookAppointment: 'Book Appointment',
    services: 'Services',
    workingHours: 'Working Hours',
    priceRange: 'Price Range',
    location: 'Location',
    visitWebsite: 'Visit Website',

    // Booking
    bookingTitle: 'Book an Appointment',
    step: 'Step',
    selectClinic: 'Select Clinic',
    selectService: 'Select Service',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    confirm: 'Confirm',
    next: 'Next',
    back: 'Back',
    clinicsAvailable: 'clinics available',
    clinicsFound: 'clinics found',
    confirmBooking: 'Confirm Booking',
    bookingConfirmed: 'Your appointment has been booked!',
    patientName: 'Patient Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    notes: 'Notes (optional)',

    // Doctor Booking
    bookByClinic: 'Book by Clinic',
    bookByDoctor: 'Book by Doctor',
    chooseDoctor: 'Choose a Doctor',
    specialOffer: 'Special offer',
    specialOfferAvailable: 'Special offer available',
    availableAtClinics: 'Available at clinics',
    bookAtClinic: 'Book here',

    // Business Page
    businessHeroBadge: '15+ Modules  ·  212+ Clinics  ·  Gemini AI',
    businessHeroTitle: 'The Operating System for Dental Clinics',
    businessHeroSubtitle: 'Clinical charting, periodontal analysis, treatment planning, scheduling, billing, e-prescribing, lab management, and AI diagnostics — all in one platform built for Georgia.',
    theProblem: 'The Problem',
    problemSubtitle: 'Georgian dental clinics lose revenue daily due to fragmented tools',
    excelChaos: 'Excel & WhatsApp Chaos',
    excelChaosDetail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.',
    noShowRate: '25% No-Show Rate',
    noShowDetail: 'Without automated reminders, patients forget appointments. Empty chairs mean ₾500+/day in lost revenue.',
    paperCharts: 'Paper Charts in 2026',
    paperChartsDetail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.',
    insuranceBlackHole: 'Insurance Black Hole',
    insuranceDetail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.',

    // Platform Modules
    oneplatform: 'One Platform, Every Module',
    platformSubtitle: '15 integrated modules purpose-built for dental practices',
    clinical: 'CLINICAL',
    operations: 'OPERATIONS',
    analyticsEnterprise: 'ANALYTICS & ENTERPRISE',
    digitalOdontogram: 'Digital Odontogram',
    digitalOdontogramDetail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.',
    perioCharting: 'Perio Charting',
    perioChartingDetail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.',
    treatmentPlanning: 'Treatment Planning',
    treatmentPlanningDetail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.',
    soapNotes: 'SOAP Notes + AI Scribe',
    soapNotesDetail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.',
    multiChairScheduling: 'Multi-Chair Scheduling',
    multiChairDetail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.',
    billingInsurance: 'Billing & Insurance',
    billingDetail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.',
    ePrescribing: 'e-Prescribing',
    ePrescribingDetail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.',
    labTracking: 'Lab Case Tracking',
    labTrackingDetail: 'Kanban pipeline: Ordered → Fabrication → Shipped → Received. Vendor management, quality tracking.',
    productionReports: 'Production Reports',
    productionReportsDetail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.',
    referralMgmt: 'Referral Management',
    referralMgmtDetail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.',
    medicalHistory: 'Medical History',
    medicalHistoryDetail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.',
    enterpriseAdmin: 'Enterprise Admin',
    enterpriseAdminDetail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.',

    // AI Section
    geminiBuiltIn: 'Gemini AI Built In',
    geminiSubtitle: 'Every module powered by Google Gemini 3.1',
    xrayAnalysis: 'X-ray Analysis',
    xrayDetail: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment: 'Perio Assessment',
    perioAssessmentDetail: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe: 'Clinical Scribe',
    clinicalScribeDetail: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling: 'Risk Profiling',
    riskProfilingDetail: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing: 'Treatment Sequencing',
    treatmentSequencingDetail: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientComm: 'Patient Communication',
    patientCommDetail: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',

    // Integrations
    georgianEcosystem: 'Georgian Ecosystem Ready',
    integrationsSubtitle: 'Pre-built integrations with local insurance, payments, and messaging',
    insurance: 'INSURANCE',
    payments: 'PAYMENTS',
    messaging: 'MESSAGING',
    ehrLabs: 'EHR & LABS',

    // Stats
    clinicsInDb: 'Clinics in Database',
    platformModules: 'Platform Modules',
    aiTools: 'AI Tools (Gemini)',
    integrations: 'Integrations',

    // Pricing
    pricingTitle: 'Pricing',
    pricingSubtitle: 'Start free, scale as you grow',

    // Testimonials
    trustedBy: 'Trusted by Leading Clinics',

    // CTA
    readyModernize: 'Ready to modernize your practice?',
    joinCount: 'Join 212+ dental clinics across Georgia already on the platform.',
    startTrial: 'Start Free Trial',
    contactSales: 'Contact Sales',
    noCreditCard: 'No credit card required  ·  Free tier available  ·  Setup in 5 minutes',

    // Footer
    copyright: '© 2026 MCAI — Dental Clinic Operating System',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Dashboard',
    navPatients: 'Patients',
    navChart: 'Chart',
    navPerio: 'Perio',
    navTreatmentPlans: 'Treatment Plans',
    navNotes: 'Notes',
    navScheduling: 'Scheduling',
    navBilling: 'Billing',
    navPrescriptions: 'Prescriptions',
    navLabCases: 'Lab Cases',
    navReferrals: 'Referrals',
    navReports: 'Reports',
    navMedHistory: 'Medical History',
    navFinances: 'Finance',
    navCabinets: 'Cabinets',
    navRadiology: 'Radiology',
    navDocuments: 'Documents',
    navConsent: 'Consent',
    navInventory: 'Inventory',
    navChat: 'Chat',
    navIntegrations: 'Integrations',
    navEnterprise: 'Enterprise',
    sectionClinical: 'CLINICAL',
    sectionOperations: 'OPERATIONS',
    sectionComm: 'COMMUNICATION',
    sectionAnalytics: 'ANALYTICS',
    sectionAiTools: 'AI TOOLS',
    sectionAdmin: 'ADMIN',

    // Booking Page
    chooseClinic: 'Choose a Clinic',
    selectAService: 'Select a Service',
    pickADate: 'Pick a Date',
    pickATime: 'Pick a Time',
    confirmYourBooking: 'Confirm Your Booking',
    clinicLabel: 'Clinic:',
    serviceLabel: 'Service:',
    dateLabel: 'Date:',
    timeLabel: 'Time:',

    // AI Page
    send: 'Send',
    procedure: 'Procedure',
    observations: 'Observations',
    aiThinking: 'AI is thinking...',
    summarizeHistory: 'Summarize patient history',
    generateTxPlan: 'Generate treatment plan',
    checkDrugInteractions: 'Check drug interactions',
    writeClinicalNote: 'Write clinical note',
    askAiAssistant: 'Ask the AI assistant...',
    dropXray: 'Drop X-ray image or click to upload',
    supportsFormats: 'Supports DICOM, PNG, JPG',
    analysisResults: 'Analysis Results (Demo)',
    aiRecommendation: 'AI Recommendation',
    exportToTxPlan: 'Export to Treatment Plan',
    generateClinicalNote: 'Generate Clinical Note',
    generatedSoap: 'Generated Clinical Note (SOAP)',
    subjective: 'S — Subjective',
    objective: 'O — Objective',
    assessment: 'A — Assessment',
    plan: 'P — Plan',
    copyToRecord: 'Copy to Patient Record',
    aiPerioAssessment: 'AI Periodontal Assessment',
    enterProbingData: 'Enter probing data to get AAP staging/grading and treatment recommendations.',
    analyzeWithGemini: 'Analyze with Gemini',
    aiRiskAssessment: 'AI Risk Assessment',
    enterConditions: 'Enter patient conditions, family history, and vitals to generate a risk profile.',
    generateRiskProfile: 'Generate Risk Profile',
    patientCommunication: 'Patient Communication',
    generateExplanations: 'Generate patient-friendly treatment explanations in Georgian or English.',
    generateExplanation: 'Generate Explanation',
    patientFriendly: 'Patient-Friendly Explanation',

    // Billing Page
    claims: 'Claims',
    ledger: 'Ledger',
    aging: 'Aging',
    paymentPlans: 'Payment Plans',
    eligibility: 'Eligibility',
    allFilter: 'All',
    submitted: 'Submitted',
    paid: 'Paid',
    denied: 'Denied',
    patientLedger: 'Patient Ledger',
    agedAccounts: 'Aged Accounts',
    sendStatements: 'Send Statements',
    activePaymentPlans: 'Active Payment Plans',
    insuranceEligibility: 'Insurance Eligibility',

    // Clinical Charting
    odontogram: 'Odontogram',
    perioTab: 'Perio',
    treatmentPlanTab: 'Treatment Plan',
    notesTab: 'Notes',
    progressNotes: 'Progress Notes',
    openFullPerio: 'Open Full Periodontal Chart →',
    openFullTxPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes: 'Open Clinical Notes →',
    newExam: 'New Exam',
    voiceEntry: 'Voice Entry',
    bleedingIndex: 'Bleeding Index',
    plaqueIndex: 'Plaque Index',
    sitesAbove4: 'Sites ≥ 4mm',
    sitesAbove6: 'Sites ≥ 6mm',
    planA: 'Plan A: Recommended',
    planB: 'Plan B: Conservative',
    newPlan: '+ New Plan',
    presentToPatient: 'Present to Patient',
    sendToPortal: 'Send to Portal',
    totalFee: 'Total Fee',
    insuranceEst: 'Insurance Est.',
    patientPortion: 'Patient Portion',
    chairSideMode: 'Chair-side Mode',
    adminMode: 'Admin Mode',
    proceduresAcrossPhases: '{0} procedures across {1} phases',

    // Scheduling
    day: 'Day',
    week: 'Week',
    today: 'Today',
    providerFilter: 'All Providers',
    productionGoal: 'Production Goal',
    waitlist: 'Waitlist',

    // Prescriptions
    activeRx: 'Active',
    pastRx: 'Past',
    templates: 'Templates',
    interactionCheck: 'Interaction Check',

    // Lab Cases
    ordered: 'Ordered',
    sentToLab: 'Sent to Lab',
    inFabrication: 'In Fabrication',
    shipped: 'Shipped',
    received: 'Received',
    labVendors: 'Lab Vendors',

    // Referrals
    allDirections: 'All',
    inbound: 'Inbound',
    outbound: 'Outbound',
    generateLetter: 'Generate Letter',

    // Reports
    production: 'Production',
    collections: 'Collections',
    schedulingReport: 'Scheduling',
    treatmentAcceptance: 'Treatment Acceptance',
    recall: 'Recall',
    grossProduction: 'Gross Production',
    netProduction: 'Net Production',
    collectionRate: 'Collection Rate',
    plansPresented: 'Plans Presented',
    accepted: 'Accepted',
    acceptanceRate: 'Acceptance Rate',
    dueThisMonth: 'Due This Month',
    scheduled: 'Scheduled',
    completed: 'Completed',
    overdue: 'Overdue',
    reactivationRate: 'Reactivation Rate',

    // Medical History
    timeline: 'Timeline',
    conditions: 'Conditions',
    medications: 'Medications',
    allergies: 'Allergies',
    labResults: 'Lab Results',
    vitals: 'Vitals',
    immunizations: 'Immunizations',
    familyHistory: 'Family History',
    imaging: 'Imaging',
    documents: 'Documents',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Audit Log',
    compliance: 'Compliance',
    multiTenancy: 'Multi-Tenancy',
    sso: 'SSO & Security',
    featureFlags: 'Feature Flags',
    apiManagement: 'API Management',
    dataManagement: 'Data Management',

    // Integrations
    ehr: 'EHR',
    labs: 'Labs',
    telehealth: 'Telehealth',
    aiMl: 'AI/ML',
    wearables: 'Wearables',
    connected: 'Connected',
    disconnected: 'Disconnected',
    available: 'Available',

    // Components
    status: 'Status',
    healthy: 'Healthy',
    caries: 'Caries',
    restored: 'Restored',
    missing: 'Missing',
    implant: 'Implant',
    crownStatus: 'Crown',
    bridge: 'Bridge',
    veneer: 'Veneer',
    braces: 'Braces',
    surfaces: 'Surfaces',
    procedureHistory: 'Procedure History',
    procedureTimeline: 'Procedure Timeline',
    noHistory: 'No procedures recorded',
    chartLegend: 'Chart Legend',
    addProcedure: 'Add Procedure',
    addHistory: 'Add History',
    addDentalHistory: 'Add Dental History',
    patientReported: 'Patient-reported',
    verified: 'Verified',
    toothNumber: 'Tooth Number',
    selectTooth: 'Select tooth...',
    procedureType: 'Procedure Type',
    selectProcedure: 'Select procedure...',
    filling: 'Filling',
    crown: 'Crown',
    rootCanal: 'Root Canal',
    extraction: 'Extraction',
    implantProc: 'Implant',
    cleaningProc: 'Cleaning',
    whiteningProc: 'Whitening',
    bracesProc: 'Braces',
    other: 'Other',
    month: 'Month',
    year: 'Year',
    selectMonth: 'Select month...',
    selectYear: 'Select year...',
    doctorNameOptional: 'Doctor Name (Optional)',
    enterDoctorName: 'Enter doctor name',
    clinicNameOptional: 'Clinic Name (Optional)',
    enterClinicName: 'Enter clinic name',
    notes: 'Notes',
    enterNotes: 'Add any notes about this procedure...',
    cancel: 'Cancel',
    appointmentDetails: 'Appointment Details',
    openPatientRecord: 'Open Patient Record',
    submitHistory: 'Submit History',
    procedures: 'procedures',
    nextAppt: 'Next',
    totalCharged: 'Total Charged',
    insurancePayment: 'Insurance Payment',
    patientResponsibility: 'Patient Responsibility',
    expand: 'Expand',
    policyNumber: 'Policy #',
    planType: 'Plan Type',
    annualMax: 'Annual Max',
    used: 'Used',
    remaining: 'Remaining',
    coverageByCategory: 'Coverage by Category',
    preventive: 'Preventive',
    basic: 'Basic',
    major: 'Major',
    ortho: 'Ortho',
    current: 'Current',
    thirtyDay: '30 Day',
    sixtyDay: '60 Day',
    ninetyPlus: '90+ Day',
    totalBalance: 'Total Balance',
    monthlyPayment: 'Monthly Payment',
    paymentsRemaining: 'Payments Remaining',
    nextPayment: 'Next Payment',
    paymentProgress: 'Payment Progress',
    choosePlan: 'Choose Plan',
    aiInsight: 'AI Insight',
    confidence: 'Confidence',
    revoke: 'Revoke',
    exams: 'Exams',
    phaseTotal: 'Phase Total',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    thinking: 'Thinking...',
    followUpPlaceholder: 'Ask a follow-up question...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    // Nav
    home: 'Home',
    features: 'Features',
    pricing: 'Pricing',
    clinicsNav: 'Clinics',
    aiAssistant: 'AI Assistant',
    forBusiness: 'For Business',
    dashboard: 'Dashboard',
    getStarted: 'Get Started',
    tryDemo: 'Try Live Demo',
    viewPitch: 'View Pitch Deck',

    // Landing Hero
    heroTagline: 'Dental Platform for Georgia',
    heroTitle: 'All dental clinics hub',
    heroSubtitle: 'Your AI assistant to find the best dental care in Georgia',
    searchPlaceholder: 'Search clinics, services, or ask anything...',
    chipImplant: 'Best implant clinics in Tbilisi',
    chipWhitening: 'Teeth whitening near me',
    chipEmergency: 'Emergency dental care',
    chipOrtho: 'Orthodontics for adults',
    scrollExplore: 'Scroll to explore',
    topRated: 'Top-rated dental clinics in Tbilisi',
    viewAllClinics: 'View all clinics',
    shareLocation: 'Share location for nearby clinics',
    locationShared: 'Location shared — showing nearby',

    // Landing Stats
    statClinics: 'Clinics',
    statNoShows: 'Less No-shows',
    statBooking: 'Online Booking',
    statDentists: 'Dentists',
    statRating: 'Avg Rating',
    statPatients: 'Patients',

    // Landing Actions
    findClinics: 'Find Best Clinics',
    forBusinessBtn: 'For Business',

    // Landing Claim
    ownClinic: 'Do you own a dental clinic?',
    claimText: "Claim your listing or add it to our database. We'll help people find your clinic.",
    getListed: 'Get Listed →',

    // Clinics Page
    clinicsTitle: 'Dental Clinics in Georgia',
    verifiedClinics: 'verified clinics with ratings and reviews',
    searchByName: 'Search by name, district, or service...',
    hideMap: 'Hide Map',
    showMap: 'Map',
    nearMe: 'Near Me',
    clinicsMatch: 'clinics match',
    reviews: 'reviews',
    loadingMore: 'Loading more...',

    // Clinic Detail
    callClinic: 'Call',
    bookAppointment: 'Book Appointment',
    services: 'Services',
    workingHours: 'Working Hours',
    priceRange: 'Price Range',
    location: 'Location',
    visitWebsite: 'Visit Website',

    // Booking
    bookingTitle: 'Book an Appointment',
    step: 'Step',
    selectClinic: 'Select Clinic',
    selectService: 'Select Service',
    selectDate: 'Select Date',
    selectTime: 'Select Time',
    confirm: 'Confirm',
    next: 'Next',
    back: 'Back',
    clinicsAvailable: 'clinics available',
    clinicsFound: 'clinics found',
    confirmBooking: 'Confirm Booking',
    bookingConfirmed: 'Your appointment has been booked!',
    patientName: 'Patient Name',
    phoneNumber: 'Phone Number',
    email: 'Email',
    notes: 'Notes (optional)',

    // Doctor Booking
    bookByClinic: 'Book by Clinic',
    bookByDoctor: 'Book by Doctor',
    chooseDoctor: 'Choose a Doctor',
    specialOffer: 'Special offer',
    specialOfferAvailable: 'Special offer available',
    availableAtClinics: 'Available at clinics',
    bookAtClinic: 'Book here',

    // Business Page
    businessHeroBadge: '15+ Modules  ·  212+ Clinics  ·  Gemini AI',
    businessHeroTitle: 'The Operating System for Dental Clinics',
    businessHeroSubtitle: 'Clinical charting, periodontal analysis, treatment planning, scheduling, billing, e-prescribing, lab management, and AI diagnostics — all in one platform built for Georgia.',
    theProblem: 'The Problem',
    problemSubtitle: 'Georgian dental clinics lose revenue daily due to fragmented tools',
    excelChaos: 'Excel & WhatsApp Chaos',
    excelChaosDetail: 'Clinics manage appointments through spreadsheets and chat groups. Zero automation, constant errors, lost records.',
    noShowRate: '25% No-Show Rate',
    noShowDetail: 'Without automated reminders, patients forget appointments. Empty chairs mean ₾500+/day in lost revenue.',
    paperCharts: 'Paper Charts in 2026',
    paperChartsDetail: 'Handwritten clinical notes, no digital odontogram, no perio tracking. Critical data trapped in filing cabinets.',
    insuranceBlackHole: 'Insurance Black Hole',
    insuranceDetail: 'Manual claims to Aldagi, GPI, Imedi L take hours. Denied claims pile up with no tracking or appeal workflow.',

    // Platform Modules
    oneplatform: 'One Platform, Every Module',
    platformSubtitle: '15 integrated modules purpose-built for dental practices',
    clinical: 'CLINICAL',
    operations: 'OPERATIONS',
    analyticsEnterprise: 'ANALYTICS & ENTERPRISE',
    digitalOdontogram: 'Digital Odontogram',
    digitalOdontogramDetail: 'FDI 32-tooth chart with 5-surface tracking. Click any surface to record caries, restorations, crowns, implants, and missing teeth.',
    perioCharting: 'Perio Charting',
    perioChartingDetail: '192-site periodontal grid. 6-point probing, BOP, CAL, furcation, mobility. AAP staging via Gemini AI.',
    treatmentPlanning: 'Treatment Planning',
    treatmentPlanningDetail: 'Phased plans with CDT codes, insurance estimates, patient portions. Drag-and-drop reordering. AI sequencing.',
    soapNotes: 'SOAP Notes + AI Scribe',
    soapNotesDetail: 'Structured clinical documentation with templates. Gemini generates notes from voice or chart data.',
    multiChairScheduling: 'Multi-Chair Scheduling',
    multiChairDetail: 'Week view with multiple operatories. Provider color-coding, production goals, waitlist management.',
    billingInsurance: 'Billing & Insurance',
    billingDetail: 'Claims tracking for Aldagi, GPI, Imedi L. Patient ledger, aging buckets, payment plans, eligibility checks.',
    ePrescribing: 'e-Prescribing',
    ePrescribingDetail: 'Digital prescriptions with templates. Gemini-powered drug interaction checking. Georgian pharmacy integration.',
    labTracking: 'Lab Case Tracking',
    labTrackingDetail: 'Kanban pipeline: Ordered → Fabrication → Shipped → Received. Vendor management, quality tracking.',
    productionReports: 'Production Reports',
    productionReportsDetail: 'Gross/net production, collection rates, treatment acceptance, recall effectiveness. Per-provider breakdown.',
    referralMgmt: 'Referral Management',
    referralMgmtDetail: 'Inbound/outbound referrals to specialists. AI-generated referral letters. Status tracking.',
    medicalHistory: 'Medical History',
    medicalHistoryDetail: '11-view patient record: timeline, conditions (ICD-10), medications, allergies, vitals, imaging, documents.',
    enterpriseAdmin: 'Enterprise Admin',
    enterpriseAdminDetail: 'RBAC, audit logs, compliance meters, multi-tenancy, SSO, feature flags, API management.',

    // AI Section
    geminiBuiltIn: 'Gemini AI Built In',
    geminiSubtitle: 'Every module powered by Google Gemini 3.1',
    xrayAnalysis: 'X-ray Analysis',
    xrayDetail: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment: 'Perio Assessment',
    perioAssessmentDetail: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe: 'Clinical Scribe',
    clinicalScribeDetail: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling: 'Risk Profiling',
    riskProfilingDetail: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing: 'Treatment Sequencing',
    treatmentSequencingDetail: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientComm: 'Patient Communication',
    patientCommDetail: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',

    // Integrations
    georgianEcosystem: 'Georgian Ecosystem Ready',
    integrationsSubtitle: 'Pre-built integrations with local insurance, payments, and messaging',
    insurance: 'INSURANCE',
    payments: 'PAYMENTS',
    messaging: 'MESSAGING',
    ehrLabs: 'EHR & LABS',

    // Stats
    clinicsInDb: 'Clinics in Database',
    platformModules: 'Platform Modules',
    aiTools: 'AI Tools (Gemini)',
    integrations: 'Integrations',

    // Pricing
    pricingTitle: 'Pricing',
    pricingSubtitle: 'Start free, scale as you grow',

    // Testimonials
    trustedBy: 'Trusted by Leading Clinics',

    // CTA
    readyModernize: 'Ready to modernize your practice?',
    joinCount: 'Join 212+ dental clinics across Georgia already on the platform.',
    startTrial: 'Start Free Trial',
    contactSales: 'Contact Sales',
    noCreditCard: 'No credit card required  ·  Free tier available  ·  Setup in 5 minutes',

    // Footer
    copyright: '© 2026 MCAI — Dental Clinic Operating System',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Dashboard',
    navPatients: 'Patients',
    navChart: 'Chart',
    navPerio: 'Perio',
    navTreatmentPlans: 'Treatment Plans',
    navNotes: 'Notes',
    navScheduling: 'Scheduling',
    navBilling: 'Billing',
    navPrescriptions: 'Prescriptions',
    navLabCases: 'Lab Cases',
    navReferrals: 'Referrals',
    navReports: 'Reports',
    navMedHistory: 'Medical History',
    navFinances: 'Finance',
    navCabinets: 'Cabinets',
    navRadiology: 'Radiology',
    navDocuments: 'Documents',
    navConsent: 'Consent',
    navInventory: 'Inventory',
    navChat: 'Chat',
    navIntegrations: 'Integrations',
    navEnterprise: 'Enterprise',
    sectionClinical: 'CLINICAL',
    sectionOperations: 'OPERATIONS',
    sectionComm: 'COMMUNICATION',
    sectionAnalytics: 'ANALYTICS',
    sectionAiTools: 'AI TOOLS',
    sectionAdmin: 'ADMIN',

    // Booking Page
    chooseClinic: 'Choose a Clinic',
    selectAService: 'Select a Service',
    pickADate: 'Pick a Date',
    pickATime: 'Pick a Time',
    confirmYourBooking: 'Confirm Your Booking',
    clinicLabel: 'Clinic:',
    serviceLabel: 'Service:',
    dateLabel: 'Date:',
    timeLabel: 'Time:',

    // AI Page
    send: 'Send',
    procedure: 'Procedure',
    observations: 'Observations',
    aiThinking: 'AI is thinking...',
    summarizeHistory: 'Summarize patient history',
    generateTxPlan: 'Generate treatment plan',
    checkDrugInteractions: 'Check drug interactions',
    writeClinicalNote: 'Write clinical note',
    askAiAssistant: 'Ask the AI assistant...',
    dropXray: 'Drop X-ray image or click to upload',
    supportsFormats: 'Supports DICOM, PNG, JPG',
    analysisResults: 'Analysis Results (Demo)',
    aiRecommendation: 'AI Recommendation',
    exportToTxPlan: 'Export to Treatment Plan',
    generateClinicalNote: 'Generate Clinical Note',
    generatedSoap: 'Generated Clinical Note (SOAP)',
    subjective: 'S — Subjective',
    objective: 'O — Objective',
    assessment: 'A — Assessment',
    plan: 'P — Plan',
    copyToRecord: 'Copy to Patient Record',
    aiPerioAssessment: 'AI Periodontal Assessment',
    enterProbingData: 'Enter probing data to get AAP staging/grading and treatment recommendations.',
    analyzeWithGemini: 'Analyze with Gemini',
    aiRiskAssessment: 'AI Risk Assessment',
    enterConditions: 'Enter patient conditions, family history, and vitals to generate a risk profile.',
    generateRiskProfile: 'Generate Risk Profile',
    patientCommunication: 'Patient Communication',
    generateExplanations: 'Generate patient-friendly treatment explanations in Georgian or English.',
    generateExplanation: 'Generate Explanation',
    patientFriendly: 'Patient-Friendly Explanation',

    // Billing Page
    claims: 'Claims',
    ledger: 'Ledger',
    aging: 'Aging',
    paymentPlans: 'Payment Plans',
    eligibility: 'Eligibility',
    allFilter: 'All',
    submitted: 'Submitted',
    paid: 'Paid',
    denied: 'Denied',
    patientLedger: 'Patient Ledger',
    agedAccounts: 'Aged Accounts',
    sendStatements: 'Send Statements',
    activePaymentPlans: 'Active Payment Plans',
    insuranceEligibility: 'Insurance Eligibility',

    // Clinical Charting
    odontogram: 'Odontogram',
    perioTab: 'Perio',
    treatmentPlanTab: 'Treatment Plan',
    notesTab: 'Notes',
    progressNotes: 'Progress Notes',
    openFullPerio: 'Open Full Periodontal Chart →',
    openFullTxPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes: 'Open Clinical Notes →',
    newExam: 'New Exam',
    voiceEntry: 'Voice Entry',
    bleedingIndex: 'Bleeding Index',
    plaqueIndex: 'Plaque Index',
    sitesAbove4: 'Sites ≥ 4mm',
    sitesAbove6: 'Sites ≥ 6mm',
    planA: 'Plan A: Recommended',
    planB: 'Plan B: Conservative',
    newPlan: '+ New Plan',
    presentToPatient: 'Present to Patient',
    sendToPortal: 'Send to Portal',
    totalFee: 'Total Fee',
    insuranceEst: 'Insurance Est.',
    patientPortion: 'Patient Portion',
    chairSideMode: 'Chair-side Mode',
    adminMode: 'Admin Mode',
    proceduresAcrossPhases: '{0} procedures across {1} phases',

    // Scheduling
    day: 'Day',
    week: 'Week',
    today: 'Today',
    providerFilter: 'All Providers',
    productionGoal: 'Production Goal',
    waitlist: 'Waitlist',

    // Prescriptions
    activeRx: 'Active',
    pastRx: 'Past',
    templates: 'Templates',
    interactionCheck: 'Interaction Check',

    // Lab Cases
    ordered: 'Ordered',
    sentToLab: 'Sent to Lab',
    inFabrication: 'In Fabrication',
    shipped: 'Shipped',
    received: 'Received',
    labVendors: 'Lab Vendors',

    // Referrals
    allDirections: 'All',
    inbound: 'Inbound',
    outbound: 'Outbound',
    generateLetter: 'Generate Letter',

    // Reports
    production: 'Production',
    collections: 'Collections',
    schedulingReport: 'Scheduling',
    treatmentAcceptance: 'Treatment Acceptance',
    recall: 'Recall',
    grossProduction: 'Gross Production',
    netProduction: 'Net Production',
    collectionRate: 'Collection Rate',
    plansPresented: 'Plans Presented',
    accepted: 'Accepted',
    acceptanceRate: 'Acceptance Rate',
    dueThisMonth: 'Due This Month',
    scheduled: 'Scheduled',
    completed: 'Completed',
    overdue: 'Overdue',
    reactivationRate: 'Reactivation Rate',

    // Medical History
    timeline: 'Timeline',
    conditions: 'Conditions',
    medications: 'Medications',
    allergies: 'Allergies',
    labResults: 'Lab Results',
    vitals: 'Vitals',
    immunizations: 'Immunizations',
    familyHistory: 'Family History',
    imaging: 'Imaging',
    documents: 'Documents',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Audit Log',
    compliance: 'Compliance',
    multiTenancy: 'Multi-Tenancy',
    sso: 'SSO & Security',
    featureFlags: 'Feature Flags',
    apiManagement: 'API Management',
    dataManagement: 'Data Management',

    // Integrations
    ehr: 'EHR',
    labs: 'Labs',
    telehealth: 'Telehealth',
    aiMl: 'AI/ML',
    wearables: 'Wearables',
    connected: 'Connected',
    disconnected: 'Disconnected',
    available: 'Available',

    // Components
    status: 'Status',
    healthy: 'Healthy',
    caries: 'Caries',
    restored: 'Restored',
    missing: 'Missing',
    implant: 'Implant',
    crownStatus: 'Crown',
    bridge: 'Bridge',
    veneer: 'Veneer',
    braces: 'Braces',
    surfaces: 'Surfaces',
    procedureHistory: 'Procedure History',
    procedureTimeline: 'Procedure Timeline',
    noHistory: 'No procedures recorded',
    chartLegend: 'Chart Legend',
    addProcedure: 'Add Procedure',
    addHistory: 'Add History',
    addDentalHistory: 'Add Dental History',
    patientReported: 'Patient-reported',
    verified: 'Verified',
    toothNumber: 'Tooth Number',
    selectTooth: 'Select tooth...',
    procedureType: 'Procedure Type',
    selectProcedure: 'Select procedure...',
    filling: 'Filling',
    crown: 'Crown',
    rootCanal: 'Root Canal',
    extraction: 'Extraction',
    implantProc: 'Implant',
    cleaningProc: 'Cleaning',
    whiteningProc: 'Whitening',
    bracesProc: 'Braces',
    other: 'Other',
    month: 'Month',
    year: 'Year',
    selectMonth: 'Select month...',
    selectYear: 'Select year...',
    doctorNameOptional: 'Doctor Name (Optional)',
    enterDoctorName: 'Enter doctor name',
    clinicNameOptional: 'Clinic Name (Optional)',
    enterClinicName: 'Enter clinic name',
    notes: 'Notes',
    enterNotes: 'Add any notes about this procedure...',
    cancel: 'Cancel',
    appointmentDetails: 'Appointment Details',
    openPatientRecord: 'Open Patient Record',
    submitHistory: 'Submit History',
    procedures: 'procedures',
    nextAppt: 'Next',
    totalCharged: 'Total Charged',
    insurancePayment: 'Insurance Payment',
    patientResponsibility: 'Patient Responsibility',
    expand: 'Expand',
    policyNumber: 'Policy #',
    planType: 'Plan Type',
    annualMax: 'Annual Max',
    used: 'Used',
    remaining: 'Remaining',
    coverageByCategory: 'Coverage by Category',
    preventive: 'Preventive',
    basic: 'Basic',
    major: 'Major',
    ortho: 'Ortho',
    current: 'Current',
    thirtyDay: '30 Day',
    sixtyDay: '60 Day',
    ninetyPlus: '90+ Day',
    totalBalance: 'Total Balance',
    monthlyPayment: 'Monthly Payment',
    paymentsRemaining: 'Payments Remaining',
    nextPayment: 'Next Payment',
    paymentProgress: 'Payment Progress',
    choosePlan: 'Choose Plan',
    aiInsight: 'AI Insight',
    confidence: 'Confidence',
    revoke: 'Revoke',
    exams: 'Exams',
    phaseTotal: 'Phase Total',
    mon: 'Mon',
    tue: 'Tue',
    wed: 'Wed',
    thu: 'Thu',
    fri: 'Fri',
    sat: 'Sat',
    sun: 'Sun',
    thinking: 'Thinking...',
    followUpPlaceholder: 'Ask a follow-up question...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    // Informed Consent
    informedConsent: 'Informed Consent',
    informedConsentTitle: 'Informed Consent Form',
    newConsent: 'New Consent',
    consentHistory: 'Consent History',
    consentProcedureTitle: 'Procedure Description',
    consentProcedureDesc: 'Your dentist has recommended the following procedure. This section describes the nature, purpose, and expected steps of the planned treatment. Please read carefully before acknowledging.',
    consentRisksTitle: 'Risks & Complications',
    consentRisksDesc: 'As with any medical or dental procedure, there are potential risks including but not limited to infection, bleeding, nerve damage, allergic reaction to materials or anesthesia, and the possibility that the treatment may not achieve the desired outcome.',
    consentAlternativesTitle: 'Alternative Treatments',
    consentAlternativesDesc: 'Alternative treatment options may include no treatment, delayed treatment, or different procedures. Each alternative carries its own benefits and risks. Your dentist can discuss these options with you in detail.',
    consentOutcomesTitle: 'Expected Outcomes',
    consentOutcomesDesc: 'The expected outcome of this procedure is to restore dental health, function, and/or aesthetics. Individual results may vary based on the complexity of the case, patient compliance, and other health factors.',
    consentAftercareTitle: 'Aftercare Instructions',
    consentAftercareDesc: 'Following the procedure, you will receive specific aftercare instructions. These may include dietary restrictions, medication schedules, activity limitations, and follow-up appointment requirements. Adherence to these instructions is essential for optimal healing.',
    consentAcknowledge: 'I understand and agree',
    eSignatureTitle: 'Electronic Signature',
    consentCheckAllFirst: 'Please acknowledge all sections above before signing',
    clearSignature: 'Clear Signature',
    confirmSignature: 'Confirm Signature',
    signatureCapturedAt: 'Signature captured at',
    signed: 'Signed',
    awaitingSignature: 'Awaiting signature',
    viewDetails: 'View Details',
    untitled: 'Untitled',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  },

  ka: {
    // Nav
    home: 'მთავარი',
    features: 'ფუნქციები',
    pricing: 'ფასები',
    clinicsNav: 'კლინიკები',
    aiAssistant: 'AI ასისტენტი',
    forBusiness: 'ბიზნესისთვის',
    dashboard: 'მთავარი პანელი',
    getStarted: 'დაწყება',
    tryDemo: 'სცადეთ დემო',
    viewPitch: 'პრეზენტაციის ნახვა',

    // Landing Hero
    heroTagline: 'სტომატოლოგიური პლატფორმა საქართველოსთვის',
    heroTitle: 'ყველა სტომატოლოგიური კლინიკა ერთ სივრცეში',
    heroSubtitle: 'თქვენი AI ასისტენტი საქართველოში საუკეთესო სტომატოლოგიური მომსახურების მოსაძებნად',
    searchPlaceholder: 'მოძებნეთ კლინიკები, სერვისები ან ჰკითხეთ რამე...',
    chipImplant: 'საუკეთესო იმპლანტაციის კლინიკები თბილისში',
    chipWhitening: 'კბილების გათეთრება ჩემთან ახლოს',
    chipEmergency: 'გადაუდებელი სტომატოლოგიური დახმარება',
    chipOrtho: 'ორთოდონტია მოზრდილებისთვის',
    scrollExplore: 'გადაახვიეთ სანახავად',
    topRated: 'საუკეთესო შეფასების კლინიკები თბილისში',
    viewAllClinics: 'ყველა კლინიკის ნახვა',
    shareLocation: 'გააზიარეთ მდებარეობა ახლომდებარე კლინიკებისთვის',
    locationShared: 'მდებარეობა გაზიარებულია — ახლომდებარე ჩანს',

    // Landing Stats
    statClinics: 'კლინიკა',
    statNoShows: 'ნაკლები გაცდენა',
    statBooking: 'ონლაინ ჯავშანი',
    statDentists: 'სტომატოლოგი',
    statRating: 'საშ. შეფასება',
    statPatients: 'პაციენტი',

    // Landing Actions
    findClinics: 'იპოვეთ საუკეთესო კლინიკები',
    forBusinessBtn: 'ბიზნესისთვის',

    // Landing Claim
    ownClinic: 'სტომატოლოგიური კლინიკის მფლობელი ხართ?',
    claimText: 'დარეგისტრირეთ თქვენი კლინიკა ან დაამატეთ ჩვენს ბაზაში. დავეხმარებით ხალხს თქვენი კლინიკის პოვნაში.',
    getListed: 'დარეგისტრირდით →',

    // Clinics Page
    clinicsTitle: 'სტომატოლოგიური კლინიკები საქართველოში',
    verifiedClinics: 'ვერიფიცირებული კლინიკა შეფასებებითა და მიმოხილვებით',
    searchByName: 'მოძებნეთ სახელით, რაიონით ან სერვისით...',
    hideMap: 'რუკის დამალვა',
    showMap: 'რუკა',
    nearMe: 'ჩემთან ახლოს',
    clinicsMatch: 'კლინიკა ემთხვევა',
    reviews: 'მიმოხილვა',
    loadingMore: 'იტვირთება...',

    // Clinic Detail
    callClinic: 'დარეკვა',
    bookAppointment: 'ვიზიტის დაჯავშნა',
    services: 'სერვისები',
    workingHours: 'სამუშაო საათები',
    priceRange: 'ფასის დიაპაზონი',
    location: 'მდებარეობა',
    visitWebsite: 'ვებსაიტის ნახვა',

    // Booking
    bookingTitle: 'ვიზიტის დაჯავშნა',
    step: 'ნაბიჯი',
    selectClinic: 'აირჩიეთ კლინიკა',
    selectService: 'აირჩიეთ სერვისი',
    selectDate: 'აირჩიეთ თარიღი',
    selectTime: 'აირჩიეთ დრო',
    confirm: 'დადასტურება',
    next: 'შემდეგი',
    back: 'უკან',
    clinicsAvailable: 'კლინიკა ხელმისაწვდომია',
    clinicsFound: 'კლინიკა მოიძებნა',
    confirmBooking: 'ჯავშნის დადასტურება',
    bookingConfirmed: 'თქვენი ვიზიტი დაჯავშნილია!',
    patientName: 'პაციენტის სახელი',
    phoneNumber: 'ტელეფონის ნომერი',
    email: 'ელ.ფოსტა',
    notes: 'შენიშვნები (არასავალდებულო)',

    // Business Page
    businessHeroBadge: '15+ მოდული  ·  212+ კლინიკა  ·  Gemini AI',
    businessHeroTitle: 'სტომატოლოგიური კლინიკების ოპერაციული სისტემა',
    businessHeroSubtitle: 'კლინიკური ჩარტინგი, პერიოდონტოლოგიური ანალიზი, მკურნალობის დაგეგმვა, განრიგი, ანგარიშსწორება, ელ.რეცეპტები, ლაბორატორიის მართვა და AI დიაგნოსტიკა — ყველაფერი ერთ პლატფორმაზე.',
    theProblem: 'პრობლემა',
    problemSubtitle: 'საქართველოს სტომატოლოგიური კლინიკები ყოველდღიურად კარგავენ შემოსავალს ფრაგმენტული ინსტრუმენტების გამო',
    excelChaos: 'Excel და WhatsApp ქაოსი',
    excelChaosDetail: 'კლინიკები ვიზიტებს ცხრილებით და ჩატებით მართავენ. ნულოვანი ავტომატიზაცია, მუდმივი შეცდომები, დაკარგული ჩანაწერები.',
    noShowRate: '25% გაცდენის მაჩვენებელი',
    noShowDetail: 'ავტომატური შეხსენებების გარეშე პაციენტები ვიზიტებს ავიწყდებათ. ცარიელი სავარძლები ₾500+/დღეში დაკარგულ შემოსავალს ნიშნავს.',
    paperCharts: 'ქაღალდის ჩარტები 2026-ში',
    paperChartsDetail: 'ხელნაწერი კლინიკური ჩანაწერები, ციფრული ოდონტოგრამის გარეშე, პერიოდონტოლოგიური თრექინგის გარეშე. კრიტიკული მონაცემები ჩაკეტილია საქაღალდეებში.',
    insuranceBlackHole: 'დაზღვევის შავი ხვრელი',
    insuranceDetail: 'ხელით მოთხოვნები ალდაგისთვის, GPI-სთვის, იმედი ელ-სთვის საათებს მოითხოვს. უარყოფილი მოთხოვნები გროვდება თრექინგისა და გასაჩივრების გარეშე.',

    // Platform Modules
    oneplatform: 'ერთი პლატფორმა, ყველა მოდული',
    platformSubtitle: '15 ინტეგრირებული მოდული სტომატოლოგიური პრაქტიკისთვის',
    clinical: 'კლინიკური',
    operations: 'ოპერაციული',
    analyticsEnterprise: 'ანალიტიკა და ენტერპრაიზი',
    digitalOdontogram: 'ციფრული ოდონტოგრამა',
    digitalOdontogramDetail: 'FDI 32-კბილიანი რუკა 5-ზედაპირიანი თრექინგით. დააწკაპუნეთ ნებისმიერ ზედაპირზე კარიესის, რესტავრაციის, გვირგვინის, იმპლანტისა და ამოღებული კბილის აღსანიშნავად.',
    perioCharting: 'პერიოდონტოლოგიური ჩარტინგი',
    perioChartingDetail: '192-ადგილიანი პერიოდონტოლოგიური ბადე. 6-წერტილიანი ზონდირება, BOP, CAL, ფურკაცია, მობილობა. AAP სტეიჯინგი Gemini AI-ით.',
    treatmentPlanning: 'მკურნალობის დაგეგმვა',
    treatmentPlanningDetail: 'ფაზური გეგმები CDT კოდებით, სადაზღვევო შეფასებებით, პაციენტის წილით. გადაათრიეთ გადალაგებისთვის. AI სეკვენცირება.',
    soapNotes: 'SOAP ჩანაწერები + AI სკრიბი',
    soapNotesDetail: 'სტრუქტურირებული კლინიკური დოკუმენტაცია შაბლონებით. Gemini ქმნის ჩანაწერებს ხმიდან ან ჩარტის მონაცემებიდან.',
    multiChairScheduling: 'მრავალსავარძლიანი განრიგი',
    multiChairDetail: 'კვირის ხედი მრავალი ოპერატორიით. პროვაიდერის ფერით კოდირება, წარმოების მიზნები, მოლოდინის სიის მართვა.',
    billingInsurance: 'ანგარიშსწორება და დაზღვევა',
    billingDetail: 'მოთხოვნების თრექინგი ალდაგი, GPI, იმედი ელ-სთვის. პაციენტის ბალანსი, დავალიანების ასაკობრივი კატეგორიები, გადახდის გეგმები, უფლებამოსილების შემოწმება.',
    ePrescribing: 'ელ.რეცეპტები',
    ePrescribingDetail: 'ციფრული რეცეპტები შაბლონებით. Gemini-ს მიერ წამლების ურთიერთქმედების შემოწმება. ქართულ აფთიაქებთან ინტეგრაცია.',
    labTracking: 'ლაბორატორიული შემთხვევების თრექინგი',
    labTrackingDetail: 'კანბან პაიპლაინი: შეკვეთილი → ფაბრიკაცია → გაგზავნილი → მიღებული. მომწოდებლების მართვა, ხარისხის თრექინგი.',
    productionReports: 'წარმოების ანგარიშები',
    productionReportsDetail: 'მთლიანი/წმინდა წარმოება, შეგროვების მაჩვენებლები, მკურნალობის მიღება, გამოძახების ეფექტურობა. პროვაიდერის მიხედვით დაშლა.',
    referralMgmt: 'რეფერალების მართვა',
    referralMgmtDetail: 'შემომავალი/გამავალი რეფერალები სპეციალისტებთან. AI-ს მიერ გენერირებული სარეფერალო წერილები. სტატუსის თრექინგი.',
    medicalHistory: 'სამედიცინო ისტორია',
    medicalHistoryDetail: '11-ხედიანი პაციენტის ჩანაწერი: ქრონოლოგია, მდგომარეობები (ICD-10), მედიკამენტები, ალერგიები, სასიცოცხლო მაჩვენებლები, გამოსახულებები, დოკუმენტები.',
    enterpriseAdmin: 'ენტერპრაიზ ადმინისტრირება',
    enterpriseAdminDetail: 'RBAC, აუდიტის ჟურნალი, შესაბამისობის მეტრიკები, მულტი-ტენანტობა, SSO, ფუნქციის ფლაგები, API მართვა.',

    // AI Section
    geminiBuiltIn: 'Gemini AI ჩაშენებული',
    geminiSubtitle: 'ყველა მოდული Google Gemini 3.1-ით არის აღჭურვილი',
    xrayAnalysis: 'რენტგენის ანალიზი',
    xrayDetail: 'ატვირთეთ სტომატოლოგიური რენტგენი AI-ით კარიესის აღმოჩენის, ძვლის დონის შეფასებისა და პერიაპიკალური პათოლოგიის იდენტიფიკაციისთვის.',
    perioAssessment: 'პერიოდონტოლოგიური შეფასება',
    perioAssessmentDetail: 'ავტომატური AAP სტეიჯინგი/გრეიდინგი ზონდირების მონაცემებიდან. პროგრესიის იდენტიფიკაცია, SRP ან ქირურგიული ჩარევის რეკომენდაცია.',
    clinicalScribe: 'კლინიკური სკრიბი',
    clinicalScribeDetail: 'SOAP ჩანაწერების გენერაცია ხმოვანი ჩაწერიდან ან ჩარტის მონაცემებიდან. CDT კოდების და ICD-10-ის ავტომატური გამოყენება.',
    riskProfiling: 'რისკის პროფილირება',
    riskProfilingDetail: 'ანალიზებს მდგომარეობას, ოჯახის ისტორიას და სასიცოცხლო მაჩვენებლებს ყოვლისმომცველი სტომატოლოგიური რისკის პროფილის შესაქმნელად.',
    treatmentSequencing: 'მკურნალობის სეკვენცირება',
    treatmentSequencingDetail: 'AI-ოპტიმიზებული მკურნალობის ფაზირება შეხორცების პერიოდების, სადაზღვევო წლების და კლინიკური პრიორიტეტების გათვალისწინებით.',
    patientComm: 'პაციენტის კომუნიკაცია',
    patientCommDetail: 'პაციენტისთვის გასაგები ახსნა-განმარტებების გენერაცია ქართულად. კლინიკური ჟარგონის გასაგებ ენაზე თარგმნა.',

    // Integrations
    georgianEcosystem: 'ქართული ეკოსისტემა მზადაა',
    integrationsSubtitle: 'წინასწარ აგებული ინტეგრაციები ადგილობრივ დაზღვევასთან, გადახდებთან და მესიჯინგთან',
    insurance: 'დაზღვევა',
    payments: 'გადახდები',
    messaging: 'მესიჯინგი',
    ehrLabs: 'EHR და ლაბორატორიები',

    // Stats
    clinicsInDb: 'კლინიკა ბაზაში',
    platformModules: 'პლატფორმის მოდული',
    aiTools: 'AI ინსტრუმენტი (Gemini)',
    integrations: 'ინტეგრაცია',

    // Pricing
    pricingTitle: 'ფასები',
    pricingSubtitle: 'დაიწყეთ უფასოდ, გაიზარდეთ თანდათან',

    // Testimonials
    trustedBy: 'წამყვანი კლინიკების ნდობით',

    // CTA
    readyModernize: 'მზად ხართ თქვენი პრაქტიკის მოდერნიზაციისთვის?',
    joinCount: 'შეუერთდით 212+ სტომატოლოგიურ კლინიკას საქართველოში, რომლებიც უკვე პლატფორმაზეა.',
    startTrial: 'უფასო ცდის დაწყება',
    contactSales: 'გაყიდვებთან დაკავშირება',
    noCreditCard: 'საკრედიტო ბარათი არ სჭირდება  ·  უფასო გეგმა ხელმისაწვდომია  ·  დაყენება 5 წუთში',

    // Footer
    copyright: '© 2026 MCAI — სტომატოლოგიური კლინიკების ოპერაციული სისტემა',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'მთავარი პანელი',
    navPatients: 'პაციენტები',
    navChart: 'სტომატოლოგიური რუკა',
    navPerio: 'პერიო',
    navTreatmentPlans: 'მკურნალობის გეგმები',
    navNotes: 'ჩანაწერები',
    navScheduling: 'განრიგი',
    navBilling: 'ანგარიშსწორება',
    navPrescriptions: 'რეცეპტები',
    navLabCases: 'ლაბორატორიული შემთხვევები',
    navReferrals: 'რეფერალები',
    navReports: 'ანგარიშები',
    navMedHistory: 'სამედიცინო ისტორია',
    navFinances: 'ფინანსები',
    navCabinets: 'კაბინეტები',
    navRadiology: 'რადიოლოგია',
    navDocuments: 'დოკუმენტები',
    navConsent: 'თანხმობა',
    navInventory: 'ინვენტარი',
    navChat: 'ჩათი',
    navIntegrations: 'ინტეგრაციები',
    navEnterprise: 'ენტერპრაიზი',
    sectionClinical: 'კლინიკური',
    sectionOperations: 'ოპერაციული',
    sectionComm: 'კომუნიკაცია',
    sectionAnalytics: 'ანალიტიკა',
    sectionAiTools: 'AI ინსტრუმენტები',
    sectionAdmin: 'ადმინისტრირება',

    // Booking Page
    chooseClinic: 'აირჩიეთ კლინიკა',
    selectAService: 'აირჩიეთ სერვისი',
    pickADate: 'აირჩიეთ თარიღი',
    pickATime: 'აირჩიეთ დრო',
    confirmYourBooking: 'დაადასტურეთ ჯავშანი',
    clinicLabel: 'კლინიკა:',
    serviceLabel: 'სერვისი:',
    dateLabel: 'თარიღი:',
    timeLabel: 'დრო:',

    // AI Page
    send: 'გაგზავნა',
    procedure: 'პროცედურა',
    observations: 'დაკვირვებები',
    aiThinking: 'AI ფიქრობს...',
    summarizeHistory: 'პაციენტის ისტორიის შეჯამება',
    generateTxPlan: 'მკურნალობის გეგმის გენერაცია',
    checkDrugInteractions: 'წამლების ურთიერთქმედების შემოწმება',
    writeClinicalNote: 'კლინიკური ჩანაწერის დაწერა',
    askAiAssistant: 'ჰკითხეთ AI ასისტენტს...',
    dropXray: 'ჩააგდეთ რენტგენის სურათი ან დააწკაპუნეთ ასატვირთად',
    supportsFormats: 'მხარდაჭერილია DICOM, PNG, JPG',
    analysisResults: 'ანალიზის შედეგები (დემო)',
    aiRecommendation: 'AI რეკომენდაცია',
    exportToTxPlan: 'ექსპორტი მკურნალობის გეგმაში',
    generateClinicalNote: 'კლინიკური ჩანაწერის გენერაცია',
    generatedSoap: 'გენერირებული კლინიკური ჩანაწერი (SOAP)',
    subjective: 'S — სუბიექტური',
    objective: 'O — ობიექტური',
    assessment: 'A — შეფასება',
    plan: 'P — გეგმა',
    copyToRecord: 'კოპირება პაციენტის ჩანაწერში',
    aiPerioAssessment: 'AI პერიოდონტოლოგიური შეფასება',
    enterProbingData: 'შეიყვანეთ ზონდირების მონაცემები AAP სტეიჯინგისა და მკურნალობის რეკომენდაციებისთვის.',
    analyzeWithGemini: 'ანალიზი Gemini-ით',
    aiRiskAssessment: 'AI რისკის შეფასება',
    enterConditions: 'შეიყვანეთ პაციენტის მდგომარეობა, ოჯახის ისტორია და სასიცოცხლო მაჩვენებლები რისკის პროფილის შესაქმნელად.',
    generateRiskProfile: 'რისკის პროფილის გენერაცია',
    patientCommunication: 'პაციენტის კომუნიკაცია',
    generateExplanations: 'პაციენტისთვის გასაგები მკურნალობის ახსნის გენერაცია ქართულად ან ინგლისურად.',
    generateExplanation: 'ახსნის გენერაცია',
    patientFriendly: 'პაციენტისთვის გასაგები ახსნა',

    // Billing Page
    claims: 'მოთხოვნები',
    ledger: 'ბალანსის წიგნი',
    aging: 'დავალიანების ასაკი',
    paymentPlans: 'გადახდის გეგმები',
    eligibility: 'უფლებამოსილება',
    allFilter: 'ყველა',
    submitted: 'გაგზავნილი',
    paid: 'გადახდილი',
    denied: 'უარყოფილი',
    patientLedger: 'პაციენტის ბალანსი',
    agedAccounts: 'ვადაგადაცილებული ანგარიშები',
    sendStatements: 'ამონაწერების გაგზავნა',
    activePaymentPlans: 'აქტიური გადახდის გეგმები',
    insuranceEligibility: 'სადაზღვევო უფლებამოსილება',

    // Clinical Charting
    odontogram: 'ოდონტოგრამა',
    perioTab: 'პერიო',
    treatmentPlanTab: 'მკურნალობის გეგმა',
    notesTab: 'ჩანაწერები',
    progressNotes: 'პროგრესის ჩანაწერები',
    openFullPerio: 'სრული პერიოდონტოლოგიური ჩარტის გახსნა →',
    openFullTxPlanner: 'სრული მკურნალობის დამგეგმავის გახსნა →',
    openClinicalNotes: 'კლინიკური ჩანაწერების გახსნა →',
    newExam: 'ახალი გამოკვლევა',
    voiceEntry: 'ხმოვანი შეყვანა',
    bleedingIndex: 'სისხლდენის ინდექსი',
    plaqueIndex: 'ნადების ინდექსი',
    sitesAbove4: 'უბნები ≥ 4მმ',
    sitesAbove6: 'უბნები ≥ 6მმ',
    planA: 'გეგმა A: რეკომენდებული',
    planB: 'გეგმა B: კონსერვატიული',
    newPlan: '+ ახალი გეგმა',
    presentToPatient: 'პაციენტისთვის წარდგენა',
    sendToPortal: 'პორტალზე გაგზავნა',
    totalFee: 'ჯამური საფასური',
    insuranceEst: 'სადაზღვევო შეფასება',
    patientPortion: 'პაციენტის წილი',

    // Scheduling
    day: 'დღე',
    week: 'კვირა',
    today: 'დღეს',
    providerFilter: 'ყველა პროვაიდერი',
    productionGoal: 'წარმოების მიზანი',
    waitlist: 'მოლოდინის სია',

    // Prescriptions
    activeRx: 'აქტიური',
    pastRx: 'წარსული',
    templates: 'შაბლონები',
    interactionCheck: 'ურთიერთქმედების შემოწმება',

    // Lab Cases
    ordered: 'შეკვეთილი',
    sentToLab: 'ლაბორატორიაში გაგზავნილი',
    inFabrication: 'ფაბრიკაციაში',
    shipped: 'გაგზავნილი',
    received: 'მიღებული',
    labVendors: 'ლაბორატორიის მომწოდებლები',

    // Referrals
    allDirections: 'ყველა',
    inbound: 'შემომავალი',
    outbound: 'გამავალი',
    generateLetter: 'წერილის გენერაცია',

    // Reports
    production: 'წარმოება',
    collections: 'შეგროვება',
    schedulingReport: 'განრიგი',
    treatmentAcceptance: 'მკურნალობის მიღება',
    recall: 'გამოძახება',
    grossProduction: 'მთლიანი წარმოება',
    netProduction: 'წმინდა წარმოება',
    collectionRate: 'შეგროვების მაჩვენებელი',
    plansPresented: 'წარდგენილი გეგმები',
    accepted: 'მიღებული',
    acceptanceRate: 'მიღების მაჩვენებელი',
    dueThisMonth: 'ამ თვეში დაგეგმილი',
    scheduled: 'დაგეგმილი',
    completed: 'დასრულებული',
    overdue: 'ვადაგადაცილებული',
    reactivationRate: 'რეაქტივაციის მაჩვენებელი',

    // Medical History
    timeline: 'ქრონოლოგია',
    conditions: 'მდგომარეობები',
    medications: 'მედიკამენტები',
    allergies: 'ალერგიები',
    labResults: 'ლაბორატორიული შედეგები',
    vitals: 'სასიცოცხლო მაჩვენებლები',
    immunizations: 'იმუნიზაციები',
    familyHistory: 'ოჯახის ისტორია',
    imaging: 'გამოსახულებები',
    documents: 'დოკუმენტები',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'აუდიტის ჟურნალი',
    compliance: 'შესაბამისობა',
    multiTenancy: 'მულტი-ტენანტობა',
    sso: 'SSO და უსაფრთხოება',
    featureFlags: 'ფუნქციის ფლაგები',
    apiManagement: 'API მართვა',
    dataManagement: 'მონაცემთა მართვა',

    // Integrations
    ehr: 'EHR',
    labs: 'ლაბორატორიები',
    telehealth: 'ტელემედიცინა',
    aiMl: 'AI/ML',
    wearables: 'ტარებადი მოწყობილობები',
    connected: 'დაკავშირებული',
    disconnected: 'გათიშული',
    available: 'ხელმისაწვდომი',

    // Components
    status: 'სტატუსი',
    healthy: 'ჯანმრთელი',
    caries: 'კარიესი',
    restored: 'აღდგენილი',
    missing: 'არმქონე',
    implant: 'იმპლანტი',
    crownStatus: 'გვირგვინი',
    bridge: 'ხიდი',
    veneer: 'ვინირი',
    surfaces: 'ზედაპირები',
    procedureHistory: 'პროცედურების ისტორია',
    addProcedure: 'პროცედურის დამატება',
    totalCharged: 'ჯამური თანხა',
    insurancePayment: 'სადაზღვევო გადახდა',
    patientResponsibility: 'პაციენტის ვალდებულება',
    expand: 'გაშლა',
    policyNumber: 'პოლისის #',
    planType: 'გეგმის ტიპი',
    annualMax: 'წლიური მაქსიმუმი',
    used: 'გამოყენებული',
    remaining: 'დარჩენილი',
    coverageByCategory: 'დაფარვა კატეგორიების მიხედვით',
    preventive: 'პრევენციული',
    basic: 'ბაზისური',
    major: 'ძირითადი',
    ortho: 'ორთო',
    current: 'მიმდინარე',
    thirtyDay: '30 დღე',
    sixtyDay: '60 დღე',
    ninetyPlus: '90+ დღე',
    totalBalance: 'ჯამური ბალანსი',
    monthlyPayment: 'ყოველთვიური გადახდა',
    paymentsRemaining: 'დარჩენილი გადახდები',
    nextPayment: 'შემდეგი გადახდა',
    paymentProgress: 'გადახდის პროგრესი',
    choosePlan: 'აირჩიეთ გეგმა',
    aiInsight: 'AI ინსაიტი',
    confidence: 'სანდოობა',
    revoke: 'გაუქმება',
    exams: 'გამოკვლევები',
    phaseTotal: 'ფაზის ჯამი',
    mon: 'ორშ',
    tue: 'სამ',
    wed: 'ოთხ',
    thu: 'ხუთ',
    fri: 'პარ',
    sat: 'შაბ',
    sun: 'კვი',
    thinking: 'ფიქრობს...',
    followUpPlaceholder: 'დასვით დამატებითი კითხვა...',
    priorityCompleteRctOn: 'პრიორიტეტი: დაასრულეთ არხის მკურნალობა #14-ზე, შემდეგ აღადგინეთ #36. დაგეგმეთ პერიოდონტოლოგიური შეფასება ძვლის დაკარგვის შესაფასებლად. განიხილეთ CBCT #14-ის დაზიანების დეტალური 3D ხედისთვის.',
    patientReportsPersistentDull: 'პაციენტი აღნიშნავს მუდმივ ტკივილს ზედა მარცხენა კვადრანტში 2 კვირის განმავლობაში. ტკივილი იზრდება ცხელი სასმელებით. სპონტანური სისხლდენა არ არის. პაციენტი აფასებს ტკივილს 5/10.',
    tooth14PositivePercussion: 'კბილი #14: დადებითი პერკუსიის ტესტი. უარყოფითი სიცოცხლისუნარიანობა (ცივი ტესტი). პერიაპიკალურ რენტგენზე 3მმ რადიოლუცენტობა აპექსზე. ზონდირების სიღრმეები ნორმის ფარგლებში (2-3მმ). მობილობა არ არის. მეზობელი კბილები სიცოცხლისუნარიანია.',
    chronicPeriapicalAbscess14: 'ქრონიკული პერიაპიკალური აბსცესი #14. პულპის ნეკროზი ღრმა კარიესის შედეგად. მწვავე ინფექციის ნიშნები არ არის.',
    english: 'ინგლისური',
    patientLedgerU2014Giorgi: 'პაციენტის ბალანსი — გიორგი ბერიძე',
    xrayAnalysis2: 'რენტგენის ანალიზი',
    uploadDentalRadiographsFor: 'ატვირთეთ სტომატოლოგიური რენტგენოგრამები AI-ით კარიესის აღმოჩენის, ძვლის დონის შეფასებისა და პერიაპიკალური პათოლოგიის იდენტიფიკაციისთვის.',
    perioAssessment2: 'პერიოდონტოლოგიური შეფასება',
    automaticAapStaginggradingFrom: 'ავტომატური AAP სტეიჯინგი/გრეიდინგი ზონდირების მონაცემებიდან. პროგრესიის იდენტიფიკაცია, SRP ან ქირურგიული ჩარევის რეკომენდაცია.',
    clinicalScribe2: 'კლინიკური სკრიბი',
    generatesSoapNotesFrom: 'SOAP ჩანაწერების გენერაცია ხმოვანი ჩაწერიდან ან ჩარტის მონაცემებიდან. CDT კოდებისა და ICD-10-ის ავტომატური გამოყენება.',
    riskProfiling2: 'რისკის პროფილირება',
    analyzesConditionsFamilyHistor: 'ანალიზებს მდგომარეობას, ოჯახის ისტორიას და სასიცოცხლო მაჩვენებლებს ყოვლისმომცველი სტომატოლოგიური რისკის პროფილის შესაქმნელად.',
    treatmentSequencing2: 'მკურნალობის სეკვენცირება',
    aioptimizedTreatmentPhasingCon: 'AI-ოპტიმიზებული მკურნალობის ფაზირება შეხორცების პერიოდების, სადაზღვევო წლების და კლინიკური პრიორიტეტების გათვალისწინებით.',
    patientCommunication2: 'პაციენტის კომუნიკაცია',
    generatesPatientfriendlyExplan: 'პაციენტისთვის გასაგები ახსნა-განმარტებების გენერაცია ქართულად. კლინიკური ჟარგონის გასაგებ ენაზე თარგმნა.',
    insurance2: 'დაზღვევა',
    automatedClaimsEligibilityVeri: 'ავტომატური მოთხოვნები, უფლებამოსილების ვერიფიკაცია, ERA-ს განთავსება',
    payments2: 'გადახდები',
    onlinePaymentsPaymentPlans: 'ონლაინ გადახდები, გადახდის გეგმები, ავტო-ბილინგი',
    messaging2: 'მესიჯინგი',
    appointmentRemindersRecallCamp: 'ვიზიტის შეხსენებები, გამოძახების კამპანიები, პორტალის მესიჯინგი',
    ehrLabs2: 'EHR და ლაბორატორიები',
    interoperableHealthRecordsLab: 'ინტეროპერაბელური ჯანმრთელობის ჩანაწერები, ლაბორატორიული შეკვეთები, გამოსახულებების სინქრონიზაცია',
    clinicsInDatabase: 'კლინიკა ბაზაში',
    platformModules2: 'პლატფორმის მოდულები',
    integrations2: 'ინტეგრაციები',
    home2: 'მთავარი',
    features2: 'ფუნქციები',
    pricing2: 'ფასები',
    dashboard2: 'მთავარი პანელი',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 სტომატოლოგიური კლინიკების ოპერაციული სისტემა',
    openFullPeriodontalChart: 'სრული პერიოდონტოლოგიური ჩარტის გახსნა →',
    openFullTreatmentPlanner: 'სრული მკურნალობის დამგეგმავის გახსნა →',
    openClinicalNotes2: 'კლინიკური ჩანაწერების გახსნა →',
    backToAllClinics: '← ყველა კლინიკაზე დაბრუნება',
    priceRange2: 'ფასის დიაპაზონი:',
    bookAnAppointment: 'ვიზიტის დაჯავშნა',
    selectDate2: 'აირჩიეთ თარიღი',
    selectTime2: 'აირჩიეთ დრო',
    confirmBooking2: 'ჯავშნის დადასტურება →',
    clinics: 'კლინიკები',
    forBusiness2: 'ბიზნესისთვის',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'კლინიკური ჩანაწერები',
    newNote: '+ ახალი ჩანაწერი',
    template: 'შაბლონი:',
    crownPrep: 'გვირგვინის პრეპარაცია',
    aiScribe: 'AI სკრიბი',
    recordYourClinicalEncounter: 'ჩაწერეთ თქვენი კლინიკური შეხვედრა და მიეცით AI-ს სტრუქტურირებული SOAP ჩანაწერების ავტომატურად გენერირების საშუალება.',
    startRecording: 'ჩაწერის დაწყება',
    generateNote: 'ჩანაწერის გენერაცია',
    general: 'ზოგადი',
    prosthetics: 'პროთეზირება',
    typeToSearch: 'აკრიფეთ სტომატოლოგიური ტერმინების საძიებლად...',
    revenueToday: 'დღევანდელი შემოსავალი',
    noshows: 'გაცდენები',
    confirmed: 'დადასტურებული',
    time: 'დრო',
    patient: 'პაციენტი',
    service: 'სერვისი',
    doctor: 'ექიმი',
    status2: 'სტატუსი',
    addPatient: '+ პაციენტის დამატება',
    mondayMarch19: 'ორშაბათი, 19 მარტი',
    gBeridzeCheckup: 'გ. ბერიძე — შემოწმება',
    nKapanadzeWhitening: 'ნ. კაპანაძე — გათეთრება',
    dGelashviliImplantPhase: 'დ. გელაშვილი — იმპლანტის ფაზა 2',
    lunchBreak: '— შესვენება —',
    mTsiklauriOrthodontics: 'მ. ციკლაური — ორთოდონტია',
    aJavakhishviliRootCanal: 'ა. ჯავახიშვილი — არხის მკურნალობა',
    lMchedlishviliExtraction: 'ლ. მჭედლიშვილი — კბილის ამოღება',
    tLomidzeCheckup: 'თ. ლომიძე — შემოწმება',
    clinicName: 'კლინიკის სახელი',
    phone: 'ტელეფონი',
    address: 'მისამართი',
    acceptedInsurance: 'მიღებული დაზღვევა',
    unison: 'Unison',
    saveSettings: 'პარამეტრების შენახვა',
    aiToolsAreAvailable: 'AI ინსტრუმენტები ხელმისაწვდომია სრული ასისტენტის ხედში.',
    openTheFullAi: 'სრული AI ასისტენტის გახსნა →',
    enterprise: 'ენტერპრაიზი',
    rolebasedAccessControl: 'როლებზე დაფუძნებული წვდომის კონტროლი',
    permissionMatrix: 'ნებართვების მატრიცა',
    module: 'მოდული',
    admin: 'ადმინი',
    doctor2: 'ექიმი',
    hygienist: 'ჰიგიენისტი',
    reception: 'რეცეფცია',
    lab: 'ლაბორატორია',
    patient2: 'პაციენტი',
    patients: 'პაციენტები',
    full: 'სრული',
    read: 'წაკითხვა',
    none: 'არცერთი',
    own: 'საკუთარი',
    billing: 'ანგარიშსწორება',
    scheduling: 'განრიგი',
    reports: 'ანგარიშები',
    settings: 'პარამეტრები',
    labOrders: 'ლაბორატორიული შეკვეთები',
    auditLog2: 'აუდიტის ჟურნალი',
    allTypes: 'ყველა ტიპი',
    last7Days: 'ბოლო 7 დღე',
    complianceDashboard: 'შესაბამისობის პანელი',
    complianceChecklist: 'შესაბამისობის ჩეკლისტი',
    pass: 'წარმატებული',
    dataEncryptedAtRest: 'მონაცემები დაშიფრულია მოსვენების რეჟიმში (AES-256)',
    dataEncryptedInTransit: 'მონაცემები დაშიფრულია ტრანზიტში (TLS 1.3)',
    mfaEnabledForAll: 'MFA ჩართულია ყველა ადმინისტრატორის ანგარიშისთვის',
    warn: 'გაფრთხილება',
    dataRetentionPolicyReview: 'მონაცემთა შენახვის პოლიტიკის მიმოხილვა 14 დღით ვადაგადაცილებულია',
    auditLoggingActiveOn: 'აუდიტის ლოგირება აქტიურია ყველა მოდულზე',
    multitenancyManagement: 'მულტი-ტენანტობის მართვა',
    singleSignonSso: 'ერთჯერადი შესვლა (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'ენტერპრაიზ იდენტობის პროვაიდერის ინტეგრაცია',
    configured: 'კონფიგურირებული',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 დაფუძნებული ავთენტიფიკაცია',
    available2: 'ხელმისაწვდომი',
    signInWithGoogle: 'შესვლა Google ორგანიზაციის ანგარიშებით',
    connected2: 'დაკავშირებული',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'ფუნქციის ფლაგები',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-ით რენტგენის ანალიზი და ანომალიების აღმოჩენა',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'ხმით აქტივირებული პერიოდონტოლოგიური ჩარტინგი',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'ახალი თაობის პაციენტის თვითმომსახურების პორტალი',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'მრავალენოვანი მხარდაჭერა (ქართული, ინგლისური, რუსული)',
    apiManagement2: 'API მართვა',
    requests24h: 'მოთხოვნები (24სთ)',
    avgLatency: 'საშ. შეყოვნება',
    uptime: 'მუშაობის დრო',
    apiKeys: 'API გასაღებები',
    dataManagement2: 'მონაცემთა მართვა',
    storageUsed: 'გამოყენებული საცავი',
    of100Gb: '100 GB-დან',
    totalRecords: 'ჯამური ჩანაწერები',
    lastBackup: 'ბოლო სარეზერვო ასლი',
    nextIn4h: 'შემდეგი: 4სთ-ში',
    dataOperations: 'მონაცემთა ოპერაციები',
    exportAllData: 'ყველა მონაცემის ექსპორტი',
    downloadCompleteDatabaseExport: 'სრული მონაცემთა ბაზის ექსპორტის ჩამოტვირთვა FHIR R4 ფორმატში',
    export: 'ექსპორტი',
    purgeOldRecords: 'ძველი ჩანაწერების წაშლა',
    removeRecordsPastRetention: 'შენახვის ვადაგასული ჩანაწერების წაშლა (7+ წელი)',
    purge: 'წაშლა',
    dataMigration: 'მონაცემთა მიგრაცია',
    importDataFromExternal: 'მონაცემთა იმპორტი გარე სისტემებიდან (CSV, HL7, FHIR)',
    import: 'იმპორტი',
    finance: 'ფინანსები',
    revenueInvoicesPayments: 'შემოსავალი, ინვოისები და გადახდები',
    exportReport: 'ანგარიშის ექსპორტი',
    monthlyRevenue: 'ყოველთვიური შემოსავალი',
    u20be12400: '\u20BE12,400',
    pending: 'მოლოდინში',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'ამ კვირაში',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'ყოველკვირეული შემოსავალი',
    mon2: 'ორშ',
    tue2: 'სამ',
    wed2: 'ოთხ',
    thu2: 'ხუთ',
    fri2: 'პარ',
    sat2: 'შაბ',
    invoice: 'ინვოისი',
    amount: 'თანხა',
    inv001: 'INV-001',
    giorgiBeridze: 'გიორგი ბერიძე',
    checkupXray: 'შემოწმება + რენტგენი',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'ნინო კაპანაძე',
    whitening: 'გათეთრება',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'დავით გელაშვილი',
    implantPhase1: 'იმპლანტის ფაზა 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'ანა ჯავახიშვილი',
    rootCanal: 'არხის მკურნალობა',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'კონფიგურაცია',
    apiKey: 'API გასაღები',
    endpointUrl: 'ბოლო წერტილის URL',
    protocol: 'პროტოკოლი',
    syncSettings: 'სინქრონიზაციის პარამეტრები',
    syncFrequency: 'სინქრონიზაციის სიხშირე',
    every5Minutes: 'ყოველ 5 წუთში',
    every15Minutes: 'ყოველ 15 წუთში',
    everyHour: 'ყოველ საათში',
    manualOnly: 'მხოლოდ ხელით',
    autosyncOnChanges: 'ავტო-სინქრონიზაცია ცვლილებებზე',
    lastSynced: 'ბოლო სინქრონიზაცია',
    disconnect: 'გათიშვა',
    testConnection: 'კავშირის ტესტირება',
    labCasePipeline: 'ლაბორატორიული შემთხვევების პაიპლაინი',
    labVendors2: 'ლაბორატორიის მომწოდებლები',
    tbilisidentLab: 'TbilisiDent ლაბორატორია',
    turnaround710Days: 'შესრულების ვადა: 7-10 დღე',
    rating485: 'რეიტინგი: 4.8/5',
    activeCases4: 'აქტიური შემთხვევები: 4',
    caucasusDentalLab: 'კავკასიის სტომატოლოგიური ლაბორატორია',
    turnaround57Days: 'შესრულების ვადა: 5-7 დღე',
    rating465: 'რეიტინგი: 4.6/5',
    activeCases2: 'აქტიური შემთხვევები: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'შესრულების ვადა: 10-14 დღე',
    rating445: 'რეიტინგი: 4.4/5',
    enterSpaceForClinics: 'კლინიკებისთვის შესვლა →',
    book: 'დაჯავშნა',
    followupConsultation: 'შემდგომი კონსულტაცია',
    postoperativeCheckAfterRoot: '#14-ზე არხის მკურნალობის შემდეგ პოსტოპერაციული შემოწმება. კარგად იხორცება, ინფექციის ნიშნები არ არის. გვირგვინის პრეპარაცია დაგეგმილია.',
    rootCanalTreatmentPhase: 'არხის მკურნალობა - ფაზა 2',
    completedObturationOnTooth: '#14 კბილზე ობტურაცია დასრულებულია. გუტაპერჩის შევსება, ლატერალური კონდენსაციის ტექნიკა. პოსტოპერაციულმა რენტგენმა ადეკვატური შევსება დაადასტურა.',
    periapicalXray: 'პერიაპიკალური რენტგენი',
    workingLengthRadiographFor: '#14 კბილის სამუშაო სიგრძის რენტგენოგრამა. არხის პრეპარაცია დადასტურდა 21მმ-ზე. პერიაპიკალური ცვლილებები არ აღინიშნა.',
    medicationPrescribedAmoxicilli: 'დანიშნული მედიკამენტი: ამოქსიცილინი 500მგ',
    prescribed7dayCourseOf: 'დანიშნულია 7-დღიანი კურსი ამოქსიცილინით პერიაპიკალური ინფექციისთვის. პაციენტს აცნობეს პენიცილინის ალერგიის შესახებ - ამოქსიცილინის ტოლერანტობა დადასტურდა კანის ტესტით.',
    diagnosisAcutePulpitis14: 'დიაგნოზი: მწვავე პულპიტი #14',
    patientPresentedWithSevere: 'პაციენტი წარმოდგენილია მძიმე სპონტანური ტკივილით ზედა მარჯვენა კვადრანტში. ცივი ტესტი დადებითი, პერკუსია მტკივნეული. დიაგნოსტირდა მწვავე შეუქცევადი პულპიტი.',
    compositeFillingTooth21: 'კომპოზიტური ბჟენი - კბილი #21',
    classIiCompositeRestoration: 'კლასი II კომპოზიტური რესტავრაცია #21-ზე. ფერი A2. რეზინის კოფერდამით იზოლაცია. ინკრემენტალური ფენების ტექნიკა. ოკლუზიური კორექცია დასრულებულია.',
    labResultsCbcPanel: 'ლაბორატორიული შედეგები: CBC პანელი',
    completeBloodCountWithin: 'სრული სისხლის ანალიზი ნორმის ფარგლებში. WBC 6.2, RBC 4.8, ჰემოგლობინი 14.2 გ/დლ, თრომბოციტები 245K. ნებადართულია ქირურგიული პროცედურებისთვის.',
    fullmouthRadiographs: 'სრულ-პირის რენტგენოგრამები',
    panoramicOpgAndFull: 'პანორამული OPG და სრული პერიაპიკალური სერია დასრულებულია. აღმოჩენები: პერიაპიკალური რადიოლუცენტობა #14-ზე, ადრეული კარიესის ლეზია #21-ზე, გენერალიზებული მსუბუქი ძვლის დაკარგვა.',
    comprehensiveExamination: 'ყოვლისმომცველი გამოკვლევა',
    initialComprehensiveExamFull: 'საწყისი ყოვლისმომცველი გამოკვლევა. სრული პერიოდონტოლოგიური ჩარტინგი დასრულებულია. BPE ქულები: 2,2,3,2,3,2. მკურნალობის გეგმა განხილულია და თანხმობა მიღებულია. წნევა ჩაწერილია 128/82.',
    medicationUpdateLisinopril10mg: 'მედიკამენტის განახლება: ლიზინოპრილი 10მგ',
    patientReportedCurrentMedicati: 'პაციენტმა აღნიშნა მიმდინარე მედიკამენტი: ლიზინოპრილი 10მგ ყოველდღიურად ჰიპერტენზიისთვის. სხვა მედიკამენტები არ არის. ოჯახის ექიმი: დოქტ. მაისურაძე, თბილისის სამედიცინო ცენტრი.',
    patientRegistration: 'პაციენტის რეგისტრაცია',
    newPatientRegistrationMedical: 'ახალი პაციენტის რეგისტრაცია. სამედიცინო ისტორიის კითხვარი შევსებულია. ალერგიები დოკუმენტირებულია: პენიცილინი (მძიმე), ლატექსი (ზომიერი), ლიდოკაინი (მსუბუქი). დაზღვევა: GPI Health.',
    activeConditions: 'აქტიური მდგომარეობები',
    chronicPeriodontitis: 'ქრონიკული პერიოდონტიტი',
    active: 'აქტიური',
    generalizedMildChronicPeriodon: 'გენერალიზებული მსუბუქი ქრონიკული პერიოდონტიტი ლოკალიზებული ზომიერი ჩართულობით. BPE ქულები მიუთითებს პერიოდონტოლოგიური მართვის საჭიროებაზე.',
    onsetJan2026: 'დაწყება: იან 2026',
    dentalCaries: 'სტომატოლოგიური კარიესი',
    resolved: 'მოგვარებული',
    cariousLesionOnTooth: 'კარიესის ლეზია კბილზე #21, მეზიო-ოკლუზიური ზედაპირი. ნამკურნალები კომპოზიტური რესტავრაციით 2026 წლის 15 თებერვალს.',
    resolvedFeb2026: 'მოგვარებული: თებ 2026',
    bruxism: 'ბრუქსიზმი',
    nocturnalBruxismWearFacets: 'ღამის ბრუქსიზმი. ცვეთის ფასეტები აღინიშნა წინა კბილებზე. ღამის კაპა რეკომენდებულია, მაგრამ პაციენტს ჯერ არ დაუწყია გამოყენება.',
    activeMedications: 'აქტიური მედიკამენტები',
    lisinopril10mg: 'ლიზინოპრილი 10მგ',
    onceDailyOral: 'დღეში ერთხელ, პერორალურად',
    hypertensionManagement: 'ჰიპერტენზიის მართვა',
    chlorhexidine012Rinse: 'ქლორჰექსიდინი 0.12% ხსნარი',
    twiceDailyOralRinse: 'დღეში ორჯერ, პირის ღრუს ხსნარი',
    periodontalMaintenance: 'პერიოდონტოლოგიური მოვლა',
    ibuprofen400mg: 'იბუპროფენი 400მგ',
    asNeededForPain: 'საჭიროებისამებრ ტკივილისთვის, მაქს. 3-ჯერ დღეში',
    postprocedurePainManagement: 'პროცედურის შემდგომი ტკივილის მართვა',
    pastMedications: 'წარსული მედიკამენტები',
    amoxicillin500mg: 'ამოქსიცილინი 500მგ',
    periapicalInfectionProphylaxis: 'პერიაპიკალური ინფექციის პროფილაქტიკა',
    completed2: 'დასრულებული',
    metronidazole250mg: 'მეტრონიდაზოლი 250მგ',
    adjunctPeriodontalTherapy: 'დამხმარე პერიოდონტოლოგიური თერაპია',
    paracetamol500mg: 'პარაცეტამოლი 500მგ',
    asNeededFeb1518: 'საჭიროებისამებრ (თებ 15-18, 2026)',
    postfillingSensitivity: 'ბჟენის შემდგომი მგრძნობელობა',
    diclofenac50mg: 'დიკლოფენაკი 50მგ',
    twiceDailyFor3: 'დღეში ორჯერ, 3 დღე (იან 22-24, 2026)',
    postexamSoreness: 'გამოკვლევის შემდგომი მტკივნეულობა',
    documentedAllergies: 'დოკუმენტირებული ალერგიები',
    penicillin: 'პენიცილინი',
    severe: 'მძიმე',
    reactionAnaphylaxisUrticariaAn: 'რეაქცია: ანაფილაქსია, ურტიკარია, ანგიოედემა',
    crossreactivityWithCephalospor: 'ცეფალოსპორინებთან ჯვარედინი რეაქტივობა შესაძლებელია. ამოქსიცილინის ტოლერანტობა დადასტურებულია ზედამხედველობის ქვეშ ჩატარებული კანის ტესტით. დააფიქსირეთ ყველა სარეფერალო წერილში.',
    documentedJan102026: 'დოკუმენტირებულია: 2026 წლის 10 იანვარი',
    latex: 'ლატექსი',
    moderate: 'ზომიერი',
    reactionContactDermatitisLocal: 'რეაქცია: საკონტაქტო დერმატიტი, ლოკალიზებული შეშუპება',
    useNitrileGlovesOnly: 'გამოიყენეთ მხოლოდ ნიტრილის ხელთათმანები. ლატექსისგან თავისუფალი გარემო საჭიროა ყველა პროცედურისთვის. თვალსაჩინოდ მიუთითეთ ვიზიტის ჩანაწერებში.',
    lidocaine: 'ლიდოკაინი',
    mild: 'მსუბუქი',
    reactionMildTinglingProlonged: 'რეაქცია: მსუბუქი ჩხვლეტა, მოსალოდნელ ვადაზე მეტი დაბუჟება',
    useArticaineAsAlternative: 'გამოიყენეთ არტიკაინი როგორც ალტერნატიული ადგილობრივი ანესთეტიკი. პაციენტი კარგად იტანს მეპივაკაინს. დააკვირდით არაჩვეულებრივ რეაქციებს.',
    latestVitalsMar15: 'უახლესი სასიცოცხლო მაჩვენებლები — 2026 წლის 15 მარტი',
    labResults2: 'ლაბორატორიული შედეგები',
    test: 'ტესტი',
    result: 'შედეგი',
    reference: 'საცნობარო',
    date: 'თარიღი',
    hemoglobin: 'ჰემოგლობინი',
    platelets: 'თრომბოციტები',
    glucoseFasting: 'გლუკოზა (უზმოზე)',
    immunizationRecords: 'იმუნიზაციის ჩანაწერები',
    hepatitisB: 'ჰეპატიტი B',
    completed3doseSeries2019: 'დასრულებული: 3-დოზიანი სერია, 2019',
    upToDate: 'განახლებული',
    tetanusdiphtheriaTd: 'ტეტანუსი/დიფთერია (Td)',
    lastBooster2022: 'ბოლო ბუსტერი: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'ბოლო დოზა: სექ 2024',
    dueForBooster: 'ბუსტერის დრო დგება',
    familyMedicalHistory: 'ოჯახის სამედიცინო ისტორია',
    father: 'მამა',
    hypertensionType2Diabetes: 'ჰიპერტენზია, ტიპი 2 დიაბეტი, პერიოდონტოლოგიური დაავადება',
    mother: 'დედა',
    osteoporosisDrugAllergySulfona: 'ოსტეოპოროზი, წამლის ალერგია (სულფონამიდები)',
    sibling: 'და-ძმა',
    bruxismDentalAnxiety: 'ბრუქსიზმი, სტომატოლოგიური შფოთვა',
    imagingRecords: 'გამოსახულებების ჩანაწერები',
    panoramicOpg: 'პანორამული OPG',
    periapical14: 'პერიაპიკალური #14',
    bitewingRl: 'ბიტვინგი R+L',
    patientDocuments: 'პაციენტის დოკუმენტები',
    consentFormRootCanal: 'თანხმობის ფორმა - არხის მკურნალობა',
    treatmentPlanAgreement: 'მკურნალობის გეგმის შეთანხმება',
    medicalHistoryQuestionnaire: 'სამედიცინო ისტორიის კითხვარი',
    insuranceAuthorizationGpi: 'სადაზღვევო ავტორიზაცია - GPI',
    insuranceInformation: 'სადაზღვევო ინფორმაცია',
    provider: 'პროვაიდერი:',
    policy: 'პოლისი #:',
    group: 'ჯგუფი:',
    corporatePlanPremium: 'კორპორატიული გეგმა - პრემიუმ',
    coverage: 'დაფარვა:',
    deductible: 'თანაგადახდა:',
    annualMax2: 'წლიური მაქსიმუმი:',
    valid: 'მოქმედი:',
    age34: 'ასაკი: 34',
    lastVisitMar10: 'ბოლო ვიზიტი: მარ 10',
    nextMar19: 'შემდეგი: მარ 19',
    overview: 'მიმოხილვა',
    dentalChart: 'სტომატოლოგიური რუკა',
    treatmentPlan: 'მკურნალობის გეგმა',
    history: 'ისტორია',
    documents2: 'დოკუმენტები',
    allergies2: 'ალერგიები',
    medicalNotes: 'სამედიცინო ჩანაწერები',
    insurance3: 'დაზღვევა',
    upperArch: 'ზედა რკალი',
    lowerArch: 'ქვედა რკალი',
    tooth: 'კბილი',
    procedure2: 'პროცედურა',
    price: 'ფასი',
    rootCanalTreatment: 'არხის მკურნალობა',
    ceramicCrown: 'კერამიკული გვირგვინი',
    compositeFilling: 'კომპოზიტური ბჟენი',
    implantPlacement: 'იმპლანტის ჩადგმა',
    total: 'ჯამი',
    addProcedure2: '+ პროცედურის დამატება',
    march102026: '2026 წლის 10 მარტი',
    periapicalXrayRootCanal: 'პერიაპიკალური რენტგენი, არხის მკურნალობა დაწყებულია #14-ზე. სამუშაო სიგრძე განსაზღვრულია. კალციუმის ჰიდროქსიდის სამკურნალო საფარი განთავსებულია.',
    february152026: '2026 წლის 15 თებერვალი',
    compositeFillingOn21: 'კომპოზიტური ბჟენი #21-ზე. ფერი A2. ოკლუზიური კორექცია შესრულებულია. პაციენტმა პროცედურა კარგად ატარა.',
    january202026: '2026 წლის 20 იანვარი',
    comprehensiveExaminationFullmo: 'ყოვლისმომცველი გამოკვლევა. სრულ-პირის პერიაპიკალური რენტგენოგრამები. მკურნალობის გეგმა პაციენტთან განხილულია. თანხმობის ფორმები ხელმოწერილია.',
    bitewingRight: 'ბიტვინგი მარჯვენა',
    bitewingLeft: 'ბიტვინგი მარცხენა',
    uploadDocument: '+ დოკუმენტის ატვირთვა',
    all: 'ყველა',
    new: 'ახალი',
    phone2: 'ტელეფონი',
    lastVisit: 'ბოლო ვიზიტი',
    nextAppt: 'შემდეგი ვიზიტი',
    balance: 'ბალანსი',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'მარიამ ციკლაური',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'ლუკა მჭედლიშვილი',
    pt006: 'PT-006',
    tamtaLomidze: 'თამთა ლომიძე',
    pt007: 'PT-007',
    periodontalChart: 'პერიოდონტოლოგიური ჩარტი',
    newExam2: '+ ახალი გამოკვლევა',
    voiceEntry2: 'ხმოვანი შეყვანა',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'სტომატოლოგიური ჯავშნისა და ოპერაციების პლატფორმა',
    theMissingInfrastructureFor: 'საქართველოს სტომატოლოგიური კლინიკებისთვის აკლიანი ინფრასტრუქტურა',
    manage: 'მართვა',
    grow: 'ზრდა',
    marketSize: 'ბაზრის ზომა',
    dentalClinicsInGeorgia: 'სტომატოლოგიური კლინიკა საქართველოში',
    inTbilisiAlone: 'მხოლოდ თბილისში',
    unifiedBookingOrOps: 'ერთიანი ჯავშნის ან ოპერაციის პლატფორმა',
    dentosgeIsTheOnly: '⚠️  dentos.ge ერთადერთი ნაწილობრივი კონკურენტია — სრული ოპერაციული ფენა არ არსებობს',
    theProblem2: 'პრობლემა',
    str511: '📋',
    clinicsRunOnExcel: 'კლინიკები მუშაობენ Excel + WhatsApp + ქაღალდით',
    noStructuredWorkflowConstant: 'სტრუქტურირებული სამუშაო პროცესი არ არის, მუდმივი ადამიანური შეცდომა',
    str514: '📉',
    noshowsCost1525Of: 'გაცდენები შემოსავლის 15–25%-ს შეადგენს',
    noAutomatedRemindersOr: 'ავტომატური შეხსენებები ან დადასტურების სისტემა არ არის',
    str517: '🏦',
    insuranceBillingIsManual: 'სადაზღვევო ანგარიშსწორება ხელითაა და მტკივნეული',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'სტომატოლოგიური ტურიზმის პაციენტები განსაკუთრებით ელიან ციფრულ ჯავშანს',
    theSolution: 'გამოსავალი',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'ონლაინ ჯავშნის ვიჯეტი + მარკეტფლეისი',
    patientsBook247From: 'პაციენტები ჯავშნიან 24/7 ნებისმიერი მოწყობილობიდან',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'პაციენტის ჩანაწერები და მკურნალობის მართვა',
    fullHistoryTreatmentPlans: 'სრული ისტორია, მკურნალობის გეგმები, ელ-დოკუმენტები',
    str529: '🏥',
    insuranceIntegrations: 'სადაზღვევო ინტეგრაციები',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp შეხსენებები',
    cutNoshowsByUp: 'გაცდენების 40%-მდე შემცირება',
    str534: '📊',
    financialReportingDashboard: 'ფინანსური ანგარიშგების პანელი',
    revenueSalariesExpensesRealtim: 'შემოსავალი, ხელფასები, ხარჯები — რეალურ დროში',
    willingnessToPay: 'გადახდის მზაობა',
    free: 'უფასო',
    month: '/თვეში',
    listingBookingWidget: 'ლისტინგი + ჯავშნის ვიჯეტი',
    growth: 'ზრდა',
    calendarRemindersPatientCards: 'კალენდარი + შეხსენებები + პაციენტის ბარათები',
    pro: 'პრო',
    fullOpsInsuranceAnalytics: 'სრული ოპერაციები + დაზღვევა + ანალიტიკა',
    multibranchApiAccessReporting: 'მრავალფილიალი + API წვდომა + ანგარიშგება',
    wtp0515OfMonthly: '💡 WTP: ყოველთვიური შემოსავლის 0.5–1.5% — ₾15K–50K/თვეში შემოსავლის მქონე კლინიკები ₾100–350/თვეში კომფორტულად იხდიან',
    marketOpportunity: 'ბაზრის შესაძლებლობა',
    addressableClinicsAtLaunch: 'მისაწვდომი კლინიკები გაშვებისას',
    mrrAtFullPenetration: 'MRR სრული პენეტრაციისას (₾49 საშ.)',
    initialMrrCeilingUsd: 'საწყისი MRR ჭერი (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  შემდეგი გაფართოება: სომხეთი → აზერბაიჯანი → ფართო კავკასიის სტომატოლოგიური ბაზარი',
    whyNow: 'რატომ ახლა',
    str561: '✈️',
    dentalTourismBoom: 'სტომატოლოგიური ტურიზმის ბუმი',
    internationalPatientsNeedEngli: 'საერთაშორისო პაციენტებს სჭირდებათ ინგლისურენოვანი ონლაინ ჯავშანი ახლავე',
    str564: '📱',
    postcovidDigitizationPressure: 'პოსტ-COVID ციფრიზაციის ზეწოლა',
    clinicsThatSurvivedAre: 'გადარჩენილი კლინიკები მზად არიან ტექნოლოგიაში ინვესტირებისთვის',
    str567: '🏆',
    noStrongLocalIncumbent: 'ძლიერი ადგილობრივი კონკურენტი არ არის',
    dentosgeOnlyCoversDiscovery: 'dentos.ge მხოლოდ აღმოჩენას ფარავს — სრული ოპერაციული პლატფორმა არ არსებობს',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'საქართველო ჯანდაცვის ჰაბია კავკასიაში',
    lowCostHighQuality: 'დაბალი ღირებულება, მაღალი ხარისხი — დასავლეთ ევროპაზე 50–70%-ით იაფი',
    joinThePartnerClinic: 'შეუერთდით პარტნიორი კლინიკის პროგრამას — პირველი 3 თვე უფასო',
    builtForGeorgianClinics: '🦷 შექმნილია ქართული კლინიკებისთვის, ადამიანების მიერ, რომლებიც აქ ცხოვრობენ',
    prev: '← წინა',
    next2: 'შემდეგი →',
    getInTouch: '🦷 დაგვიკავშირდით',
    activePrescriptions: 'აქტიური რეცეპტები',
    pastPrescriptions: 'წარსული რეცეპტები',
    prescriptionTemplates: 'რეცეპტის შაბლონები',
    drugInteractionChecker: 'წამლების ურთიერთქმედების შემმოწმებელი',
    referrals: 'რეფერალები',
    newReferral: '+ ახალი რეფერალი',
    inbound2: 'შემომავალი',
    outbound2: 'გამავალი',
    reportsAnalytics: 'ანგარიშები და ანალიტიკა',
    productionByProvider: 'წარმოება პროვაიდერის მიხედვით',
    productionByCategory: 'წარმოება კატეგორიის მიხედვით',
    preventive2: 'პრევენციული',
    restorative: 'რესტავრაციული',
    endodontics: 'ენდოდონტია',
    periodontics: 'პერიოდონტოლოგია',
    prosthodontics: 'პროთეზირება',
    surgery: 'ქირურგია',
    agingReport: 'დავალიანების ანგარიში',
    appointmentsByDay: 'ვიზიტები დღის მიხედვით',
    monday: 'ორშაბათი',
    tuesday: 'სამშაბათი',
    wednesday: 'ოთხშაბათი',
    thursday: 'ხუთშაბათი',
    friday: 'პარასკევი',
    saturday: 'შაბათი',
    topDeclinedTreatments: 'ყველაზე უარყოფილი მკურნალობები',
    costConcerns: 'ღირებულების შეშფოთება',
    wantsToWait: 'სურს ლოდინი',
    orthodontics: 'ორთოდონტია',
    insuranceNotCovering: 'დაზღვევა არ ფარავს',
    notAPriority: 'არ არის პრიორიტეტი',
    seekingSecondOpinion: 'მეორე აზრის ძიება',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'ყველა პროვაიდერი',
    hygienistNino: 'ჰიგიენისტი ნინო',
    mon17: 'ორშ 17',
    tue18: 'სამ 18',
    wed19: 'ოთხ 19',
    thu20: 'ხუთ 20',
    fri21: 'პარ 21',
    crownPrep14: 'გვირგვინის პრეპ #14',
    tKapanadze: 'თ. კაპანაძე',
    srpQuad1: 'SRP კვადრანტი 1',
    dGelashvili: 'დ. გელაშვილი',
    examXray: 'გამოკვლევა + რენტგენი',
    mTsiklauri: 'მ. ციკლაური',
    unconfirmed: 'დაუდასტურებელი',
    rct36: 'არხის მკურნალობა #36',
    gBeridze: 'გ. ბერიძე',
    prophyPolish: 'პროფილაქტიკა + პოლირება',
    iDiasamidze: 'ი. დიასამიძე',
    perioMaintenance: 'პერიოდონტოლოგიური მოვლა',
    tLomidze: 'თ. ლომიძე',
    prophy: 'პროფილაქტიკა',
    aJavakhishvili: 'ა. ჯავახიშვილი',
    inChair: 'სავარძელში',
    sealantsX4: 'სილანტები x4',
    nKapanadze: 'ნ. კაპანაძე',
    lMchedlishvili: 'ლ. მჭედლიშვილი',
    u2014LunchU2014: '\u2014 შესვენება \u2014',
    veneerPrep11: 'ვინირის პრეპ #11',
    kGabrichidze: 'კ. გაბრიჩიძე',
    composite25: 'კომპოზიტი #25',
    sMeladze: 'ს. მელაძე',
    bridgePrep3436: 'ხიდის პრეპ #34-36',
    rKharazishvili: 'რ. ხარაზიშვილი',
    composite22: 'კომპოზიტი #22',
    zDolidze: 'ზ. დოლიძე',
    noShow: 'გაცდენა',
    extraction48: 'ამოღება #48',
    vPapunashvili: 'ვ. პაპუნაშვილი',
    implantConsult: 'იმპლანტის კონსულტაცია',
    eTsereteli: 'ე. წერეთელი',
    nGogiberidze: 'ნ. გოგიბერიძე',
    crownSeat14: 'გვირგვინის დადგმა #14',
    checkup: 'შემოწმება',
    bShengelia: 'ბ. შენგელია',
    fluorideTreatment: 'ფტორით მკურნალობა',
    emergencyWalkin: 'გადაუდებელი მიმართვა',
    scaling: 'სკეილინგი',
    wantsMonwedAmSlot: 'სურს ორშ/ოთხ დილის სლოტი \u2022 გათეთრება',
    assignToSchedule: 'განრიგში მინიჭება',
    autoAssign: 'ავტო-მინიჭება',
    high: 'მაღალი',
    anyMorningSlotU2022: 'ნებისმიერი დილის სლოტი \u2022 იმპლანტის შემდგომი ვიზიტი',
    medium: 'საშუალო',
    irakliDiasamidze: 'ირაკლი დიასამიძე',
    friPmPreferredU2022: 'პარ შუადღე სასურველია \u2022 შემოწმება',
    low: 'დაბალი',
    planARecommended: 'გეგმა A: რეკომენდებული',
    planBConservative: 'გეგმა B: კონსერვატიული',
    newPlan2: '+ ახალი გეგმა',
    conservativeApproach: 'კონსერვატიული მიდგომა',
    thisPlanPrioritizesDisease: 'ეს გეგმა პრიორიტეტს ანიჭებს დაავადების კონტროლსა და მონიტორინგს ძირითადი რესტავრაციული სამუშაოს დაწყებამდე. იმპლანტის ჩადგმა გადადებულია პერიოდონტოლოგიური ხელახალი შეფასების მოლოდინში.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'მკურნალობის გეგმის შედარება',
    u00b72: '\u00b7',
    exams2: 'გამოკვლევები:',
    metric: 'მეტრიკა',
    pdMm: 'PD (მმ)',
    gmMm: 'GM (მმ)',
    calMm: 'CAL (მმ)',
    suppuration: 'სუპურაცია',
    furcation: 'ფურკაცია',
    mobility: 'მობილობა',
    qty: 'რაოდენობა',
    refills: 'განმეორებითი შევსება',
    goal: 'მიზანი',
    current2: 'მიმდინარე',
    totalDue: 'ჯამური დავალიანება',
    scheduled2: 'დაგეგმილი',
    overdue2: 'ვადაგადაცილებული',
    reactivation: 'რეაქტივაცია',
    chiefComplaint: 'მთავარი ჩივილი',
    painScale: 'ტკივილის შკალა:',
    clinicalFindings: 'კლინიკური აღმოჩენები',
    diagnosis: 'დიაგნოზი',
    prescriptions: 'რეცეპტები',
    u201c: '\u201C',
    xray: 'რენტგენი',
    cleaning: 'პროფესიონალური წმენდა',

    // Booking Extended
    bookByClinic: 'კლინიკით ჯავშანი',
    bookByDoctor: 'ექიმით ჯავშანი',
    bookAtClinic: 'დაჯავშნეთ აქ',
    chooseDoctor: 'აირჩიეთ ექიმი',
    availableAtClinics: 'ხელმისაწვდომია კლინიკებში',
    specialOffer: 'სპეციალური შეთავაზება',
    specialOfferAvailable: 'სპეციალური შეთავაზება ხელმისაწვდომია',
    viewDetails: 'დეტალების ნახვა',

    // Chart & Clinical Extended
    chartLegend: 'ჩარტის ლეგენდა',
    chairSideMode: 'სავარძლის რეჟიმი',
    adminMode: 'ადმინისტრატორის რეჟიმი',
    braces: 'ბრეკეტები',
    procedureTimeline: 'პროცედურების ქრონოლოგია',
    proceduresAcrossPhases: '{0} პროცედურა {1} ფაზაში',
    untitled: 'უსათაურო',
    noHistory: 'პროცედურები არ არის ჩაწერილი',

    // Informed Consent
    informedConsent: 'ინფორმირებული თანხმობა',
    informedConsentTitle: 'ინფორმირებული თანხმობის ფორმა',
    newConsent: 'ახალი თანხმობა',
    consentHistory: 'თანხმობის ისტორია',
    consentProcedureTitle: 'პროცედურის აღწერა',
    consentProcedureDesc: 'თქვენმა სტომატოლოგმა რეკომენდაცია გაუწია შემდეგ პროცედურას. ეს სექცია აღწერს დაგეგმილი მკურნალობის ბუნებას, მიზანს და მოსალოდნელ ეტაპებს. გთხოვთ, ყურადღებით წაიკითხოთ დადასტურებამდე.',
    consentRisksTitle: 'რისკები და გართულებები',
    consentRisksDesc: 'როგორც ნებისმიერ სამედიცინო ან სტომატოლოგიურ პროცედურაში, არსებობს პოტენციური რისკები, მათ შორის, მაგრამ არა მხოლოდ, ინფექცია, სისხლდენა, ნერვის დაზიანება, მასალების ან ანესთეზიის მიმართ ალერგიული რეაქცია და მკურნალობის სასურველი შედეგის მიუღწევლობის შესაძლებლობა.',
    consentAlternativesTitle: 'ალტერნატიული მკურნალობა',
    consentAlternativesDesc: 'ალტერნატიული მკურნალობის ვარიანტები შეიძლება მოიცავდეს მკურნალობაზე უარის თქმას, გადადებულ მკურნალობას ან სხვა პროცედურებს. თითოეულ ალტერნატივას აქვს საკუთარი სარგებელი და რისკები. თქვენს სტომატოლოგს შეუძლია დეტალურად განიხილოს ეს ვარიანტები.',
    consentOutcomesTitle: 'მოსალოდნელი შედეგები',
    consentOutcomesDesc: 'ამ პროცედურის მოსალოდნელი შედეგია სტომატოლოგიური ჯანმრთელობის, ფუნქციის და/ან ესთეტიკის აღდგენა. ინდივიდუალური შედეგები შეიძლება განსხვავდებოდეს შემთხვევის სირთულის, პაციენტის თანამშრომლობისა და სხვა ჯანმრთელობის ფაქტორების მიხედვით.',
    consentAftercareTitle: 'პროცედურის შემდგომი მოვლის ინსტრუქციები',
    consentAftercareDesc: 'პროცედურის შემდეგ თქვენ მიიღებთ სპეციფიკურ მოვლის ინსტრუქციებს. ეს შეიძლება მოიცავდეს დიეტურ შეზღუდვებს, მედიკამენტების მიღების განრიგს, აქტივობის შეზღუდვებს და შემდგომი ვიზიტის მოთხოვნებს. ამ ინსტრუქციების დაცვა აუცილებელია ოპტიმალური შეხორცებისთვის.',
    consentAcknowledge: 'ვეთანხმები და ვადასტურებ',
    consentCheckAllFirst: 'გთხოვთ, დაადასტურეთ ყველა ზემოთ მოცემული სექცია ხელმოწერამდე',

    // E-Signature
    eSignatureTitle: 'ელექტრონული ხელმოწერა',
    clearSignature: 'ხელმოწერის გასუფთავება',
    confirmSignature: 'ხელმოწერის დადასტურება',
    awaitingSignature: 'ხელმოწერის მოლოდინში',
    signatureCapturedAt: 'ხელმოწერა დაფიქსირებულია',
    signed: 'ხელმოწერილი',
    amountPaid: 'თანხა გადახდილი',
    annotate: 'ანოტაცია',
    anonymousPatient: 'Anonymous პაციენტი',
    autoImport: 'Auto იმპორტი',
    away: 'გასული',
    bankTransfer: 'Bank გადარიცხვა',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'დაშლა',
    bridgePrep: 'Bridge Prep',
    brightness: 'სიკაშკაშე',
    cabinet: 'კაბინეტი',
    cabinet1: 'კაბინეტი 1',
    cabinet2: 'კაბინეტი 2',
    cabinetSchedule: 'კაბინეტი განრიგი',
    cabinetScheduleDesc: 'კაბინეტი განრიგი Desc',
    card: 'ბარათი',
    cash: 'ნაღდი',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical კითხვა',
    clinicAvgRating: 'Clinic Avg შეფასება',
    collapse: 'აკეცვა',
    completedToday: 'დასრულებული დღეს',
    compositeF: 'Composite F',
    continueToScheduling: 'გაგრძელება To Scheduling',
    contrast: 'კონტრასტი',
    ctScans: 'Ct Scans',
    customAmount: 'სხვა თანხა',
    days: 'დღე',
    delivered: 'Delivered',
    directMessages: 'პირდაპირი Messages',
    disposables: 'Disposables',
    doctorResponse: 'ექიმი პასუხი',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'დოკუმენტი Mgmt Subtitle',
    documentPreview: 'დოკუმენტი გადახედვა',
    download: 'ჩამოტვირთვა',
    endodontic: 'ენდოდონტიური',
    enterAmount: 'შეიყვანეთ თანხა',
    equipmentDevices: 'აღჭურვილობა Devices',
    estDelivery: 'Est მიწოდება',
    examConsult: 'Exam Consult',
    explanationQuality: 'ახსნა ხარისხი',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth ხედი',
    hasBracesQuestion: 'Has Braces კითხვა',
    hasConsultationQuestion: 'Has Consultation კითხვა',
    hasCtScanQuestion: 'Has Ct სკანირება კითხვა',
    hasRecentXrayQuestion: 'Has ბოლო Xray კითხვა',
    helpfulQuestion: 'სასარგებლო კითხვა',
    highest: 'უმაღლესი',
    hygiene: 'ჰიგიენა',
    imagingType: 'ვიზუალიზაცია Type',
    implantPlace: 'Implant შეკვეთა',
    important: 'მნიშვნელოვანი',
    importLatest: 'იმპორტი Latest',
    inProgress: 'In პროგრესი',
    installment: 'განვადება',
    insuranceCoverage: 'დაზღვევა დაფარვა',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning კითხვა',
    lateralSkullView: 'Lateral Skull ხედი',
    lowest: 'უდაბლესი',
    lowStock: 'დაბალი მარაგი',
    lowStockAlerts: 'დაბალი მარაგი გაფრთხილებები',
    maintenance: 'მოვლა',
    management: 'მართვა',
    markComplete: 'მონიშვნა სრული',
    material: 'მასალა',
    method: 'მეთოდი',
    minOrder: 'Min შეკვეთა',
    monthlySpend: 'თვიური ხარჯი',
    newPayment: 'New გადახდა',
    newRadiologyReferral: 'New Radiology რეფერალი',
    nextAppointment: 'Next ვიზიტი',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'ნორმალური',
    noteInterpreter: 'Note Interpreter',
    occupied: 'დაკავებული',
    online: 'ონლაინ',
    orderNow: 'შეკვეთა Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'დარჩენილი',
    painManagement: 'Pain მართვა',
    panoramic: 'პანორამული',
    patientDue: 'პაციენტი გადასახდელი',
    paymentHistory: 'გადახდა ისტორია',
    paymentMethod: 'გადახდა მეთოდი',
    pendingOrders: 'მოლოდინში Orders',
    periapical: 'პერიაპიკალური',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'შეკვეთა შეკვეთა',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'ბეჭდვა',
    processing: 'Processing',
    processPayment: 'დამუშავება გადახდა',
    processPaymentBtn: 'დამუშავება გადახდა Btn',
    professionalism: 'პროფესიონალიზმი',
    prophyClean: 'Prophy Clean',
    prosthetic: 'პროთეზირება',
    punctuality: 'პუნქტუალურობა',
    qtyUsed: 'Qty Used',
    quantity: 'რაოდენობა',
    queue: 'რიგი',
    receiptPreview: 'ქვითარი გადახედვა',
    recent: 'ბოლო',
    recentMaterialUsage: 'ბოლო მასალა Usage',
    recentReceipts: 'ბოლო Receipts',
    reliability: 'საიმედოობა',
    remainingBalance: 'Remaining ბალანსი',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth ხედი',
    slotDetails: 'Slot Details',
    sortBy: 'სორტირება By',
    srpQuad: 'Srp Quad',
    startImaging: 'დაწყება ვიზუალიზაცია',
    stock: 'მარაგი',
    stockLevel: 'მარაგი Level',
    submitReferral: 'გაგზავნა რეფერალი',
    subtotal: 'ქვეჯამი',
    suppliers: 'Suppliers',
    surgical: 'ქირურგიული',
    targetArea: 'Target Area',
    teamChat: 'გუნდი ჩატი',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D ვიზუალიზაცია',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A შეტყობინება',
    unavailable: 'Unavailable',
    unit: 'ერთეული',
    urgency: 'Urgency',
    urgent: 'გადაუდებელი',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'ხედი On Google',
    xrays: 'Xrays'
  },

  ru: {
    home: 'Главная',
    features: 'Функции',
    pricing: 'Цены',
    clinicsNav: 'Клиники',
    aiAssistant: 'ИИ Ассистент',
    forBusiness: 'Для бизнеса',
    dashboard: 'Панель',
    getStarted: 'Начать',
    tryDemo: 'Попробовать демо',
    viewPitch: 'Презентация',
    heroTagline: 'Стоматологическая платформа для Грузии',
    heroTitle: 'Все стоматологические клиники',
    heroSubtitle: 'Ваш AI-ассистент для поиска лучшей стоматологической помощи в Грузии',
    searchPlaceholder: 'Поиск клиник, услуг или задайте вопрос...',
    chipImplant: 'Лучшие клиники имплантации в Тбилиси',
    chipWhitening: 'Отбеливание зубов рядом',
    chipEmergency: 'Экстренная стоматологическая помощь',
    chipOrtho: 'Ортодонтия для взрослых',
    scrollExplore: 'Прокрутите для просмотра',
    topRated: 'Лучшие стоматологические клиники Тбилиси',
    viewAllClinics: 'Все клиники',
    shareLocation: 'Поделиться локацией для поиска ближайших клиник',
    locationShared: 'Локация получена — показываем ближайшие',
    statClinics: 'Клиники',
    statNoShows: 'Меньше неявок',
    statBooking: 'Онлайн запись',
    statDentists: 'Стоматологи',
    statRating: 'Средний рейтинг',
    statPatients: 'Пациенты',
    findClinics: 'Найти лучшие клиники',
    forBusinessBtn: 'Для бизнеса',
    ownClinic: 'У вас есть стоматологическая клиника?',
    claimText: 'Зарегистрируйте свою клинику или добавьте её в нашу базу данных.',
    getListed: 'Зарегистрироваться →',
    clinicsTitle: 'Стоматологические клиники в Грузии',
    verifiedClinics: 'проверенных клиник с рейтингами и отзывами',
    searchByName: 'Поиск по названию, району или услуге...',
    hideMap: 'Скрыть карту',
    showMap: 'Карта',
    nearMe: 'Рядом',
    clinicsMatch: 'клиник совпадает',
    reviews: 'отзывов',
    loadingMore: 'Загрузка...',
    callClinic: 'Позвонить',
    bookAppointment: 'Записаться',
    services: 'Услуги',
    workingHours: 'Часы работы',
    priceRange: 'Диапазон цен',
    location: 'Расположение',
    visitWebsite: 'Перейти на сайт',
    bookingTitle: 'Запись на приём',
    step: 'Шаг',
    selectClinic: 'Выберите клинику',
    selectService: 'Выберите услугу',
    selectDate: 'Выберите дату',
    selectTime: 'Выберите время',
    confirm: 'Подтвердить',
    next: 'Далее',
    back: 'Назад',
    clinicsAvailable: 'клиник доступно',
    clinicsFound: 'клиник найдено',
    confirmBooking: 'Подтвердить запись',
    bookingConfirmed: 'Ваш визит забронирован!',
    patientName: 'Имя пациента',
    phoneNumber: 'Номер телефона',
    email: 'Электронная почта',
    notes: 'Примечания (необязательно)',
    businessHeroBadge: '15+ Модулей  ·  212+ Клиник  ·  Gemini AI',
    businessHeroTitle: 'Операционная система для стоматологических клиник',
    businessHeroSubtitle: 'Клиническое картирование, пародонтологический анализ, планирование лечения, расписание, биллинг, электронные рецепты, управление лабораторией и ИИ-диагностика — всё в одной платформе для Грузии.',
    theProblem: 'Проблема',
    problemSubtitle: 'Грузинские стоматологические клиники ежедневно теряют доход из-за фрагментированных инструментов',
    excelChaos: 'Хаос Excel и WhatsApp',
    excelChaosDetail: 'Клиники управляют записями через таблицы и чаты. Нулевая автоматизация, постоянные ошибки.',
    noShowRate: '25% неявок',
    noShowDetail: 'Без автоматических напоминаний пациенты забывают о визитах. Пустые кресла — ₾500+/день потерь.',
    paperCharts: 'Бумажные карты в 2026',
    paperChartsDetail: 'Рукописные клинические записи, без цифровой одонтограммы. Критические данные заперты в шкафах.',
    insuranceBlackHole: 'Чёрная дыра страхования',
    insuranceDetail: 'Ручные претензии в Aldagi, GPI, Imedi L занимают часы. Отклонённые претензии копятся.',
    oneplatform: 'Одна платформа, все модули',
    platformSubtitle: '15 интегрированных модулей для стоматологической практики',
    clinical: 'КЛИНИЧЕСКИЕ',
    operations: 'ОПЕРАЦИОННЫЕ',
    analyticsEnterprise: 'АНАЛИТИКА И ENTERPRISE',
    digitalOdontogram: 'Цифровая одонтограмма',
    digitalOdontogramDetail: 'FDI 32-зубная карта с 5-поверхностным отслеживанием.',
    perioCharting: 'Пародонтологическое картирование',
    perioChartingDetail: '192-точечная пародонтологическая сетка. 6-точечное зондирование, BOP, CAL.',
    treatmentPlanning: 'Планирование лечения',
    treatmentPlanningDetail: 'Фазовые планы с CDT-кодами, страховыми оценками. ИИ-секвенирование.',
    soapNotes: 'SOAP записи + ИИ скрайб',
    soapNotesDetail: 'Структурированная клиническая документация с шаблонами. Gemini генерирует записи из голоса.',
    multiChairScheduling: 'Многокресельное расписание',
    multiChairDetail: 'Недельный вид с несколькими кабинетами. Цветовая кодировка врачей.',
    billingInsurance: 'Биллинг и страхование',
    billingDetail: 'Отслеживание претензий для Aldagi, GPI, Imedi L. Бухгалтерия, планы оплаты.',
    ePrescribing: 'Электронные рецепты',
    ePrescribingDetail: 'Цифровые рецепты с шаблонами. Проверка взаимодействий лекарств через Gemini.',
    labTracking: 'Отслеживание лаборатории',
    labTrackingDetail: 'Канбан: Заказано → Изготовление → Отправлено → Получено.',
    productionReports: 'Отчёты производства',
    productionReportsDetail: 'Валовое/чистое производство, уровень сбора, принятие лечения.',
    referralMgmt: 'Управление направлениями',
    referralMgmtDetail: 'Входящие/исходящие направления к специалистам. ИИ-генерируемые письма.',
    medicalHistory: 'Медицинская история',
    medicalHistoryDetail: '11-видовая карта пациента: хронология, состояния, медикаменты, аллергии.',
    enterpriseAdmin: 'Enterprise админ',
    enterpriseAdminDetail: 'RBAC, журнал аудита, соответствие, мультиарендность, SSO, управление API.',
    geminiBuiltIn: 'Встроенный Gemini AI',
    geminiSubtitle: 'Каждый модуль работает на Google Gemini 3.1',
    xrayAnalysis: 'Анализ рентгена',
    xrayDetail: 'Загрузите стоматологические рентгенограммы для ИИ-диагностики кариеса.',
    perioAssessment: 'Пародонтологическая оценка',
    perioAssessmentDetail: 'Автоматическая стадирование/градирование AAP по данным зондирования.',
    clinicalScribe: 'Клинический скрайб',
    clinicalScribeDetail: 'Генерация SOAP-записей из голосовых записей или данных карты.',
    riskProfiling: 'Профилирование рисков',
    riskProfilingDetail: 'Анализ состояний, семейного анамнеза для создания профиля стоматологического риска.',
    treatmentSequencing: 'Секвенирование лечения',
    treatmentSequencingDetail: 'ИИ-оптимизированное фазирование лечения с учётом заживления и страхования.',
    patientComm: 'Коммуникация с пациентом',
    patientCommDetail: 'Генерация понятных пациенту объяснений на грузинском языке.',
    georgianEcosystem: 'Готово для грузинской экосистемы',
    integrationsSubtitle: 'Предустановленные интеграции с местным страхованием, платежами и мессенджерами',
    insurance: 'СТРАХОВАНИЕ',
    payments: 'ПЛАТЕЖИ',
    messaging: 'СООБЩЕНИЯ',
    ehrLabs: 'ЭМК И ЛАБОРАТОРИИ',
    clinicsInDb: 'Клиник в базе',
    platformModules: 'Модулей платформы',
    aiTools: 'ИИ-инструментов (Gemini)',
    integrations: 'Интеграций',
    pricingTitle: 'Цены',
    pricingSubtitle: 'Начните бесплатно, масштабируйтесь по мере роста',
    trustedBy: 'Доверие ведущих клиник',
    readyModernize: 'Готовы модернизировать вашу практику?',
    joinCount: 'Присоединяйтесь к 212+ клиникам в Грузии.',
    startTrial: 'Начать бесплатно',
    contactSales: 'Связаться с продажами',
    noCreditCard: 'Без кредитной карты  ·  Бесплатный тариф  ·  Настройка за 5 минут',
    copyright: '© 2026 MCAI — Операционная система стоматологических клиник',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Панель',
    navPatients: 'Пациенты',
    navChart: 'Карта',
    navPerio: 'Пародонтология',
    navTreatmentPlans: 'Планы лечения',
    navNotes: 'Записи',
    navScheduling: 'Расписание',
    navBilling: 'Биллинг',
    navPrescriptions: 'Рецепты',
    navLabCases: 'Лабораторные случаи',
    navReferrals: 'Направления',
    navReports: 'Отчёты',
    navMedHistory: 'Медицинская история',
    navIntegrations: 'Интеграции',
    navEnterprise: 'Предприятие',
    sectionClinical: 'КЛИНИКА',
    sectionOperations: 'ОПЕРАЦИИ',
    sectionAnalytics: 'АНАЛИТИКА',
    sectionAiTools: 'ИИ ИНСТРУМЕНТЫ',
    sectionAdmin: 'АДМИНИСТРИРОВАНИЕ',

    // Booking Page
    chooseClinic: 'Выберите клинику',
    selectAService: 'Выберите услугу',
    pickADate: 'Выберите дату',
    pickATime: 'Выберите время',
    confirmYourBooking: 'Подтвердите запись',
    clinicLabel: 'Клиника:',
    serviceLabel: 'Услуга:',
    dateLabel: 'Дата:',
    timeLabel: 'Время:',

    // AI Page
    send: 'Отправить',
    procedure: 'Процедура',
    observations: 'Наблюдения',
    aiThinking: 'ИИ думает...',
    summarizeHistory: 'Резюмировать историю пациента',
    generateTxPlan: 'Сгенерировать план лечения',
    checkDrugInteractions: 'Проверить взаимодействие лекарств',
    writeClinicalNote: 'Написать клиническую запись',
    askAiAssistant: 'Спросите ИИ-ассистента...',
    dropXray: 'Перетащите рентген или нажмите для загрузки',
    supportsFormats: 'Поддерживаются DICOM, PNG, JPG',
    analysisResults: 'Результаты анализа (демо)',
    aiRecommendation: 'Рекомендация ИИ',
    exportToTxPlan: 'Экспорт в план лечения',
    generateClinicalNote: 'Сгенерировать клиническую запись',
    generatedSoap: 'Сгенерированная клиническая запись (SOAP)',
    subjective: 'S — Субъективно',
    objective: 'O — Объективно',
    assessment: 'A — Оценка',
    plan: 'P — План',
    copyToRecord: 'Скопировать в карту пациента',
    aiPerioAssessment: 'ИИ пародонтологическая оценка',
    enterProbingData: 'Введите данные зондирования для AAP стадирования и рекомендаций по лечению.',
    analyzeWithGemini: 'Анализировать с Gemini',
    aiRiskAssessment: 'ИИ оценка рисков',
    enterConditions: 'Введите состояния пациента, семейный анамнез и витальные показатели для генерации профиля риска.',
    generateRiskProfile: 'Сгенерировать профиль риска',
    patientCommunication: 'Коммуникация с пациентом',
    generateExplanations: 'Генерация понятных пациенту объяснений лечения на грузинском или английском.',
    generateExplanation: 'Сгенерировать объяснение',
    patientFriendly: 'Понятное пациенту объяснение',

    // Billing Page
    claims: 'Претензии',
    ledger: 'Бухгалтерская книга',
    aging: 'Старение задолженности',
    paymentPlans: 'Планы оплаты',
    eligibility: 'Право на страхование',
    allFilter: 'Все',
    submitted: 'Отправлено',
    paid: 'Оплачено',
    denied: 'Отклонено',
    patientLedger: 'Бухгалтерия пациента',
    agedAccounts: 'Просроченные счета',
    sendStatements: 'Отправить выписки',
    activePaymentPlans: 'Активные планы оплаты',
    insuranceEligibility: 'Страховое право',

    // Clinical Charting
    odontogram: 'Одонтограмма',
    perioTab: 'Пародонтология',
    treatmentPlanTab: 'План лечения',
    notesTab: 'Записи',
    progressNotes: 'Записи о прогрессе',
    openFullPerio: 'Открыть полную пародонтологическую карту →',
    openFullTxPlanner: 'Открыть полный планировщик лечения →',
    openClinicalNotes: 'Открыть клинические записи →',
    newExam: 'Новый осмотр',
    voiceEntry: 'Голосовой ввод',
    bleedingIndex: 'Индекс кровоточивости',
    plaqueIndex: 'Индекс налёта',
    sitesAbove4: 'Участки ≥ 4мм',
    sitesAbove6: 'Участки ≥ 6мм',
    planA: 'План A: Рекомендуемый',
    planB: 'План B: Консервативный',
    newPlan: '+ Новый план',
    presentToPatient: 'Представить пациенту',
    sendToPortal: 'Отправить на портал',
    totalFee: 'Общая стоимость',
    insuranceEst: 'Оценка страховки',
    patientPortion: 'Доля пациента',
    chairSideMode: 'Режим у кресла',
    adminMode: 'Режим админа',
    proceduresAcrossPhases: '{0} процедур в {1} фазах',

    // Scheduling
    day: 'День',
    week: 'Неделя',
    today: 'Сегодня',
    providerFilter: 'Все врачи',
    productionGoal: 'Цель производства',
    waitlist: 'Лист ожидания',

    // Prescriptions
    activeRx: 'Активные',
    pastRx: 'Прошлые',
    templates: 'Шаблоны',
    interactionCheck: 'Проверка взаимодействий',

    // Lab Cases
    ordered: 'Заказано',
    sentToLab: 'Отправлено в лабораторию',
    inFabrication: 'В изготовлении',
    shipped: 'Отправлено',
    received: 'Получено',
    labVendors: 'Поставщики лабораторий',

    // Referrals
    allDirections: 'Все',
    inbound: 'Входящие',
    outbound: 'Исходящие',
    generateLetter: 'Сгенерировать письмо',

    // Reports
    production: 'Производство',
    collections: 'Сборы',
    schedulingReport: 'Расписание',
    treatmentAcceptance: 'Принятие лечения',
    recall: 'Повторный вызов',
    grossProduction: 'Валовое производство',
    netProduction: 'Чистое производство',
    collectionRate: 'Уровень сбора',
    plansPresented: 'Представлено планов',
    accepted: 'Принято',
    acceptanceRate: 'Уровень принятия',
    dueThisMonth: 'Запланировано на этот месяц',
    scheduled: 'Запланировано',
    completed: 'Завершено',
    overdue: 'Просрочено',
    reactivationRate: 'Уровень реактивации',

    // Medical History
    timeline: 'Хронология',
    conditions: 'Состояния',
    medications: 'Медикаменты',
    allergies: 'Аллергии',
    labResults: 'Результаты анализов',
    vitals: 'Витальные показатели',
    immunizations: 'Иммунизации',
    familyHistory: 'Семейный анамнез',
    imaging: 'Визуализация',
    documents: 'Документы',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Журнал аудита',
    compliance: 'Соответствие',
    multiTenancy: 'Мультиарендность',
    sso: 'SSO и безопасность',
    featureFlags: 'Флаги функций',
    apiManagement: 'Управление API',
    dataManagement: 'Управление данными',

    // Integrations
    ehr: 'ЭМК',
    labs: 'Лаборатории',
    telehealth: 'Телемедицина',
    aiMl: 'ИИ/МО',
    wearables: 'Носимые устройства',
    connected: 'Подключено',
    disconnected: 'Отключено',
    available: 'Доступно',

    // Components
    status: 'Статус',
    healthy: 'Здоровый',
    caries: 'Кариес',
    restored: 'Восстановлен',
    missing: 'Отсутствует',
    implant: 'Имплант',
    crownStatus: 'Коронка',
    bridge: 'Мост',
    veneer: 'Винир',
    surfaces: 'Поверхности',
    procedureHistory: 'История процедур',
    addProcedure: 'Добавить процедуру',
    totalCharged: 'Всего начислено',
    insurancePayment: 'Страховой платёж',
    patientResponsibility: 'Ответственность пациента',
    expand: 'Развернуть',
    policyNumber: 'Полис №',
    planType: 'Тип плана',
    annualMax: 'Годовой максимум',
    used: 'Использовано',
    remaining: 'Остаток',
    coverageByCategory: 'Покрытие по категориям',
    preventive: 'Профилактика',
    basic: 'Базовое',
    major: 'Основное',
    ortho: 'Ортодонтия',
    current: 'Текущие',
    thirtyDay: '30 дней',
    sixtyDay: '60 дней',
    ninetyPlus: '90+ дней',
    totalBalance: 'Общий баланс',
    monthlyPayment: 'Ежемесячный платёж',
    paymentsRemaining: 'Осталось платежей',
    nextPayment: 'Следующий платёж',
    paymentProgress: 'Прогресс оплаты',
    choosePlan: 'Выбрать план',
    aiInsight: 'ИИ инсайт',
    confidence: 'Уверенность',
    revoke: 'Отозвать',
    exams: 'Осмотры',
    phaseTotal: 'Итого по фазе',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Вс',
    thinking: 'Думаю...',
    followUpPlaceholder: 'Задайте дополнительный вопрос...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Клинический Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Лечение Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Пациент Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Главная',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Панель',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Подтвердить Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Клинический Notes',
    newNote: '+ Новый Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Выручка Сегодня',
    noshows: 'No-shows',
    confirmed: 'Подтверждён',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Пациент',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Клиника Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Страхование',
    unison: 'Unison',
    saveSettings: 'Сохранить Настройки',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Доктор',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Лаборатория',
    patient2: 'Пациент',
    patients: 'Пациенты',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Настройки',
    labOrders: 'Лаборатория Orders',
    auditLog2: 'Audit Log',
    allTypes: 'Все Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Панель',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Доступен',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Подключён',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Итого Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Экспорт Все Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Экспорт',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Импорт',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Экспорт Отчёт',
    monthlyRevenue: 'Monthly Выручка',
    u20be12400: '\u20BE12,400',
    pending: 'Ожидание',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Выручка',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Настройки',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Лаборатория Case Pipeline',
    labVendors2: 'Лаборатория Vendors',
    tbilisidentLab: 'TbilisiDent Лаборатория',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Активный Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Лаборатория',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Активный Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Пациент Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Активный Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Активный',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Активный Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Завершён',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Лаборатория Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Пациент Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Лечение Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Страхование Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Лечение Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Страхование',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Лечение',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Итого',
    addProcedure2: '+ Add Процедура',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Загрузить Document',
    all: 'Все',
    new: 'Новый',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ Новый Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Страхование integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: 'Главная',
    features: 'Функции',
    pricing: 'Цены',
    clinicsNav: 'Клиники',
    aiAssistant: 'ИИ Ассистент',
    forBusiness: 'Для бизнеса',
    dashboard: 'Панель',
    getStarted: 'Начать',
    tryDemo: 'Попробовать демо',
    viewPitch: 'Презентация',
    heroTagline: 'Стоматологическая платформа для Грузии',
    heroTitle: 'Все стоматологические клиники',
    heroSubtitle: 'Ваш AI-ассистент для поиска лучшей стоматологической помощи в Грузии',
    searchPlaceholder: 'Поиск клиник, услуг или задайте вопрос...',
    chipImplant: 'Лучшие клиники имплантации в Тбилиси',
    chipWhitening: 'Отбеливание зубов рядом',
    chipEmergency: 'Экстренная стоматологическая помощь',
    chipOrtho: 'Ортодонтия для взрослых',
    scrollExplore: 'Прокрутите для просмотра',
    topRated: 'Лучшие стоматологические клиники Тбилиси',
    viewAllClinics: 'Все клиники',
    shareLocation: 'Поделиться локацией для поиска ближайших клиник',
    locationShared: 'Локация получена — показываем ближайшие',
    statClinics: 'Клиники',
    statNoShows: 'Меньше неявок',
    statBooking: 'Онлайн запись',
    statDentists: 'Стоматологи',
    statRating: 'Средний рейтинг',
    statPatients: 'Пациенты',
    findClinics: 'Найти лучшие клиники',
    forBusinessBtn: 'Для бизнеса',
    ownClinic: 'У вас есть стоматологическая клиника?',
    claimText: 'Зарегистрируйте свою клинику или добавьте её в нашу базу данных.',
    getListed: 'Зарегистрироваться →',
    clinicsTitle: 'Стоматологические клиники в Грузии',
    verifiedClinics: 'проверенных клиник с рейтингами и отзывами',
    searchByName: 'Поиск по названию, району или услуге...',
    hideMap: 'Скрыть карту',
    showMap: 'Карта',
    nearMe: 'Рядом',
    clinicsMatch: 'клиник совпадает',
    reviews: 'отзывов',
    loadingMore: 'Загрузка...',
    callClinic: 'Позвонить',
    bookAppointment: 'Записаться',
    services: 'Услуги',
    workingHours: 'Часы работы',
    priceRange: 'Диапазон цен',
    location: 'Расположение',
    visitWebsite: 'Перейти на сайт',
    bookingTitle: 'Запись на приём',
    step: 'Шаг',
    selectClinic: 'Выберите клинику',
    selectService: 'Выберите услугу',
    selectDate: 'Выберите дату',
    selectTime: 'Выберите время',
    confirm: 'Подтвердить',
    next: 'Далее',
    back: 'Назад',
    clinicsAvailable: 'клиник доступно',
    clinicsFound: 'клиник найдено',
    confirmBooking: 'Подтвердить запись',
    bookingConfirmed: 'Ваш визит забронирован!',
    patientName: 'Имя пациента',
    phoneNumber: 'Номер телефона',
    email: 'Электронная почта',
    notes: 'Примечания (необязательно)',
    businessHeroBadge: '15+ Модулей  ·  212+ Клиник  ·  Gemini AI',
    businessHeroTitle: 'Операционная система для стоматологических клиник',
    businessHeroSubtitle: 'Клиническое картирование, пародонтологический анализ, планирование лечения, расписание, биллинг, электронные рецепты, управление лабораторией и ИИ-диагностика — всё в одной платформе для Грузии.',
    theProblem: 'Проблема',
    problemSubtitle: 'Грузинские стоматологические клиники ежедневно теряют доход из-за фрагментированных инструментов',
    excelChaos: 'Хаос Excel и WhatsApp',
    excelChaosDetail: 'Клиники управляют записями через таблицы и чаты. Нулевая автоматизация, постоянные ошибки.',
    noShowRate: '25% неявок',
    noShowDetail: 'Без автоматических напоминаний пациенты забывают о визитах. Пустые кресла — ₾500+/день потерь.',
    paperCharts: 'Бумажные карты в 2026',
    paperChartsDetail: 'Рукописные клинические записи, без цифровой одонтограммы. Критические данные заперты в шкафах.',
    insuranceBlackHole: 'Чёрная дыра страхования',
    insuranceDetail: 'Ручные претензии в Aldagi, GPI, Imedi L занимают часы. Отклонённые претензии копятся.',
    oneplatform: 'Одна платформа, все модули',
    platformSubtitle: '15 интегрированных модулей для стоматологической практики',
    clinical: 'КЛИНИЧЕСКИЕ',
    operations: 'ОПЕРАЦИОННЫЕ',
    analyticsEnterprise: 'АНАЛИТИКА И ENTERPRISE',
    digitalOdontogram: 'Цифровая одонтограмма',
    digitalOdontogramDetail: 'FDI 32-зубная карта с 5-поверхностным отслеживанием.',
    perioCharting: 'Пародонтологическое картирование',
    perioChartingDetail: '192-точечная пародонтологическая сетка. 6-точечное зондирование, BOP, CAL.',
    treatmentPlanning: 'Планирование лечения',
    treatmentPlanningDetail: 'Фазовые планы с CDT-кодами, страховыми оценками. ИИ-секвенирование.',
    soapNotes: 'SOAP записи + ИИ скрайб',
    soapNotesDetail: 'Структурированная клиническая документация с шаблонами. Gemini генерирует записи из голоса.',
    multiChairScheduling: 'Многокресельное расписание',
    multiChairDetail: 'Недельный вид с несколькими кабинетами. Цветовая кодировка врачей.',
    billingInsurance: 'Биллинг и страхование',
    billingDetail: 'Отслеживание претензий для Aldagi, GPI, Imedi L. Бухгалтерия, планы оплаты.',
    ePrescribing: 'Электронные рецепты',
    ePrescribingDetail: 'Цифровые рецепты с шаблонами. Проверка взаимодействий лекарств через Gemini.',
    labTracking: 'Отслеживание лаборатории',
    labTrackingDetail: 'Канбан: Заказано → Изготовление → Отправлено → Получено.',
    productionReports: 'Отчёты производства',
    productionReportsDetail: 'Валовое/чистое производство, уровень сбора, принятие лечения.',
    referralMgmt: 'Управление направлениями',
    referralMgmtDetail: 'Входящие/исходящие направления к специалистам. ИИ-генерируемые письма.',
    medicalHistory: 'Медицинская история',
    medicalHistoryDetail: '11-видовая карта пациента: хронология, состояния, медикаменты, аллергии.',
    enterpriseAdmin: 'Enterprise админ',
    enterpriseAdminDetail: 'RBAC, журнал аудита, соответствие, мультиарендность, SSO, управление API.',
    geminiBuiltIn: 'Встроенный Gemini AI',
    geminiSubtitle: 'Каждый модуль работает на Google Gemini 3.1',
    xrayAnalysis: 'Анализ рентгена',
    xrayDetail: 'Загрузите стоматологические рентгенограммы для ИИ-диагностики кариеса.',
    perioAssessment: 'Пародонтологическая оценка',
    perioAssessmentDetail: 'Автоматическая стадирование/градирование AAP по данным зондирования.',
    clinicalScribe: 'Клинический скрайб',
    clinicalScribeDetail: 'Генерация SOAP-записей из голосовых записей или данных карты.',
    riskProfiling: 'Профилирование рисков',
    riskProfilingDetail: 'Анализ состояний, семейного анамнеза для создания профиля стоматологического риска.',
    treatmentSequencing: 'Секвенирование лечения',
    treatmentSequencingDetail: 'ИИ-оптимизированное фазирование лечения с учётом заживления и страхования.',
    patientComm: 'Коммуникация с пациентом',
    patientCommDetail: 'Генерация понятных пациенту объяснений на грузинском языке.',
    georgianEcosystem: 'Готово для грузинской экосистемы',
    integrationsSubtitle: 'Предустановленные интеграции с местным страхованием, платежами и мессенджерами',
    insurance: 'СТРАХОВАНИЕ',
    payments: 'ПЛАТЕЖИ',
    messaging: 'СООБЩЕНИЯ',
    ehrLabs: 'ЭМК И ЛАБОРАТОРИИ',
    clinicsInDb: 'Клиник в базе',
    platformModules: 'Модулей платформы',
    aiTools: 'ИИ-инструментов (Gemini)',
    integrations: 'Интеграций',
    pricingTitle: 'Цены',
    pricingSubtitle: 'Начните бесплатно, масштабируйтесь по мере роста',
    trustedBy: 'Доверие ведущих клиник',
    readyModernize: 'Готовы модернизировать вашу практику?',
    joinCount: 'Присоединяйтесь к 212+ клиникам в Грузии.',
    startTrial: 'Начать бесплатно',
    contactSales: 'Связаться с продажами',
    noCreditCard: 'Без кредитной карты  ·  Бесплатный тариф  ·  Настройка за 5 минут',
    copyright: '© 2026 MCAI — Операционная система стоматологических клиник',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Панель',
    navPatients: 'Пациенты',
    navChart: 'Карта',
    navPerio: 'Пародонтология',
    navTreatmentPlans: 'Планы лечения',
    navNotes: 'Записи',
    navScheduling: 'Расписание',
    navBilling: 'Биллинг',
    navPrescriptions: 'Рецепты',
    navLabCases: 'Лабораторные случаи',
    navReferrals: 'Направления',
    navReports: 'Отчёты',
    navMedHistory: 'Медицинская история',
    navIntegrations: 'Интеграции',
    navEnterprise: 'Предприятие',
    sectionClinical: 'КЛИНИКА',
    sectionOperations: 'ОПЕРАЦИИ',
    sectionAnalytics: 'АНАЛИТИКА',
    sectionAiTools: 'ИИ ИНСТРУМЕНТЫ',
    sectionAdmin: 'АДМИНИСТРИРОВАНИЕ',

    // Booking Page
    chooseClinic: 'Выберите клинику',
    selectAService: 'Выберите услугу',
    pickADate: 'Выберите дату',
    pickATime: 'Выберите время',
    confirmYourBooking: 'Подтвердите запись',
    clinicLabel: 'Клиника:',
    serviceLabel: 'Услуга:',
    dateLabel: 'Дата:',
    timeLabel: 'Время:',

    // AI Page
    send: 'Отправить',
    procedure: 'Процедура',
    observations: 'Наблюдения',
    aiThinking: 'ИИ думает...',
    summarizeHistory: 'Резюмировать историю пациента',
    generateTxPlan: 'Сгенерировать план лечения',
    checkDrugInteractions: 'Проверить взаимодействие лекарств',
    writeClinicalNote: 'Написать клиническую запись',
    askAiAssistant: 'Спросите ИИ-ассистента...',
    dropXray: 'Перетащите рентген или нажмите для загрузки',
    supportsFormats: 'Поддерживаются DICOM, PNG, JPG',
    analysisResults: 'Результаты анализа (демо)',
    aiRecommendation: 'Рекомендация ИИ',
    exportToTxPlan: 'Экспорт в план лечения',
    generateClinicalNote: 'Сгенерировать клиническую запись',
    generatedSoap: 'Сгенерированная клиническая запись (SOAP)',
    subjective: 'S — Субъективно',
    objective: 'O — Объективно',
    assessment: 'A — Оценка',
    plan: 'P — План',
    copyToRecord: 'Скопировать в карту пациента',
    aiPerioAssessment: 'ИИ пародонтологическая оценка',
    enterProbingData: 'Введите данные зондирования для AAP стадирования и рекомендаций по лечению.',
    analyzeWithGemini: 'Анализировать с Gemini',
    aiRiskAssessment: 'ИИ оценка рисков',
    enterConditions: 'Введите состояния пациента, семейный анамнез и витальные показатели для генерации профиля риска.',
    generateRiskProfile: 'Сгенерировать профиль риска',
    patientCommunication: 'Коммуникация с пациентом',
    generateExplanations: 'Генерация понятных пациенту объяснений лечения на грузинском или английском.',
    generateExplanation: 'Сгенерировать объяснение',
    patientFriendly: 'Понятное пациенту объяснение',

    // Billing Page
    claims: 'Претензии',
    ledger: 'Бухгалтерская книга',
    aging: 'Старение задолженности',
    paymentPlans: 'Планы оплаты',
    eligibility: 'Право на страхование',
    allFilter: 'Все',
    submitted: 'Отправлено',
    paid: 'Оплачено',
    denied: 'Отклонено',
    patientLedger: 'Бухгалтерия пациента',
    agedAccounts: 'Просроченные счета',
    sendStatements: 'Отправить выписки',
    activePaymentPlans: 'Активные планы оплаты',
    insuranceEligibility: 'Страховое право',

    // Clinical Charting
    odontogram: 'Одонтограмма',
    perioTab: 'Пародонтология',
    treatmentPlanTab: 'План лечения',
    notesTab: 'Записи',
    progressNotes: 'Записи о прогрессе',
    openFullPerio: 'Открыть полную пародонтологическую карту →',
    openFullTxPlanner: 'Открыть полный планировщик лечения →',
    openClinicalNotes: 'Открыть клинические записи →',
    newExam: 'Новый осмотр',
    voiceEntry: 'Голосовой ввод',
    bleedingIndex: 'Индекс кровоточивости',
    plaqueIndex: 'Индекс налёта',
    sitesAbove4: 'Участки ≥ 4мм',
    sitesAbove6: 'Участки ≥ 6мм',
    planA: 'План A: Рекомендуемый',
    planB: 'План B: Консервативный',
    newPlan: '+ Новый план',
    presentToPatient: 'Представить пациенту',
    sendToPortal: 'Отправить на портал',
    totalFee: 'Общая стоимость',
    insuranceEst: 'Оценка страховки',
    patientPortion: 'Доля пациента',
    chairSideMode: 'Режим у кресла',
    adminMode: 'Режим админа',
    proceduresAcrossPhases: '{0} процедур в {1} фазах',

    // Scheduling
    day: 'День',
    week: 'Неделя',
    today: 'Сегодня',
    providerFilter: 'Все врачи',
    productionGoal: 'Цель производства',
    waitlist: 'Лист ожидания',

    // Prescriptions
    activeRx: 'Активные',
    pastRx: 'Прошлые',
    templates: 'Шаблоны',
    interactionCheck: 'Проверка взаимодействий',

    // Lab Cases
    ordered: 'Заказано',
    sentToLab: 'Отправлено в лабораторию',
    inFabrication: 'В изготовлении',
    shipped: 'Отправлено',
    received: 'Получено',
    labVendors: 'Поставщики лабораторий',

    // Referrals
    allDirections: 'Все',
    inbound: 'Входящие',
    outbound: 'Исходящие',
    generateLetter: 'Сгенерировать письмо',

    // Reports
    production: 'Производство',
    collections: 'Сборы',
    schedulingReport: 'Расписание',
    treatmentAcceptance: 'Принятие лечения',
    recall: 'Повторный вызов',
    grossProduction: 'Валовое производство',
    netProduction: 'Чистое производство',
    collectionRate: 'Уровень сбора',
    plansPresented: 'Представлено планов',
    accepted: 'Принято',
    acceptanceRate: 'Уровень принятия',
    dueThisMonth: 'Запланировано на этот месяц',
    scheduled: 'Запланировано',
    completed: 'Завершено',
    overdue: 'Просрочено',
    reactivationRate: 'Уровень реактивации',

    // Medical History
    timeline: 'Хронология',
    conditions: 'Состояния',
    medications: 'Медикаменты',
    allergies: 'Аллергии',
    labResults: 'Результаты анализов',
    vitals: 'Витальные показатели',
    immunizations: 'Иммунизации',
    familyHistory: 'Семейный анамнез',
    imaging: 'Визуализация',
    documents: 'Документы',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Журнал аудита',
    compliance: 'Соответствие',
    multiTenancy: 'Мультиарендность',
    sso: 'SSO и безопасность',
    featureFlags: 'Флаги функций',
    apiManagement: 'Управление API',
    dataManagement: 'Управление данными',

    // Integrations
    ehr: 'ЭМК',
    labs: 'Лаборатории',
    telehealth: 'Телемедицина',
    aiMl: 'ИИ/МО',
    wearables: 'Носимые устройства',
    connected: 'Подключено',
    disconnected: 'Отключено',
    available: 'Доступно',

    // Components
    status: 'Статус',
    healthy: 'Здоровый',
    caries: 'Кариес',
    restored: 'Восстановлен',
    missing: 'Отсутствует',
    implant: 'Имплант',
    crownStatus: 'Коронка',
    bridge: 'Мост',
    veneer: 'Винир',
    surfaces: 'Поверхности',
    procedureHistory: 'История процедур',
    addProcedure: 'Добавить процедуру',
    totalCharged: 'Всего начислено',
    insurancePayment: 'Страховой платёж',
    patientResponsibility: 'Ответственность пациента',
    expand: 'Развернуть',
    policyNumber: 'Полис №',
    planType: 'Тип плана',
    annualMax: 'Годовой максимум',
    used: 'Использовано',
    remaining: 'Остаток',
    coverageByCategory: 'Покрытие по категориям',
    preventive: 'Профилактика',
    basic: 'Базовое',
    major: 'Основное',
    ortho: 'Ортодонтия',
    current: 'Текущие',
    thirtyDay: '30 дней',
    sixtyDay: '60 дней',
    ninetyPlus: '90+ дней',
    totalBalance: 'Общий баланс',
    monthlyPayment: 'Ежемесячный платёж',
    paymentsRemaining: 'Осталось платежей',
    nextPayment: 'Следующий платёж',
    paymentProgress: 'Прогресс оплаты',
    choosePlan: 'Выбрать план',
    aiInsight: 'ИИ инсайт',
    confidence: 'Уверенность',
    revoke: 'Отозвать',
    exams: 'Осмотры',
    phaseTotal: 'Итого по фазе',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Вс',
    thinking: 'Думаю...',
    followUpPlaceholder: 'Задайте дополнительный вопрос...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Далее →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Активный Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Рецепт Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ Новый Направление',
    inbound2: 'Входящий',
    outbound2: 'Исходящий',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Производство by Провайдер',
    productionByCategory: 'Производство by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Отчёт',
    appointmentsByDay: 'Визиты by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Страхование not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'Все Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Лечение',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ Новый Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Лечение Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Итого Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Клинический Findings',
    diagnosis: 'Диагноз',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Сумма Оплачено',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Пациент',
    autoImport: 'Auto Импорт',
    away: 'Away',
    bankTransfer: 'Bank Перевод',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Кабинет',
    cabinet1: 'Кабинет 1',
    cabinet2: 'Кабинет 2',
    cabinetSchedule: 'Кабинет Расписание',
    cabinetScheduleDesc: 'Кабинет Расписание Desc',
    card: 'Карта',
    cash: 'Наличные',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Вопрос',
    clinicAvgRating: 'Clinic Avg Рейтинг',
    collapse: 'Collapse',
    completedToday: 'Завершено Сегодня',
    compositeF: 'Composite F',
    continueToScheduling: 'Продолжить To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Сумма',
    days: 'Дни',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Доктор Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Документ Mgmt Subtitle',
    documentPreview: 'Документ Просмотр',
    download: 'Скачать',
    endodontic: 'Endodontic',
    enterAmount: 'Введите Сумма',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Доставка',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Качество',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth Вид',
    hasBracesQuestion: 'Has Braces Вопрос',
    hasConsultationQuestion: 'Has Consultation Вопрос',
    hasCtScanQuestion: 'Has Ct Сканирование Вопрос',
    hasRecentXrayQuestion: 'Has Недавние Xray Вопрос',
    helpfulQuestion: 'Helpful Вопрос',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Визуализация Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Импорт Latest',
    inProgress: 'In Progress',
    installment: 'Рассрочка',
    insuranceCoverage: 'Страхование Покрытие',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Вопрос',
    lateralSkullView: 'Lateral Skull Вид',
    lowest: 'Lowest',
    lowStock: 'Низкий Запас',
    lowStockAlerts: 'Низкий Запас Оповещения',
    maintenance: 'Maintenance',
    management: 'Управление',
    markComplete: 'Mark Complete',
    material: 'Материал',
    method: 'Метод',
    minOrder: 'Min Заказ',
    monthlySpend: 'Ежемесячный Spend',
    newPayment: 'New Оплата',
    newRadiologyReferral: 'New Radiology Направление',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Нормальный',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Онлайн',
    orderNow: 'Заказ Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Остаток',
    painManagement: 'Pain Управление',
    panoramic: 'Панорамный',
    patientDue: 'Пациент К оплате',
    paymentHistory: 'Оплата История',
    paymentMethod: 'Оплата Метод',
    pendingOrders: 'Ожидание Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Заказ',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Печать',
    processing: 'Processing',
    processPayment: 'Обработка Оплата',
    processPaymentBtn: 'Обработка Оплата Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Количество',
    queue: 'Очередь',
    receiptPreview: 'Квитанция Просмотр',
    recent: 'Недавние',
    recentMaterialUsage: 'Недавние Материал Usage',
    recentReceipts: 'Недавние Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Баланс',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth Вид',
    slotDetails: 'Slot Details',
    sortBy: 'Сортировка By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Визуализация',
    stock: 'Запас',
    stockLevel: 'Запас Level',
    submitReferral: 'Отправить Направление',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Команда Чат',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Визуализация',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Сообщение',
    unavailable: 'Unavailable',
    unit: 'Единица',
    urgency: 'Urgency',
    urgent: 'Срочно',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'Вид On Google',
    xrays: 'Xrays'
  },

  uk: {
    home: 'Головна', features: 'Функції', pricing: 'Ціни', clinicsNav: 'Клініки', aiAssistant: 'AI Асистент', forBusiness: 'Для бізнесу', dashboard: 'Панель', getStarted: 'Почати', tryDemo: 'Спробувати демо', viewPitch: 'Презентація',
    heroTagline: 'Стоматологічна платформа для Грузії', heroTitle: 'Усі стоматологічні клініки', heroSubtitle: 'Ваш AI-асистент для пошуку найкращої стоматологічної допомоги в Грузії',
    searchPlaceholder: 'Пошук клінік, послуг або запитайте...', chipImplant: 'Кращі клініки імплантації у Тбілісі', chipWhitening: 'Відбілювання зубів поруч', chipEmergency: 'Екстрена стоматологічна допомога', chipOrtho: 'Ортодонтія для дорослих', scrollExplore: 'Прокрутіть для перегляду',
    topRated: 'Найкращі стоматологічні клініки Тбілісі', viewAllClinics: 'Всі клініки', shareLocation: 'Поділіться локацією', locationShared: 'Локацію отримано',
    statClinics: 'Клініки', statNoShows: 'Менше неявок', statBooking: 'Онлайн запис', statDentists: 'Стоматологи', statRating: 'Середній рейтинг', statPatients: 'Пацієнти',
    findClinics: 'Знайти клініки', forBusinessBtn: 'Для бізнесу', ownClinic: 'Ви власник стоматологічної клініки?', claimText: 'Зареєструйте свою клініку в нашій базі.', getListed: 'Зареєструватися →',
    clinicsTitle: 'Стоматологічні клініки в Грузії', verifiedClinics: 'перевірених клінік', searchByName: 'Пошук за назвою, районом або послугою...', hideMap: 'Сховати карту', showMap: 'Карта', nearMe: 'Поруч', clinicsMatch: 'клінік збігається', reviews: 'відгуків', loadingMore: 'Завантаження...',
    callClinic: 'Зателефонувати', bookAppointment: 'Записатися', services: 'Послуги', workingHours: 'Години роботи', priceRange: 'Діапазон цін', location: 'Розташування', visitWebsite: 'Перейти на сайт',
    bookingTitle: 'Запис на прийом', step: 'Крок', selectClinic: 'Оберіть клініку', selectService: 'Оберіть послугу', selectDate: 'Оберіть дату', selectTime: 'Оберіть час', confirm: 'Підтвердити', next: 'Далі', back: 'Назад', clinicsAvailable: 'клінік доступно', clinicsFound: 'клінік знайдено', confirmBooking: 'Підтвердити запис', bookingConfirmed: 'Ваш візит заброньовано!', patientName: "Ім'я пацієнта", phoneNumber: 'Номер телефону', email: 'Електронна пошта', notes: 'Примітки (необов\'язково)',
    businessHeroBadge: '15+ Модулів  ·  212+ Клінік  ·  Gemini AI',
    businessHeroTitle: 'Операційна система для стоматологічних клінік',
    businessHeroSubtitle: 'Клінічне картування, пародонтологічний аналіз, планування лікування, розклад, білінг, е-рецепти, управління лабораторією та ІІ-діагностика — все на одній платформі для Грузії.',
    theProblem: 'Проблема',
    problemSubtitle: 'Грузинські стоматологічні клініки щодня втрачають дохід через фрагментовані інструменти',
    excelChaos: 'Хаос Excel та WhatsApp',
    excelChaosDetail: 'Клініки керують записами через таблиці та чати. Нульова автоматизація, постійні помилки.',
    noShowRate: '25% неявок',
    noShowDetail: 'Без автоматичних нагадувань пацієнти забувають про візити. Порожні крісла — ₾500+/день втрат.',
    paperCharts: 'Паперові карти у 2026',
    paperChartsDetail: 'Рукописні клінічні записи, без цифрової одонтограми. Критичні дані замкнені у шафах.',
    insuranceBlackHole: 'Чорна діра страхування',
    insuranceDetail: 'Ручні претензії до Aldagi, GPI, Imedi L займають години. Відхилені претензії накопичуються.',
    oneplatform: 'Одна платформа, всі модулі',
    platformSubtitle: '15 інтегрованих модулів для стоматологічної практики',
    clinical: 'КЛІНІЧНІ',
    operations: 'ОПЕРАЦІЙНІ',
    analyticsEnterprise: 'АНАЛІТИКА ТА ENTERPRISE',
    digitalOdontogram: 'Цифрова одонтограма',
    digitalOdontogramDetail: 'FDI 32-зубна карта з 5-поверхневим відстеженням.',
    perioCharting: 'Пародонтологічне картування',
    perioChartingDetail: '192-точкова пародонтологічна сітка. 6-точкове зондування, BOP, CAL.',
    treatmentPlanning: 'Планування лікування',
    treatmentPlanningDetail: 'Фазові плани з CDT-кодами, страховими оцінками. ІІ-секвенування.',
    soapNotes: 'SOAP записи + ІІ скрайб',
    soapNotesDetail: 'Структурована клінічна документація з шаблонами. Gemini генерує записи з голосу.',
    multiChairScheduling: 'Багатокрісельний розклад',
    multiChairDetail: 'Тижневий вигляд з кількома кабінетами. Кольорове кодування лікарів.',
    billingInsurance: 'Білінг та страхування',
    billingDetail: 'Відстеження претензій для Aldagi, GPI, Imedi L. Бухгалтерія, плани оплати.',
    ePrescribing: 'Електронні рецепти',
    ePrescribingDetail: 'Цифрові рецепти з шаблонами. Перевірка взаємодій ліків через Gemini.',
    labTracking: 'Відстеження лабораторії',
    labTrackingDetail: 'Канбан: Замовлено → Виготовлення → Відправлено → Отримано.',
    productionReports: 'Звіти виробництва',
    productionReportsDetail: 'Валове/чисте виробництво, рівень збору, прийняття лікування.',
    referralMgmt: 'Управління направленнями',
    referralMgmtDetail: 'Вхідні/вихідні направлення до спеціалістів. ІІ-генеровані листи.',
    medicalHistory: 'Медична історія',
    medicalHistoryDetail: '11-видова карта пацієнта: хронологія, стани, медикаменти, алергії.',
    enterpriseAdmin: 'Enterprise адмін',
    enterpriseAdminDetail: 'RBAC, журнал аудиту, відповідність, мультиорендність, SSO, управління API.',
    geminiBuiltIn: 'Вбудований Gemini AI',
    geminiSubtitle: 'Кожен модуль працює на Google Gemini 3.1',
    xrayAnalysis: 'Аналіз рентгену',
    xrayDetail: 'Завантажте стоматологічні рентгенограми для ІІ-діагностики карієсу.',
    perioAssessment: 'Пародонтологічна оцінка',
    perioAssessmentDetail: 'Автоматичне стадіювання/градування AAP за даними зондування.',
    clinicalScribe: 'Клінічний скрайб',
    clinicalScribeDetail: 'Генерація SOAP-записів з голосових записів або даних карти.',
    riskProfiling: 'Профілювання ризиків',
    riskProfilingDetail: 'Аналіз станів, сімейного анамнезу для створення профілю стоматологічного ризику.',
    treatmentSequencing: 'Секвенування лікування',
    treatmentSequencingDetail: 'ІІ-оптимізоване фазування лікування з урахуванням загоєння та страхування.',
    patientComm: 'Комунікація з пацієнтом',
    patientCommDetail: 'Генерація зрозумілих пацієнту пояснень грузинською мовою.',
    georgianEcosystem: 'Готово для грузинської екосистеми',
    integrationsSubtitle: 'Передустановлені інтеграції з місцевим страхуванням, платежами та месенджерами',
    insurance: 'СТРАХУВАННЯ',
    payments: 'ПЛАТЕЖІ',
    messaging: 'ПОВІДОМЛЕННЯ',
    ehrLabs: 'ЕМК ТА ЛАБОРАТОРІЇ',
    clinicsInDb: 'Клінік у базі',
    platformModules: 'Модулів платформи',
    aiTools: 'ІІ-інструментів (Gemini)',
    integrations: 'Інтеграцій',
    pricingTitle: 'Ціни',
    pricingSubtitle: 'Почніть безкоштовно',
    trustedBy: 'Довіра клінік',
    readyModernize: 'Готові до модернізації?',
    joinCount: 'Приєднуйтесь до 212+ клінік у Грузії.',
    startTrial: 'Почати безкоштовно',
    contactSales: "Зв'язатися з продажами",
    noCreditCard: 'Без кредитної картки  ·  Безкоштовний тариф  ·  Налаштування за 5 хвилин',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Панель',
    navPatients: 'Пацієнти',
    navChart: 'Карта',
    navPerio: 'Пародонтологія',
    navTreatmentPlans: 'Плани лікування',
    navNotes: 'Записи',
    navScheduling: 'Розклад',
    navBilling: 'Білінг',
    navPrescriptions: 'Рецепти',
    navLabCases: 'Лабораторні випадки',
    navReferrals: 'Направлення',
    navReports: 'Звіти',
    navMedHistory: 'Медична історія',
    navIntegrations: 'Інтеграції',
    navEnterprise: 'Підприємство',
    sectionClinical: 'КЛІНІКА',
    sectionOperations: 'ОПЕРАЦІЇ',
    sectionAnalytics: 'АНАЛІТИКА',
    sectionAiTools: 'ІІ ІНСТРУМЕНТИ',
    sectionAdmin: 'АДМІНІСТРУВАННЯ',

    // Booking Page
    chooseClinic: 'Оберіть клініку',
    selectAService: 'Оберіть послугу',
    pickADate: 'Оберіть дату',
    pickATime: 'Оберіть час',
    confirmYourBooking: 'Підтвердіть запис',
    clinicLabel: 'Клініка:',
    serviceLabel: 'Послуга:',
    dateLabel: 'Дата:',
    timeLabel: 'Час:',

    // AI Page
    send: 'Надіслати',
    procedure: 'Процедура',
    observations: 'Спостереження',
    aiThinking: 'ІІ думає...',
    summarizeHistory: 'Узагальнити історію пацієнта',
    generateTxPlan: 'Згенерувати план лікування',
    checkDrugInteractions: 'Перевірити взаємодію ліків',
    writeClinicalNote: 'Написати клінічний запис',
    askAiAssistant: 'Запитайте ІІ-асистента...',
    dropXray: 'Перетягніть рентген або натисніть для завантаження',
    supportsFormats: 'Підтримуються DICOM, PNG, JPG',
    analysisResults: 'Результати аналізу (демо)',
    aiRecommendation: 'Рекомендація ІІ',
    exportToTxPlan: 'Експорт у план лікування',
    generateClinicalNote: 'Згенерувати клінічний запис',
    generatedSoap: 'Згенерований клінічний запис (SOAP)',
    subjective: 'S — Суб\'єктивне',
    objective: 'O — Об\'єктивне',
    assessment: 'A — Оцінка',
    plan: 'P — План',
    copyToRecord: 'Скопіювати до карти пацієнта',
    aiPerioAssessment: 'ІІ пародонтологічна оцінка',
    enterProbingData: 'Введіть дані зондування для AAP стадіювання та рекомендацій лікування.',
    analyzeWithGemini: 'Аналізувати з Gemini',
    aiRiskAssessment: 'ІІ оцінка ризиків',
    enterConditions: 'Введіть стан пацієнта, сімейний анамнез та вітальні показники для генерації профілю ризику.',
    generateRiskProfile: 'Згенерувати профіль ризику',
    patientCommunication: 'Комунікація з пацієнтом',
    generateExplanations: 'Генерація зрозумілих пацієнту пояснень лікування грузинською або англійською.',
    generateExplanation: 'Згенерувати пояснення',
    patientFriendly: 'Зрозуміле пацієнту пояснення',

    // Billing Page
    claims: 'Претензії',
    ledger: 'Бухгалтерська книга',
    aging: 'Старіння заборгованості',
    paymentPlans: 'Плани оплати',
    eligibility: 'Право на страхування',
    allFilter: 'Усі',
    submitted: 'Надіслано',
    paid: 'Оплачено',
    denied: 'Відхилено',
    patientLedger: 'Бухгалтерія пацієнта',
    agedAccounts: 'Прострочені рахунки',
    sendStatements: 'Надіслати виписки',
    activePaymentPlans: 'Активні плани оплати',
    insuranceEligibility: 'Страхове право',

    // Clinical Charting
    odontogram: 'Одонтограма',
    perioTab: 'Пародонтологія',
    treatmentPlanTab: 'План лікування',
    notesTab: 'Записи',
    progressNotes: 'Записи про прогрес',
    openFullPerio: 'Відкрити повну пародонтологічну карту →',
    openFullTxPlanner: 'Відкрити повний планувальник лікування →',
    openClinicalNotes: 'Відкрити клінічні записи →',
    newExam: 'Новий огляд',
    voiceEntry: 'Голосовий ввід',
    bleedingIndex: 'Індекс кровоточивості',
    plaqueIndex: 'Індекс нальоту',
    sitesAbove4: 'Ділянки ≥ 4мм',
    sitesAbove6: 'Ділянки ≥ 6мм',
    planA: 'План A: Рекомендований',
    planB: 'План B: Консервативний',
    newPlan: '+ Новий план',
    presentToPatient: 'Представити пацієнту',
    sendToPortal: 'Надіслати на портал',
    totalFee: 'Загальна вартість',
    insuranceEst: 'Оцінка страховки',
    patientPortion: 'Частка пацієнта',
    chairSideMode: 'Режим біля крісла',
    adminMode: 'Режим адміна',
    proceduresAcrossPhases: '{0} процедур у {1} фазах',

    // Scheduling
    day: 'День',
    week: 'Тиждень',
    today: 'Сьогодні',
    providerFilter: 'Усі лікарі',
    productionGoal: 'Ціль виробництва',
    waitlist: 'Лист очікування',

    // Prescriptions
    activeRx: 'Активні',
    pastRx: 'Минулі',
    templates: 'Шаблони',
    interactionCheck: 'Перевірка взаємодій',

    // Lab Cases
    ordered: 'Замовлено',
    sentToLab: 'Надіслано до лабораторії',
    inFabrication: 'У виготовленні',
    shipped: 'Відправлено',
    received: 'Отримано',
    labVendors: 'Постачальники лабораторій',

    // Referrals
    allDirections: 'Усі',
    inbound: 'Вхідні',
    outbound: 'Вихідні',
    generateLetter: 'Згенерувати лист',

    // Reports
    production: 'Виробництво',
    collections: 'Збори',
    schedulingReport: 'Розклад',
    treatmentAcceptance: 'Прийняття лікування',
    recall: 'Повторний виклик',
    grossProduction: 'Валове виробництво',
    netProduction: 'Чисте виробництво',
    collectionRate: 'Рівень збору',
    plansPresented: 'Представлено планів',
    accepted: 'Прийнято',
    acceptanceRate: 'Рівень прийняття',
    dueThisMonth: 'Заплановано на цей місяць',
    scheduled: 'Заплановано',
    completed: 'Завершено',
    overdue: 'Прострочено',
    reactivationRate: 'Рівень реактивації',

    // Medical History
    timeline: 'Хронологія',
    conditions: 'Стани',
    medications: 'Медикаменти',
    allergies: 'Алергії',
    labResults: 'Результати аналізів',
    vitals: 'Вітальні показники',
    immunizations: 'Імунізації',
    familyHistory: 'Сімейний анамнез',
    imaging: 'Візуалізація',
    documents: 'Документи',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Журнал аудиту',
    compliance: 'Відповідність',
    multiTenancy: 'Мультиорендність',
    sso: 'SSO та безпека',
    featureFlags: 'Прапорці функцій',
    apiManagement: 'Управління API',
    dataManagement: 'Управління даними',

    // Integrations
    ehr: 'ЕМК',
    labs: 'Лабораторії',
    telehealth: 'Телемедицина',
    aiMl: 'ІІ/МН',
    wearables: 'Носимі пристрої',
    connected: 'Підключено',
    disconnected: 'Відключено',
    available: 'Доступно',

    // Components
    status: 'Статус',
    healthy: 'Здоровий',
    caries: 'Карієс',
    restored: 'Відновлений',
    missing: 'Відсутній',
    implant: 'Імплант',
    crownStatus: 'Коронка',
    bridge: 'Міст',
    veneer: 'Вінір',
    surfaces: 'Поверхні',
    procedureHistory: 'Історія процедур',
    addProcedure: 'Додати процедуру',
    totalCharged: 'Всього нараховано',
    insurancePayment: 'Страховий платіж',
    patientResponsibility: 'Відповідальність пацієнта',
    expand: 'Розгорнути',
    policyNumber: 'Поліс №',
    planType: 'Тип плану',
    annualMax: 'Річний максимум',
    used: 'Використано',
    remaining: 'Залишок',
    coverageByCategory: 'Покриття за категоріями',
    preventive: 'Профілактика',
    basic: 'Базове',
    major: 'Основне',
    ortho: 'Ортодонтія',
    current: 'Поточні',
    thirtyDay: '30 днів',
    sixtyDay: '60 днів',
    ninetyPlus: '90+ днів',
    totalBalance: 'Загальний баланс',
    monthlyPayment: 'Щомісячний платіж',
    paymentsRemaining: 'Залишилось платежів',
    nextPayment: 'Наступний платіж',
    paymentProgress: 'Прогрес оплати',
    choosePlan: 'Обрати план',
    aiInsight: 'ІІ інсайт',
    confidence: 'Впевненість',
    revoke: 'Відкликати',
    exams: 'Огляди',
    phaseTotal: 'Підсумок фази',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Нд',
    thinking: 'Думаю...',
    followUpPlaceholder: 'Задайте додаткове запитання...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: 'Головна', features: 'Функції', pricing: 'Ціни', clinicsNav: 'Клініки', aiAssistant: 'AI Асистент', forBusiness: 'Для бізнесу', dashboard: 'Панель', getStarted: 'Почати', tryDemo: 'Спробувати демо', viewPitch: 'Презентація',
    heroTagline: 'Стоматологічна платформа для Грузії', heroTitle: 'Усі стоматологічні клініки', heroSubtitle: 'Ваш AI-асистент для пошуку найкращої стоматологічної допомоги в Грузії',
    searchPlaceholder: 'Пошук клінік, послуг або запитайте...', chipImplant: 'Кращі клініки імплантації у Тбілісі', chipWhitening: 'Відбілювання зубів поруч', chipEmergency: 'Екстрена стоматологічна допомога', chipOrtho: 'Ортодонтія для дорослих', scrollExplore: 'Прокрутіть для перегляду',
    topRated: 'Найкращі стоматологічні клініки Тбілісі', viewAllClinics: 'Всі клініки', shareLocation: 'Поділіться локацією', locationShared: 'Локацію отримано',
    statClinics: 'Клініки', statNoShows: 'Менше неявок', statBooking: 'Онлайн запис', statDentists: 'Стоматологи', statRating: 'Середній рейтинг', statPatients: 'Пацієнти',
    findClinics: 'Знайти клініки', forBusinessBtn: 'Для бізнесу', ownClinic: 'Ви власник стоматологічної клініки?', claimText: 'Зареєструйте свою клініку в нашій базі.', getListed: 'Зареєструватися →',
    clinicsTitle: 'Стоматологічні клініки в Грузії', verifiedClinics: 'перевірених клінік', searchByName: 'Пошук за назвою, районом або послугою...', hideMap: 'Сховати карту', showMap: 'Карта', nearMe: 'Поруч', clinicsMatch: 'клінік збігається', reviews: 'відгуків', loadingMore: 'Завантаження...',
    callClinic: 'Зателефонувати', bookAppointment: 'Записатися', services: 'Послуги', workingHours: 'Години роботи', priceRange: 'Діапазон цін', location: 'Розташування', visitWebsite: 'Перейти на сайт',
    bookingTitle: 'Запис на прийом', step: 'Крок', selectClinic: 'Оберіть клініку', selectService: 'Оберіть послугу', selectDate: 'Оберіть дату', selectTime: 'Оберіть час', confirm: 'Підтвердити', next: 'Далі', back: 'Назад', clinicsAvailable: 'клінік доступно', clinicsFound: 'клінік знайдено', confirmBooking: 'Підтвердити запис', bookingConfirmed: 'Ваш візит заброньовано!', patientName: "Ім'я пацієнта", phoneNumber: 'Номер телефону', email: 'Електронна пошта', notes: 'Примітки (необов\'язково)',
    businessHeroBadge: '15+ Модулів  ·  212+ Клінік  ·  Gemini AI',
    businessHeroTitle: 'Операційна система для стоматологічних клінік',
    businessHeroSubtitle: 'Клінічне картування, пародонтологічний аналіз, планування лікування, розклад, білінг, е-рецепти, управління лабораторією та ІІ-діагностика — все на одній платформі для Грузії.',
    theProblem: 'Проблема',
    problemSubtitle: 'Грузинські стоматологічні клініки щодня втрачають дохід через фрагментовані інструменти',
    excelChaos: 'Хаос Excel та WhatsApp',
    excelChaosDetail: 'Клініки керують записами через таблиці та чати. Нульова автоматизація, постійні помилки.',
    noShowRate: '25% неявок',
    noShowDetail: 'Без автоматичних нагадувань пацієнти забувають про візити. Порожні крісла — ₾500+/день втрат.',
    paperCharts: 'Паперові карти у 2026',
    paperChartsDetail: 'Рукописні клінічні записи, без цифрової одонтограми. Критичні дані замкнені у шафах.',
    insuranceBlackHole: 'Чорна діра страхування',
    insuranceDetail: 'Ручні претензії до Aldagi, GPI, Imedi L займають години. Відхилені претензії накопичуються.',
    oneplatform: 'Одна платформа, всі модулі',
    platformSubtitle: '15 інтегрованих модулів для стоматологічної практики',
    clinical: 'КЛІНІЧНІ',
    operations: 'ОПЕРАЦІЙНІ',
    analyticsEnterprise: 'АНАЛІТИКА ТА ENTERPRISE',
    digitalOdontogram: 'Цифрова одонтограма',
    digitalOdontogramDetail: 'FDI 32-зубна карта з 5-поверхневим відстеженням.',
    perioCharting: 'Пародонтологічне картування',
    perioChartingDetail: '192-точкова пародонтологічна сітка. 6-точкове зондування, BOP, CAL.',
    treatmentPlanning: 'Планування лікування',
    treatmentPlanningDetail: 'Фазові плани з CDT-кодами, страховими оцінками. ІІ-секвенування.',
    soapNotes: 'SOAP записи + ІІ скрайб',
    soapNotesDetail: 'Структурована клінічна документація з шаблонами. Gemini генерує записи з голосу.',
    multiChairScheduling: 'Багатокрісельний розклад',
    multiChairDetail: 'Тижневий вигляд з кількома кабінетами. Кольорове кодування лікарів.',
    billingInsurance: 'Білінг та страхування',
    billingDetail: 'Відстеження претензій для Aldagi, GPI, Imedi L. Бухгалтерія, плани оплати.',
    ePrescribing: 'Електронні рецепти',
    ePrescribingDetail: 'Цифрові рецепти з шаблонами. Перевірка взаємодій ліків через Gemini.',
    labTracking: 'Відстеження лабораторії',
    labTrackingDetail: 'Канбан: Замовлено → Виготовлення → Відправлено → Отримано.',
    productionReports: 'Звіти виробництва',
    productionReportsDetail: 'Валове/чисте виробництво, рівень збору, прийняття лікування.',
    referralMgmt: 'Управління направленнями',
    referralMgmtDetail: 'Вхідні/вихідні направлення до спеціалістів. ІІ-генеровані листи.',
    medicalHistory: 'Медична історія',
    medicalHistoryDetail: '11-видова карта пацієнта: хронологія, стани, медикаменти, алергії.',
    enterpriseAdmin: 'Enterprise адмін',
    enterpriseAdminDetail: 'RBAC, журнал аудиту, відповідність, мультиорендність, SSO, управління API.',
    geminiBuiltIn: 'Вбудований Gemini AI',
    geminiSubtitle: 'Кожен модуль працює на Google Gemini 3.1',
    xrayAnalysis: 'Аналіз рентгену',
    xrayDetail: 'Завантажте стоматологічні рентгенограми для ІІ-діагностики карієсу.',
    perioAssessment: 'Пародонтологічна оцінка',
    perioAssessmentDetail: 'Автоматичне стадіювання/градування AAP за даними зондування.',
    clinicalScribe: 'Клінічний скрайб',
    clinicalScribeDetail: 'Генерація SOAP-записів з голосових записів або даних карти.',
    riskProfiling: 'Профілювання ризиків',
    riskProfilingDetail: 'Аналіз станів, сімейного анамнезу для створення профілю стоматологічного ризику.',
    treatmentSequencing: 'Секвенування лікування',
    treatmentSequencingDetail: 'ІІ-оптимізоване фазування лікування з урахуванням загоєння та страхування.',
    patientComm: 'Комунікація з пацієнтом',
    patientCommDetail: 'Генерація зрозумілих пацієнту пояснень грузинською мовою.',
    georgianEcosystem: 'Готово для грузинської екосистеми',
    integrationsSubtitle: 'Передустановлені інтеграції з місцевим страхуванням, платежами та месенджерами',
    insurance: 'СТРАХУВАННЯ',
    payments: 'ПЛАТЕЖІ',
    messaging: 'ПОВІДОМЛЕННЯ',
    ehrLabs: 'ЕМК ТА ЛАБОРАТОРІЇ',
    clinicsInDb: 'Клінік у базі',
    platformModules: 'Модулів платформи',
    aiTools: 'ІІ-інструментів (Gemini)',
    integrations: 'Інтеграцій',
    pricingTitle: 'Ціни',
    pricingSubtitle: 'Почніть безкоштовно',
    trustedBy: 'Довіра клінік',
    readyModernize: 'Готові до модернізації?',
    joinCount: 'Приєднуйтесь до 212+ клінік у Грузії.',
    startTrial: 'Почати безкоштовно',
    contactSales: "Зв'язатися з продажами",
    noCreditCard: 'Без кредитної картки  ·  Безкоштовний тариф  ·  Налаштування за 5 хвилин',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Панель',
    navPatients: 'Пацієнти',
    navChart: 'Карта',
    navPerio: 'Пародонтологія',
    navTreatmentPlans: 'Плани лікування',
    navNotes: 'Записи',
    navScheduling: 'Розклад',
    navBilling: 'Білінг',
    navPrescriptions: 'Рецепти',
    navLabCases: 'Лабораторні випадки',
    navReferrals: 'Направлення',
    navReports: 'Звіти',
    navMedHistory: 'Медична історія',
    navIntegrations: 'Інтеграції',
    navEnterprise: 'Підприємство',
    sectionClinical: 'КЛІНІКА',
    sectionOperations: 'ОПЕРАЦІЇ',
    sectionAnalytics: 'АНАЛІТИКА',
    sectionAiTools: 'ІІ ІНСТРУМЕНТИ',
    sectionAdmin: 'АДМІНІСТРУВАННЯ',

    // Booking Page
    chooseClinic: 'Оберіть клініку',
    selectAService: 'Оберіть послугу',
    pickADate: 'Оберіть дату',
    pickATime: 'Оберіть час',
    confirmYourBooking: 'Підтвердіть запис',
    clinicLabel: 'Клініка:',
    serviceLabel: 'Послуга:',
    dateLabel: 'Дата:',
    timeLabel: 'Час:',

    // AI Page
    send: 'Надіслати',
    procedure: 'Процедура',
    observations: 'Спостереження',
    aiThinking: 'ІІ думає...',
    summarizeHistory: 'Узагальнити історію пацієнта',
    generateTxPlan: 'Згенерувати план лікування',
    checkDrugInteractions: 'Перевірити взаємодію ліків',
    writeClinicalNote: 'Написати клінічний запис',
    askAiAssistant: 'Запитайте ІІ-асистента...',
    dropXray: 'Перетягніть рентген або натисніть для завантаження',
    supportsFormats: 'Підтримуються DICOM, PNG, JPG',
    analysisResults: 'Результати аналізу (демо)',
    aiRecommendation: 'Рекомендація ІІ',
    exportToTxPlan: 'Експорт у план лікування',
    generateClinicalNote: 'Згенерувати клінічний запис',
    generatedSoap: 'Згенерований клінічний запис (SOAP)',
    subjective: 'S — Суб\'єктивне',
    objective: 'O — Об\'єктивне',
    assessment: 'A — Оцінка',
    plan: 'P — План',
    copyToRecord: 'Скопіювати до карти пацієнта',
    aiPerioAssessment: 'ІІ пародонтологічна оцінка',
    enterProbingData: 'Введіть дані зондування для AAP стадіювання та рекомендацій лікування.',
    analyzeWithGemini: 'Аналізувати з Gemini',
    aiRiskAssessment: 'ІІ оцінка ризиків',
    enterConditions: 'Введіть стан пацієнта, сімейний анамнез та вітальні показники для генерації профілю ризику.',
    generateRiskProfile: 'Згенерувати профіль ризику',
    patientCommunication: 'Комунікація з пацієнтом',
    generateExplanations: 'Генерація зрозумілих пацієнту пояснень лікування грузинською або англійською.',
    generateExplanation: 'Згенерувати пояснення',
    patientFriendly: 'Зрозуміле пацієнту пояснення',

    // Billing Page
    claims: 'Претензії',
    ledger: 'Бухгалтерська книга',
    aging: 'Старіння заборгованості',
    paymentPlans: 'Плани оплати',
    eligibility: 'Право на страхування',
    allFilter: 'Усі',
    submitted: 'Надіслано',
    paid: 'Оплачено',
    denied: 'Відхилено',
    patientLedger: 'Бухгалтерія пацієнта',
    agedAccounts: 'Прострочені рахунки',
    sendStatements: 'Надіслати виписки',
    activePaymentPlans: 'Активні плани оплати',
    insuranceEligibility: 'Страхове право',

    // Clinical Charting
    odontogram: 'Одонтограма',
    perioTab: 'Пародонтологія',
    treatmentPlanTab: 'План лікування',
    notesTab: 'Записи',
    progressNotes: 'Записи про прогрес',
    openFullPerio: 'Відкрити повну пародонтологічну карту →',
    openFullTxPlanner: 'Відкрити повний планувальник лікування →',
    openClinicalNotes: 'Відкрити клінічні записи →',
    newExam: 'Новий огляд',
    voiceEntry: 'Голосовий ввід',
    bleedingIndex: 'Індекс кровоточивості',
    plaqueIndex: 'Індекс нальоту',
    sitesAbove4: 'Ділянки ≥ 4мм',
    sitesAbove6: 'Ділянки ≥ 6мм',
    planA: 'План A: Рекомендований',
    planB: 'План B: Консервативний',
    newPlan: '+ Новий план',
    presentToPatient: 'Представити пацієнту',
    sendToPortal: 'Надіслати на портал',
    totalFee: 'Загальна вартість',
    insuranceEst: 'Оцінка страховки',
    patientPortion: 'Частка пацієнта',
    chairSideMode: 'Режим біля крісла',
    adminMode: 'Режим адміна',
    proceduresAcrossPhases: '{0} процедур у {1} фазах',

    // Scheduling
    day: 'День',
    week: 'Тиждень',
    today: 'Сьогодні',
    providerFilter: 'Усі лікарі',
    productionGoal: 'Ціль виробництва',
    waitlist: 'Лист очікування',

    // Prescriptions
    activeRx: 'Активні',
    pastRx: 'Минулі',
    templates: 'Шаблони',
    interactionCheck: 'Перевірка взаємодій',

    // Lab Cases
    ordered: 'Замовлено',
    sentToLab: 'Надіслано до лабораторії',
    inFabrication: 'У виготовленні',
    shipped: 'Відправлено',
    received: 'Отримано',
    labVendors: 'Постачальники лабораторій',

    // Referrals
    allDirections: 'Усі',
    inbound: 'Вхідні',
    outbound: 'Вихідні',
    generateLetter: 'Згенерувати лист',

    // Reports
    production: 'Виробництво',
    collections: 'Збори',
    schedulingReport: 'Розклад',
    treatmentAcceptance: 'Прийняття лікування',
    recall: 'Повторний виклик',
    grossProduction: 'Валове виробництво',
    netProduction: 'Чисте виробництво',
    collectionRate: 'Рівень збору',
    plansPresented: 'Представлено планів',
    accepted: 'Прийнято',
    acceptanceRate: 'Рівень прийняття',
    dueThisMonth: 'Заплановано на цей місяць',
    scheduled: 'Заплановано',
    completed: 'Завершено',
    overdue: 'Прострочено',
    reactivationRate: 'Рівень реактивації',

    // Medical History
    timeline: 'Хронологія',
    conditions: 'Стани',
    medications: 'Медикаменти',
    allergies: 'Алергії',
    labResults: 'Результати аналізів',
    vitals: 'Вітальні показники',
    immunizations: 'Імунізації',
    familyHistory: 'Сімейний анамнез',
    imaging: 'Візуалізація',
    documents: 'Документи',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Журнал аудиту',
    compliance: 'Відповідність',
    multiTenancy: 'Мультиорендність',
    sso: 'SSO та безпека',
    featureFlags: 'Прапорці функцій',
    apiManagement: 'Управління API',
    dataManagement: 'Управління даними',

    // Integrations
    ehr: 'ЕМК',
    labs: 'Лабораторії',
    telehealth: 'Телемедицина',
    aiMl: 'ІІ/МН',
    wearables: 'Носимі пристрої',
    connected: 'Підключено',
    disconnected: 'Відключено',
    available: 'Доступно',

    // Components
    status: 'Статус',
    healthy: 'Здоровий',
    caries: 'Карієс',
    restored: 'Відновлений',
    missing: 'Відсутній',
    implant: 'Імплант',
    crownStatus: 'Коронка',
    bridge: 'Міст',
    veneer: 'Вінір',
    surfaces: 'Поверхні',
    procedureHistory: 'Історія процедур',
    addProcedure: 'Додати процедуру',
    totalCharged: 'Всього нараховано',
    insurancePayment: 'Страховий платіж',
    patientResponsibility: 'Відповідальність пацієнта',
    expand: 'Розгорнути',
    policyNumber: 'Поліс №',
    planType: 'Тип плану',
    annualMax: 'Річний максимум',
    used: 'Використано',
    remaining: 'Залишок',
    coverageByCategory: 'Покриття за категоріями',
    preventive: 'Профілактика',
    basic: 'Базове',
    major: 'Основне',
    ortho: 'Ортодонтія',
    current: 'Поточні',
    thirtyDay: '30 днів',
    sixtyDay: '60 днів',
    ninetyPlus: '90+ днів',
    totalBalance: 'Загальний баланс',
    monthlyPayment: 'Щомісячний платіж',
    paymentsRemaining: 'Залишилось платежів',
    nextPayment: 'Наступний платіж',
    paymentProgress: 'Прогрес оплати',
    choosePlan: 'Обрати план',
    aiInsight: 'ІІ інсайт',
    confidence: 'Впевненість',
    revoke: 'Відкликати',
    exams: 'Огляди',
    phaseTotal: 'Підсумок фази',
    mon: 'Пн',
    tue: 'Вт',
    wed: 'Ср',
    thu: 'Чт',
    fri: 'Пт',
    sat: 'Сб',
    sun: 'Нд',
    thinking: 'Думаю...',
    followUpPlaceholder: 'Задайте додаткове запитання...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  },

  tr: {
    home: 'Ana Sayfa', features: 'Özellikler', pricing: 'Fiyatlar', clinicsNav: 'Klinikler', aiAssistant: 'AI Asistan', forBusiness: 'İşletmeler İçin', dashboard: 'Panel', getStarted: 'Başla', tryDemo: 'Demoyu Dene', viewPitch: 'Sunumu Gör',
    heroTagline: 'Gürcistan için Diş Hekimliği Platformu', heroTitle: 'Tüm diş klinikleri merkezi', heroSubtitle: "Gürcistan'da en iyi diş bakımını bulmak için AI asistanınız",
    searchPlaceholder: 'Klinik, hizmet arayın veya soru sorun...', chipImplant: "Tiflis'teki en iyi implant klinikleri", chipWhitening: 'Yakınımdaki diş beyazlatma', chipEmergency: 'Acil diş bakımı', chipOrtho: 'Yetişkinler için ortodonti', scrollExplore: 'Keşfetmek için kaydırın',
    topRated: "Tiflis'in en iyi diş klinikleri", viewAllClinics: 'Tüm klinikler', shareLocation: 'Yakın klinikler için konum paylaş', locationShared: 'Konum paylaşıldı',
    statClinics: 'Klinikler', statNoShows: 'Daha az iptal', statBooking: 'Online randevu', statDentists: 'Diş Hekimi', statRating: 'Ort. Puan', statPatients: 'Hastalar',
    findClinics: 'En İyi Klinikleri Bul', forBusinessBtn: 'İşletmeler İçin', clinicsTitle: "Gürcistan'daki Diş Klinikleri", verifiedClinics: 'onaylı klinik', searchByName: 'İsim, bölge veya hizmete göre arayın...', reviews: 'yorum', loadingMore: 'Yükleniyor...',
    callClinic: 'Ara', bookAppointment: 'Randevu Al', services: 'Hizmetler', workingHours: 'Çalışma Saatleri', priceRange: 'Fiyat Aralığı', location: 'Konum', visitWebsite: 'Siteyi Ziyaret Et',
    bookingTitle: 'Randevu Al', step: 'Adım', selectClinic: 'Klinik Seçin', selectService: 'Hizmet Seçin', selectDate: 'Tarih Seçin', selectTime: 'Saat Seçin', confirm: 'Onayla', next: 'İleri', back: 'Geri', clinicsAvailable: 'klinik mevcut', confirmBooking: 'Randevuyu Onayla', patientName: 'Hasta Adı', phoneNumber: 'Telefon Numarası', email: 'E-posta',
    ownClinic: 'Bir diş kliniğiniz mi var?',
    claimText: 'Kliniğinizi veritabanımıza kaydedin veya ekleyin.',
    getListed: 'Kaydolun →',
    hideMap: 'Haritayı Gizle',
    showMap: 'Harita',
    nearMe: 'Yakınımda',
    clinicsMatch: 'klinik eşleşiyor',
    clinicsFound: 'klinik bulundu',
    bookingConfirmed: 'Randevunuz onaylandı!',
    notes: 'Notlar (isteğe bağlı)',
    businessHeroBadge: '15+ Modül  ·  212+ Klinik  ·  Gemini AI',
    businessHeroTitle: 'Diş Klinikleri İçin İşletim Sistemi',
    businessHeroSubtitle: 'Klinik kartlama, periodontal analiz, tedavi planlaması, planlama, faturalandırma, e-reçete, laboratuvar yönetimi ve AI tanı — Gürcistan için tek platformda.',
    theProblem: 'Sorun',
    problemSubtitle: 'Gürcistan diş klinikleri parçalı araçlar nedeniyle günlük gelir kaybediyor',
    excelChaos: 'Excel ve WhatsApp Kaosu',
    excelChaosDetail: 'Klinikler randevuları tablolar ve sohbet gruplarıyla yönetiyor. Sıfır otomasyon, sürekli hatalar.',
    noShowRate: '%25 İptal Oranı',
    noShowDetail: 'Otomatik hatırlatmalar olmadan hastalar randevuları unutuyor. Boş koltuklar günde ₾500+ kayıp.',
    paperCharts: '2026\'da Kağıt Kartlar',
    paperChartsDetail: 'El yazısı klinik notlar, dijital odontogram yok. Kritik veriler dosya dolaplarında kilitli.',
    insuranceBlackHole: 'Sigorta Kara Deliği',
    insuranceDetail: 'Aldagi, GPI, Imedi L\'ye manuel talepler saatler sürüyor. Reddedilen talepler birikiyor.',
    oneplatform: 'Tek Platform, Her Modül',
    platformSubtitle: 'Diş hekimliği uygulamaları için 15 entegre modül',
    clinical: 'KLİNİK',
    operations: 'OPERASYONLAR',
    analyticsEnterprise: 'ANALİTİK VE KURUMSAL',
    digitalOdontogram: 'Dijital Odontogram',
    digitalOdontogramDetail: 'FDI 32 dişli kart, 5 yüzey takibi.',
    perioCharting: 'Periodontal Kartlama',
    perioChartingDetail: '192 noktalı periodontal ızgara. 6 noktalı sondaj, BOP, CAL.',
    treatmentPlanning: 'Tedavi Planlaması',
    treatmentPlanningDetail: 'CDT kodlarıyla faz planları, sigorta tahminleri. AI sekanslaması.',
    soapNotes: 'SOAP Notları + AI Yazıcı',
    soapNotesDetail: 'Şablonlarla yapılandırılmış klinik dokümantasyon. Gemini sesten not üretiyor.',
    multiChairScheduling: 'Çoklu Koltuk Planlaması',
    multiChairDetail: 'Birden fazla operatoryumlu haftalık görünüm. Doktor renk kodlaması.',
    billingInsurance: 'Faturalandırma ve Sigorta',
    billingDetail: 'Aldagi, GPI, Imedi L için talep takibi. Hasta defteri, ödeme planları.',
    ePrescribing: 'E-Reçete',
    ePrescribingDetail: 'Şablonlarla dijital reçeteler. Gemini ile ilaç etkileşim kontrolü.',
    labTracking: 'Laboratuvar Takibi',
    labTrackingDetail: 'Kanban: Sipariş → Üretim → Gönderim → Teslim.',
    productionReports: 'Üretim Raporları',
    productionReportsDetail: 'Brüt/net üretim, tahsilat oranları, tedavi kabulü.',
    referralMgmt: 'Sevk Yönetimi',
    referralMgmtDetail: 'Uzmanlara gelen/giden sevkler. AI ile oluşturulan mektuplar.',
    medicalHistory: 'Tıbbi Geçmiş',
    medicalHistoryDetail: '11 görünümlü hasta kaydı: zaman çizelgesi, durumlar, ilaçlar, alerjiler.',
    enterpriseAdmin: 'Kurumsal Yönetim',
    enterpriseAdminDetail: 'RBAC, denetim günlüğü, uyumluluk, çoklu kiracılık, SSO, API yönetimi.',
    geminiBuiltIn: 'Yerleşik Gemini AI',
    geminiSubtitle: 'Her modül Google Gemini 3.1 ile çalışır',
    xrayAnalysis: 'Röntgen Analizi',
    xrayDetail: 'AI çürük tespiti için diş röntgenlerini yükleyin.',
    perioAssessment: 'Periodontal Değerlendirme',
    perioAssessmentDetail: 'Sondaj verilerinden otomatik AAP evreleme/derecelendirme.',
    clinicalScribe: 'Klinik Yazıcı',
    clinicalScribeDetail: 'Ses kayıtlarından veya kart verilerinden SOAP not üretimi.',
    riskProfiling: 'Risk Profilleme',
    riskProfilingDetail: 'Diş riski profili için durumlar, aile geçmişi analizi.',
    treatmentSequencing: 'Tedavi Sekanslama',
    treatmentSequencingDetail: 'İyileşme ve sigortayı dikkate alan AI optimizeli tedavi fazlaması.',
    patientComm: 'Hasta İletişimi',
    patientCommDetail: 'Gürcüce hasta dostu açıklamalar üretimi.',
    georgianEcosystem: 'Gürcistan Ekosistemi Hazır',
    integrationsSubtitle: 'Yerel sigorta, ödeme ve mesajlaşma ile önceden oluşturulmuş entegrasyonlar',
    insurance: 'SİGORTA',
    payments: 'ÖDEMELER',
    messaging: 'MESAJLAŞMA',
    ehrLabs: 'EHR VE LABORATUVARLAR',
    clinicsInDb: 'Veritabanındaki Klinikler',
    platformModules: 'Platform Modülleri',
    aiTools: 'AI Araçları (Gemini)',
    integrations: 'Entegrasyonlar',
    pricingTitle: 'Fiyatlar',
    pricingSubtitle: 'Ücretsiz başlayın',
    trustedBy: 'Kliniklerin Güveni',
    readyModernize: 'Modernleşmeye hazır mısınız?',
    joinCount: "Gürcistan'daki 212+ kliniğe katılın.",
    startTrial: 'Ücretsiz Dene',
    contactSales: 'Satışla İletişim',
    noCreditCard: 'Kredi kartı gerekmez  ·  Ücretsiz plan  ·  5 dakikada kurulum',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Panel',
    navPatients: 'Hastalar',
    navChart: 'Kart',
    navPerio: 'Periodontoloji',
    navTreatmentPlans: 'Tedavi Planları',
    navNotes: 'Notlar',
    navScheduling: 'Planlama',
    navBilling: 'Faturalandırma',
    navPrescriptions: 'Reçeteler',
    navLabCases: 'Laboratuvar Vakaları',
    navReferrals: 'Sevkler',
    navReports: 'Raporlar',
    navMedHistory: 'Tıbbi Geçmiş',
    navIntegrations: 'Entegrasyonlar',
    navEnterprise: 'Kurumsal',
    sectionClinical: 'KLİNİK',
    sectionOperations: 'OPERASYONLAR',
    sectionAnalytics: 'ANALİTİK',
    sectionAiTools: 'AI ARAÇLARI',
    sectionAdmin: 'YÖNETİM',

    // Booking Page
    chooseClinic: 'Klinik Seçin',
    selectAService: 'Hizmet Seçin',
    pickADate: 'Tarih Seçin',
    pickATime: 'Saat Seçin',
    confirmYourBooking: 'Randevunuzu Onaylayın',
    clinicLabel: 'Klinik:',
    serviceLabel: 'Hizmet:',
    dateLabel: 'Tarih:',
    timeLabel: 'Saat:',

    // AI Page
    send: 'Gönder',
    procedure: 'Prosedür',
    observations: 'Gözlemler',
    aiThinking: 'AI düşünüyor...',
    summarizeHistory: 'Hasta geçmişini özetle',
    generateTxPlan: 'Tedavi planı oluştur',
    checkDrugInteractions: 'İlaç etkileşimlerini kontrol et',
    writeClinicalNote: 'Klinik not yaz',
    askAiAssistant: 'AI asistana sorun...',
    dropXray: 'Röntgen görüntüsünü bırakın veya yüklemek için tıklayın',
    supportsFormats: 'DICOM, PNG, JPG desteklenir',
    analysisResults: 'Analiz Sonuçları (Demo)',
    aiRecommendation: 'AI Önerisi',
    exportToTxPlan: 'Tedavi Planına Aktar',
    generateClinicalNote: 'Klinik Not Oluştur',
    generatedSoap: 'Oluşturulan Klinik Not (SOAP)',
    subjective: 'S — Subjektif',
    objective: 'O — Objektif',
    assessment: 'A — Değerlendirme',
    plan: 'P — Plan',
    copyToRecord: 'Hasta Kaydına Kopyala',
    aiPerioAssessment: 'AI Periodontal Değerlendirme',
    enterProbingData: 'AAP evreleme/derecelendirme ve tedavi önerileri için sondaj verilerini girin.',
    analyzeWithGemini: 'Gemini ile Analiz Et',
    aiRiskAssessment: 'AI Risk Değerlendirmesi',
    enterConditions: 'Risk profili oluşturmak için hasta durumlarını, aile geçmişini ve vital bulgularını girin.',
    generateRiskProfile: 'Risk Profili Oluştur',
    patientCommunication: 'Hasta İletişimi',
    generateExplanations: 'Gürcüce veya İngilizce hasta dostu tedavi açıklamaları oluşturun.',
    generateExplanation: 'Açıklama Oluştur',
    patientFriendly: 'Hasta Dostu Açıklama',

    // Billing Page
    claims: 'Talepler',
    ledger: 'Muhasebe Defteri',
    aging: 'Yaşlandırma',
    paymentPlans: 'Ödeme Planları',
    eligibility: 'Uygunluk',
    allFilter: 'Tümü',
    submitted: 'Gönderildi',
    paid: 'Ödendi',
    denied: 'Reddedildi',
    patientLedger: 'Hasta Muhasebesi',
    agedAccounts: 'Vadesi Geçmiş Hesaplar',
    sendStatements: 'Hesap Özetlerini Gönder',
    activePaymentPlans: 'Aktif Ödeme Planları',
    insuranceEligibility: 'Sigorta Uygunluğu',

    // Clinical Charting
    odontogram: 'Odontogram',
    perioTab: 'Periodontoloji',
    treatmentPlanTab: 'Tedavi Planı',
    notesTab: 'Notlar',
    progressNotes: 'İlerleme Notları',
    openFullPerio: 'Tam Periodontal Kartı Aç →',
    openFullTxPlanner: 'Tam Tedavi Planlayıcısını Aç →',
    openClinicalNotes: 'Klinik Notları Aç →',
    newExam: 'Yeni Muayene',
    voiceEntry: 'Sesli Giriş',
    bleedingIndex: 'Kanama İndeksi',
    plaqueIndex: 'Plak İndeksi',
    sitesAbove4: 'Bölgeler ≥ 4mm',
    sitesAbove6: 'Bölgeler ≥ 6mm',
    planA: 'Plan A: Önerilen',
    planB: 'Plan B: Konservatif',
    newPlan: '+ Yeni Plan',
    presentToPatient: 'Hastaya Sun',
    sendToPortal: 'Portala Gönder',
    totalFee: 'Toplam Ücret',
    insuranceEst: 'Sigorta Tahmini',
    patientPortion: 'Hasta Payı',
    chairSideMode: 'Koltuk Modu',
    adminMode: 'Yönetici Modu',
    proceduresAcrossPhases: '{1} fazda {0} işlem',

    // Scheduling
    day: 'Gün',
    week: 'Hafta',
    today: 'Bugün',
    providerFilter: 'Tüm Sağlayıcılar',
    productionGoal: 'Üretim Hedefi',
    waitlist: 'Bekleme Listesi',

    // Prescriptions
    activeRx: 'Aktif',
    pastRx: 'Geçmiş',
    templates: 'Şablonlar',
    interactionCheck: 'Etkileşim Kontrolü',

    // Lab Cases
    ordered: 'Sipariş Verildi',
    sentToLab: 'Laboratuvara Gönderildi',
    inFabrication: 'Üretimde',
    shipped: 'Gönderildi',
    received: 'Teslim Alındı',
    labVendors: 'Laboratuvar Tedarikçileri',

    // Referrals
    allDirections: 'Tümü',
    inbound: 'Gelen',
    outbound: 'Giden',
    generateLetter: 'Mektup Oluştur',

    // Reports
    production: 'Üretim',
    collections: 'Tahsilatlar',
    schedulingReport: 'Planlama',
    treatmentAcceptance: 'Tedavi Kabulü',
    recall: 'Geri Çağırma',
    grossProduction: 'Brüt Üretim',
    netProduction: 'Net Üretim',
    collectionRate: 'Tahsilat Oranı',
    plansPresented: 'Sunulan Planlar',
    accepted: 'Kabul Edildi',
    acceptanceRate: 'Kabul Oranı',
    dueThisMonth: 'Bu Ay Planlanan',
    scheduled: 'Planlandı',
    completed: 'Tamamlandı',
    overdue: 'Gecikmiş',
    reactivationRate: 'Reaktivasyon Oranı',

    // Medical History
    timeline: 'Zaman Çizelgesi',
    conditions: 'Durumlar',
    medications: 'İlaçlar',
    allergies: 'Alerjiler',
    labResults: 'Laboratuvar Sonuçları',
    vitals: 'Vital Bulgular',
    immunizations: 'Aşılar',
    familyHistory: 'Aile Geçmişi',
    imaging: 'Görüntüleme',
    documents: 'Belgeler',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Denetim Günlüğü',
    compliance: 'Uyumluluk',
    multiTenancy: 'Çoklu Kiracılık',
    sso: 'SSO ve Güvenlik',
    featureFlags: 'Özellik Bayrakları',
    apiManagement: 'API Yönetimi',
    dataManagement: 'Veri Yönetimi',

    // Integrations
    ehr: 'EHR',
    labs: 'Laboratuvarlar',
    telehealth: 'Telesağlık',
    aiMl: 'AI/ML',
    wearables: 'Giyilebilir Cihazlar',
    connected: 'Bağlı',
    disconnected: 'Bağlantı Kesildi',
    available: 'Mevcut',

    // Components
    status: 'Durum',
    healthy: 'Sağlıklı',
    caries: 'Çürük',
    restored: 'Restore Edilmiş',
    missing: 'Eksik',
    implant: 'İmplant',
    crownStatus: 'Kron',
    bridge: 'Köprü',
    veneer: 'Veneer',
    braces: 'Braces',
    surfaces: 'Yüzeyler',
    procedureHistory: 'İşlem Geçmişi',
    addProcedure: 'İşlem Ekle',
    totalCharged: 'Toplam Borç',
    insurancePayment: 'Sigorta Ödemesi',
    patientResponsibility: 'Hasta Sorumluluğu',
    expand: 'Genişlet',
    policyNumber: 'Poliçe No',
    planType: 'Plan Türü',
    annualMax: 'Yıllık Maksimum',
    used: 'Kullanılan',
    remaining: 'Kalan',
    coverageByCategory: 'Kategoriye Göre Kapsam',
    preventive: 'Önleyici',
    basic: 'Temel',
    major: 'Büyük',
    ortho: 'Ortodonti',
    current: 'Güncel',
    thirtyDay: '30 Gün',
    sixtyDay: '60 Gün',
    ninetyPlus: '90+ Gün',
    totalBalance: 'Toplam Bakiye',
    monthlyPayment: 'Aylık Ödeme',
    paymentsRemaining: 'Kalan Ödemeler',
    nextPayment: 'Sonraki Ödeme',
    paymentProgress: 'Ödeme İlerlemesi',
    choosePlan: 'Plan Seç',
    aiInsight: 'AI İçgörüsü',
    confidence: 'Güven',
    revoke: 'İptal Et',
    exams: 'Muayeneler',
    phaseTotal: 'Faz Toplamı',
    mon: 'Pzt',
    tue: 'Sal',
    wed: 'Çar',
    thu: 'Per',
    fri: 'Cum',
    sat: 'Cmt',
    sun: 'Paz',
    thinking: 'Düşünüyor...',
    followUpPlaceholder: 'Takip sorusu sorun...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: 'Ana Sayfa', features: 'Özellikler', pricing: 'Fiyatlar', clinicsNav: 'Klinikler', aiAssistant: 'AI Asistan', forBusiness: 'İşletmeler İçin', dashboard: 'Panel', getStarted: 'Başla', tryDemo: 'Demoyu Dene', viewPitch: 'Sunumu Gör',
    heroTagline: 'Gürcistan için Diş Hekimliği Platformu', heroTitle: 'Tüm diş klinikleri merkezi', heroSubtitle: "Gürcistan'da en iyi diş bakımını bulmak için AI asistanınız",
    searchPlaceholder: 'Klinik, hizmet arayın veya soru sorun...', chipImplant: "Tiflis'teki en iyi implant klinikleri", chipWhitening: 'Yakınımdaki diş beyazlatma', chipEmergency: 'Acil diş bakımı', chipOrtho: 'Yetişkinler için ortodonti', scrollExplore: 'Keşfetmek için kaydırın',
    topRated: "Tiflis'in en iyi diş klinikleri", viewAllClinics: 'Tüm klinikler', shareLocation: 'Yakın klinikler için konum paylaş', locationShared: 'Konum paylaşıldı',
    statClinics: 'Klinikler', statNoShows: 'Daha az iptal', statBooking: 'Online randevu', statDentists: 'Diş Hekimi', statRating: 'Ort. Puan', statPatients: 'Hastalar',
    findClinics: 'En İyi Klinikleri Bul', forBusinessBtn: 'İşletmeler İçin', clinicsTitle: "Gürcistan'daki Diş Klinikleri", verifiedClinics: 'onaylı klinik', searchByName: 'İsim, bölge veya hizmete göre arayın...', reviews: 'yorum', loadingMore: 'Yükleniyor...',
    callClinic: 'Ara', bookAppointment: 'Randevu Al', services: 'Hizmetler', workingHours: 'Çalışma Saatleri', priceRange: 'Fiyat Aralığı', location: 'Konum', visitWebsite: 'Siteyi Ziyaret Et',
    bookingTitle: 'Randevu Al', step: 'Adım', selectClinic: 'Klinik Seçin', selectService: 'Hizmet Seçin', selectDate: 'Tarih Seçin', selectTime: 'Saat Seçin', confirm: 'Onayla', next: 'İleri', back: 'Geri', clinicsAvailable: 'klinik mevcut', confirmBooking: 'Randevuyu Onayla', patientName: 'Hasta Adı', phoneNumber: 'Telefon Numarası', email: 'E-posta',
    ownClinic: 'Bir diş kliniğiniz mi var?',
    claimText: 'Kliniğinizi veritabanımıza kaydedin veya ekleyin.',
    getListed: 'Kaydolun →',
    hideMap: 'Haritayı Gizle',
    showMap: 'Harita',
    nearMe: 'Yakınımda',
    clinicsMatch: 'klinik eşleşiyor',
    clinicsFound: 'klinik bulundu',
    bookingConfirmed: 'Randevunuz onaylandı!',
    notes: 'Notlar (isteğe bağlı)',
    businessHeroBadge: '15+ Modül  ·  212+ Klinik  ·  Gemini AI',
    businessHeroTitle: 'Diş Klinikleri İçin İşletim Sistemi',
    businessHeroSubtitle: 'Klinik kartlama, periodontal analiz, tedavi planlaması, planlama, faturalandırma, e-reçete, laboratuvar yönetimi ve AI tanı — Gürcistan için tek platformda.',
    theProblem: 'Sorun',
    problemSubtitle: 'Gürcistan diş klinikleri parçalı araçlar nedeniyle günlük gelir kaybediyor',
    excelChaos: 'Excel ve WhatsApp Kaosu',
    excelChaosDetail: 'Klinikler randevuları tablolar ve sohbet gruplarıyla yönetiyor. Sıfır otomasyon, sürekli hatalar.',
    noShowRate: '%25 İptal Oranı',
    noShowDetail: 'Otomatik hatırlatmalar olmadan hastalar randevuları unutuyor. Boş koltuklar günde ₾500+ kayıp.',
    paperCharts: '2026\'da Kağıt Kartlar',
    paperChartsDetail: 'El yazısı klinik notlar, dijital odontogram yok. Kritik veriler dosya dolaplarında kilitli.',
    insuranceBlackHole: 'Sigorta Kara Deliği',
    insuranceDetail: 'Aldagi, GPI, Imedi L\'ye manuel talepler saatler sürüyor. Reddedilen talepler birikiyor.',
    oneplatform: 'Tek Platform, Her Modül',
    platformSubtitle: 'Diş hekimliği uygulamaları için 15 entegre modül',
    clinical: 'KLİNİK',
    operations: 'OPERASYONLAR',
    analyticsEnterprise: 'ANALİTİK VE KURUMSAL',
    digitalOdontogram: 'Dijital Odontogram',
    digitalOdontogramDetail: 'FDI 32 dişli kart, 5 yüzey takibi.',
    perioCharting: 'Periodontal Kartlama',
    perioChartingDetail: '192 noktalı periodontal ızgara. 6 noktalı sondaj, BOP, CAL.',
    treatmentPlanning: 'Tedavi Planlaması',
    treatmentPlanningDetail: 'CDT kodlarıyla faz planları, sigorta tahminleri. AI sekanslaması.',
    soapNotes: 'SOAP Notları + AI Yazıcı',
    soapNotesDetail: 'Şablonlarla yapılandırılmış klinik dokümantasyon. Gemini sesten not üretiyor.',
    multiChairScheduling: 'Çoklu Koltuk Planlaması',
    multiChairDetail: 'Birden fazla operatoryumlu haftalık görünüm. Doktor renk kodlaması.',
    billingInsurance: 'Faturalandırma ve Sigorta',
    billingDetail: 'Aldagi, GPI, Imedi L için talep takibi. Hasta defteri, ödeme planları.',
    ePrescribing: 'E-Reçete',
    ePrescribingDetail: 'Şablonlarla dijital reçeteler. Gemini ile ilaç etkileşim kontrolü.',
    labTracking: 'Laboratuvar Takibi',
    labTrackingDetail: 'Kanban: Sipariş → Üretim → Gönderim → Teslim.',
    productionReports: 'Üretim Raporları',
    productionReportsDetail: 'Brüt/net üretim, tahsilat oranları, tedavi kabulü.',
    referralMgmt: 'Sevk Yönetimi',
    referralMgmtDetail: 'Uzmanlara gelen/giden sevkler. AI ile oluşturulan mektuplar.',
    medicalHistory: 'Tıbbi Geçmiş',
    medicalHistoryDetail: '11 görünümlü hasta kaydı: zaman çizelgesi, durumlar, ilaçlar, alerjiler.',
    enterpriseAdmin: 'Kurumsal Yönetim',
    enterpriseAdminDetail: 'RBAC, denetim günlüğü, uyumluluk, çoklu kiracılık, SSO, API yönetimi.',
    geminiBuiltIn: 'Yerleşik Gemini AI',
    geminiSubtitle: 'Her modül Google Gemini 3.1 ile çalışır',
    xrayAnalysis: 'Röntgen Analizi',
    xrayDetail: 'AI çürük tespiti için diş röntgenlerini yükleyin.',
    perioAssessment: 'Periodontal Değerlendirme',
    perioAssessmentDetail: 'Sondaj verilerinden otomatik AAP evreleme/derecelendirme.',
    clinicalScribe: 'Klinik Yazıcı',
    clinicalScribeDetail: 'Ses kayıtlarından veya kart verilerinden SOAP not üretimi.',
    riskProfiling: 'Risk Profilleme',
    riskProfilingDetail: 'Diş riski profili için durumlar, aile geçmişi analizi.',
    treatmentSequencing: 'Tedavi Sekanslama',
    treatmentSequencingDetail: 'İyileşme ve sigortayı dikkate alan AI optimizeli tedavi fazlaması.',
    patientComm: 'Hasta İletişimi',
    patientCommDetail: 'Gürcüce hasta dostu açıklamalar üretimi.',
    georgianEcosystem: 'Gürcistan Ekosistemi Hazır',
    integrationsSubtitle: 'Yerel sigorta, ödeme ve mesajlaşma ile önceden oluşturulmuş entegrasyonlar',
    insurance: 'SİGORTA',
    payments: 'ÖDEMELER',
    messaging: 'MESAJLAŞMA',
    ehrLabs: 'EHR VE LABORATUVARLAR',
    clinicsInDb: 'Veritabanındaki Klinikler',
    platformModules: 'Platform Modülleri',
    aiTools: 'AI Araçları (Gemini)',
    integrations: 'Entegrasyonlar',
    pricingTitle: 'Fiyatlar',
    pricingSubtitle: 'Ücretsiz başlayın',
    trustedBy: 'Kliniklerin Güveni',
    readyModernize: 'Modernleşmeye hazır mısınız?',
    joinCount: "Gürcistan'daki 212+ kliniğe katılın.",
    startTrial: 'Ücretsiz Dene',
    contactSales: 'Satışla İletişim',
    noCreditCard: 'Kredi kartı gerekmez  ·  Ücretsiz plan  ·  5 dakikada kurulum',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'Panel',
    navPatients: 'Hastalar',
    navChart: 'Kart',
    navPerio: 'Periodontoloji',
    navTreatmentPlans: 'Tedavi Planları',
    navNotes: 'Notlar',
    navScheduling: 'Planlama',
    navBilling: 'Faturalandırma',
    navPrescriptions: 'Reçeteler',
    navLabCases: 'Laboratuvar Vakaları',
    navReferrals: 'Sevkler',
    navReports: 'Raporlar',
    navMedHistory: 'Tıbbi Geçmiş',
    navIntegrations: 'Entegrasyonlar',
    navEnterprise: 'Kurumsal',
    sectionClinical: 'KLİNİK',
    sectionOperations: 'OPERASYONLAR',
    sectionAnalytics: 'ANALİTİK',
    sectionAiTools: 'AI ARAÇLARI',
    sectionAdmin: 'YÖNETİM',

    // Booking Page
    chooseClinic: 'Klinik Seçin',
    selectAService: 'Hizmet Seçin',
    pickADate: 'Tarih Seçin',
    pickATime: 'Saat Seçin',
    confirmYourBooking: 'Randevunuzu Onaylayın',
    clinicLabel: 'Klinik:',
    serviceLabel: 'Hizmet:',
    dateLabel: 'Tarih:',
    timeLabel: 'Saat:',

    // AI Page
    send: 'Gönder',
    procedure: 'Prosedür',
    observations: 'Gözlemler',
    aiThinking: 'AI düşünüyor...',
    summarizeHistory: 'Hasta geçmişini özetle',
    generateTxPlan: 'Tedavi planı oluştur',
    checkDrugInteractions: 'İlaç etkileşimlerini kontrol et',
    writeClinicalNote: 'Klinik not yaz',
    askAiAssistant: 'AI asistana sorun...',
    dropXray: 'Röntgen görüntüsünü bırakın veya yüklemek için tıklayın',
    supportsFormats: 'DICOM, PNG, JPG desteklenir',
    analysisResults: 'Analiz Sonuçları (Demo)',
    aiRecommendation: 'AI Önerisi',
    exportToTxPlan: 'Tedavi Planına Aktar',
    generateClinicalNote: 'Klinik Not Oluştur',
    generatedSoap: 'Oluşturulan Klinik Not (SOAP)',
    subjective: 'S — Subjektif',
    objective: 'O — Objektif',
    assessment: 'A — Değerlendirme',
    plan: 'P — Plan',
    copyToRecord: 'Hasta Kaydına Kopyala',
    aiPerioAssessment: 'AI Periodontal Değerlendirme',
    enterProbingData: 'AAP evreleme/derecelendirme ve tedavi önerileri için sondaj verilerini girin.',
    analyzeWithGemini: 'Gemini ile Analiz Et',
    aiRiskAssessment: 'AI Risk Değerlendirmesi',
    enterConditions: 'Risk profili oluşturmak için hasta durumlarını, aile geçmişini ve vital bulgularını girin.',
    generateRiskProfile: 'Risk Profili Oluştur',
    patientCommunication: 'Hasta İletişimi',
    generateExplanations: 'Gürcüce veya İngilizce hasta dostu tedavi açıklamaları oluşturun.',
    generateExplanation: 'Açıklama Oluştur',
    patientFriendly: 'Hasta Dostu Açıklama',

    // Billing Page
    claims: 'Talepler',
    ledger: 'Muhasebe Defteri',
    aging: 'Yaşlandırma',
    paymentPlans: 'Ödeme Planları',
    eligibility: 'Uygunluk',
    allFilter: 'Tümü',
    submitted: 'Gönderildi',
    paid: 'Ödendi',
    denied: 'Reddedildi',
    patientLedger: 'Hasta Muhasebesi',
    agedAccounts: 'Vadesi Geçmiş Hesaplar',
    sendStatements: 'Hesap Özetlerini Gönder',
    activePaymentPlans: 'Aktif Ödeme Planları',
    insuranceEligibility: 'Sigorta Uygunluğu',

    // Clinical Charting
    odontogram: 'Odontogram',
    perioTab: 'Periodontoloji',
    treatmentPlanTab: 'Tedavi Planı',
    notesTab: 'Notlar',
    progressNotes: 'İlerleme Notları',
    openFullPerio: 'Tam Periodontal Kartı Aç →',
    openFullTxPlanner: 'Tam Tedavi Planlayıcısını Aç →',
    openClinicalNotes: 'Klinik Notları Aç →',
    newExam: 'Yeni Muayene',
    voiceEntry: 'Sesli Giriş',
    bleedingIndex: 'Kanama İndeksi',
    plaqueIndex: 'Plak İndeksi',
    sitesAbove4: 'Bölgeler ≥ 4mm',
    sitesAbove6: 'Bölgeler ≥ 6mm',
    planA: 'Plan A: Önerilen',
    planB: 'Plan B: Konservatif',
    newPlan: '+ Yeni Plan',
    presentToPatient: 'Hastaya Sun',
    sendToPortal: 'Portala Gönder',
    totalFee: 'Toplam Ücret',
    insuranceEst: 'Sigorta Tahmini',
    patientPortion: 'Hasta Payı',
    chairSideMode: 'Koltuk Modu',
    adminMode: 'Yönetici Modu',
    proceduresAcrossPhases: '{1} fazda {0} işlem',

    // Scheduling
    day: 'Gün',
    week: 'Hafta',
    today: 'Bugün',
    providerFilter: 'Tüm Sağlayıcılar',
    productionGoal: 'Üretim Hedefi',
    waitlist: 'Bekleme Listesi',

    // Prescriptions
    activeRx: 'Aktif',
    pastRx: 'Geçmiş',
    templates: 'Şablonlar',
    interactionCheck: 'Etkileşim Kontrolü',

    // Lab Cases
    ordered: 'Sipariş Verildi',
    sentToLab: 'Laboratuvara Gönderildi',
    inFabrication: 'Üretimde',
    shipped: 'Gönderildi',
    received: 'Teslim Alındı',
    labVendors: 'Laboratuvar Tedarikçileri',

    // Referrals
    allDirections: 'Tümü',
    inbound: 'Gelen',
    outbound: 'Giden',
    generateLetter: 'Mektup Oluştur',

    // Reports
    production: 'Üretim',
    collections: 'Tahsilatlar',
    schedulingReport: 'Planlama',
    treatmentAcceptance: 'Tedavi Kabulü',
    recall: 'Geri Çağırma',
    grossProduction: 'Brüt Üretim',
    netProduction: 'Net Üretim',
    collectionRate: 'Tahsilat Oranı',
    plansPresented: 'Sunulan Planlar',
    accepted: 'Kabul Edildi',
    acceptanceRate: 'Kabul Oranı',
    dueThisMonth: 'Bu Ay Planlanan',
    scheduled: 'Planlandı',
    completed: 'Tamamlandı',
    overdue: 'Gecikmiş',
    reactivationRate: 'Reaktivasyon Oranı',

    // Medical History
    timeline: 'Zaman Çizelgesi',
    conditions: 'Durumlar',
    medications: 'İlaçlar',
    allergies: 'Alerjiler',
    labResults: 'Laboratuvar Sonuçları',
    vitals: 'Vital Bulgular',
    immunizations: 'Aşılar',
    familyHistory: 'Aile Geçmişi',
    imaging: 'Görüntüleme',
    documents: 'Belgeler',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'Denetim Günlüğü',
    compliance: 'Uyumluluk',
    multiTenancy: 'Çoklu Kiracılık',
    sso: 'SSO ve Güvenlik',
    featureFlags: 'Özellik Bayrakları',
    apiManagement: 'API Yönetimi',
    dataManagement: 'Veri Yönetimi',

    // Integrations
    ehr: 'EHR',
    labs: 'Laboratuvarlar',
    telehealth: 'Telesağlık',
    aiMl: 'AI/ML',
    wearables: 'Giyilebilir Cihazlar',
    connected: 'Bağlı',
    disconnected: 'Bağlantı Kesildi',
    available: 'Mevcut',

    // Components
    status: 'Durum',
    healthy: 'Sağlıklı',
    caries: 'Çürük',
    restored: 'Restore Edilmiş',
    missing: 'Eksik',
    implant: 'İmplant',
    crownStatus: 'Kron',
    bridge: 'Köprü',
    veneer: 'Veneer',
    braces: 'Braces',
    surfaces: 'Yüzeyler',
    procedureHistory: 'İşlem Geçmişi',
    addProcedure: 'İşlem Ekle',
    totalCharged: 'Toplam Borç',
    insurancePayment: 'Sigorta Ödemesi',
    patientResponsibility: 'Hasta Sorumluluğu',
    expand: 'Genişlet',
    policyNumber: 'Poliçe No',
    planType: 'Plan Türü',
    annualMax: 'Yıllık Maksimum',
    used: 'Kullanılan',
    remaining: 'Kalan',
    coverageByCategory: 'Kategoriye Göre Kapsam',
    preventive: 'Önleyici',
    basic: 'Temel',
    major: 'Büyük',
    ortho: 'Ortodonti',
    current: 'Güncel',
    thirtyDay: '30 Gün',
    sixtyDay: '60 Gün',
    ninetyPlus: '90+ Gün',
    totalBalance: 'Toplam Bakiye',
    monthlyPayment: 'Aylık Ödeme',
    paymentsRemaining: 'Kalan Ödemeler',
    nextPayment: 'Sonraki Ödeme',
    paymentProgress: 'Ödeme İlerlemesi',
    choosePlan: 'Plan Seç',
    aiInsight: 'AI İçgörüsü',
    confidence: 'Güven',
    revoke: 'İptal Et',
    exams: 'Muayeneler',
    phaseTotal: 'Faz Toplamı',
    mon: 'Pzt',
    tue: 'Sal',
    wed: 'Çar',
    thu: 'Per',
    fri: 'Cum',
    sat: 'Cmt',
    sun: 'Paz',
    thinking: 'Düşünüyor...',
    followUpPlaceholder: 'Takip sorusu sorun...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  },

  zh: {
    home: '首页', features: '功能', pricing: '价格', clinicsNav: '诊所', aiAssistant: 'AI助手', forBusiness: '企业版', dashboard: '仪表板', getStarted: '开始', tryDemo: '试用演示', viewPitch: '查看演示',
    heroTagline: '格鲁吉亚牙科平台', heroTitle: '所有牙科诊所中心', heroSubtitle: '您的AI助手，帮您找到格鲁吉亚最好的牙科护理',
    searchPlaceholder: '搜索诊所、服务或提问...', chipImplant: '第比利斯最佳种植牙诊所', chipWhitening: '附近的牙齿美白', chipEmergency: '紧急牙科护理', chipOrtho: '成人正畸', scrollExplore: '滚动浏览',
    topRated: '第比利斯评分最高的牙科诊所', viewAllClinics: '查看所有诊所', shareLocation: '分享位置查找附近诊所', locationShared: '位置已分享',
    statClinics: '诊所', statNoShows: '减少缺席', statBooking: '在线预约', statDentists: '牙医', statRating: '平均评分', statPatients: '患者',
    findClinics: '查找最佳诊所', clinicsTitle: '格鲁吉亚牙科诊所', verifiedClinics: '已验证诊所', searchByName: '按名称、区域或服务搜索...', reviews: '评价', loadingMore: '加载中...',
    callClinic: '拨打电话', bookAppointment: '预约', services: '服务', workingHours: '营业时间', priceRange: '价格范围', location: '位置',
    bookingTitle: '预约', step: '步骤', selectClinic: '选择诊所', selectService: '选择服务', selectDate: '选择日期', selectTime: '选择时间', confirm: '确认', next: '下一步', back: '返回',
    forBusinessBtn: '企业版',
    ownClinic: '您拥有一家牙科诊所吗？',
    claimText: '在我们的数据库中注册或添加您的诊所。',
    getListed: '立即注册 →',
    hideMap: '隐藏地图',
    showMap: '地图',
    nearMe: '附近',
    clinicsMatch: '诊所匹配',
    visitWebsite: '访问网站',
    clinicsAvailable: '诊所可用',
    clinicsFound: '诊所找到',
    confirmBooking: '确认预约',
    bookingConfirmed: '您的预约已确认！',
    patientName: '患者姓名',
    phoneNumber: '电话号码',
    email: '电子邮箱',
    notes: '备注（可选）',
    businessHeroBadge: '15+ 模块  ·  212+ 诊所  ·  Gemini AI',
    businessHeroTitle: '牙科诊所操作系统',
    businessHeroSubtitle: '临床制图、牙周分析、治疗计划、排班、计费、电子处方、实验室管理和AI诊断——专为格鲁吉亚打造的一站式平台。',
    theProblem: '问题',
    problemSubtitle: '格鲁吉亚牙科诊所因工具碎片化每天损失收入',
    excelChaos: 'Excel和WhatsApp混乱',
    excelChaosDetail: '诊所通过电子表格和聊天群管理预约。零自动化，持续出错。',
    noShowRate: '25%爽约率',
    noShowDetail: '没有自动提醒，患者忘记预约。空椅子意味着每天₾500+的收入损失。',
    paperCharts: '2026年仍用纸质病历',
    paperChartsDetail: '手写临床笔记，没有数字牙位图。关键数据锁在文件柜中。',
    insuranceBlackHole: '保险黑洞',
    insuranceDetail: '向Aldagi、GPI、Imedi L提交人工理赔需数小时。被拒理赔不断积压。',
    oneplatform: '一个平台，所有模块',
    platformSubtitle: '15个为牙科实践量身定制的集成模块',
    clinical: '临床',
    operations: '运营',
    analyticsEnterprise: '分析与企业',
    digitalOdontogram: '数字牙位图',
    digitalOdontogramDetail: 'FDI 32齿图，5面追踪。',
    perioCharting: '牙周制图',
    perioChartingDetail: '192位点牙周网格。6点探诊、BOP、CAL。',
    treatmentPlanning: '治疗计划',
    treatmentPlanningDetail: '带CDT代码的分期计划，保险估算。AI排序。',
    soapNotes: 'SOAP笔记 + AI书写员',
    soapNotesDetail: '带模板的结构化临床文档。Gemini从语音生成笔记。',
    multiChairScheduling: '多椅位排班',
    multiChairDetail: '多操作间周视图。医生颜色编码。',
    billingInsurance: '计费与保险',
    billingDetail: 'Aldagi、GPI、Imedi L理赔追踪。患者台账、付款计划。',
    ePrescribing: '电子处方',
    ePrescribingDetail: '带模板的数字处方。Gemini药物相互作用检查。',
    labTracking: '实验室追踪',
    labTrackingDetail: '看板：已下单 → 制作中 → 已发货 → 已收到。',
    productionReports: '产出报告',
    productionReportsDetail: '毛/净产出、收款率、治疗接受率。',
    referralMgmt: '转诊管理',
    referralMgmtDetail: '向专科医生的转入/转出转诊。AI生成的转诊函。',
    medicalHistory: '病史',
    medicalHistoryDetail: '11视图患者记录：时间线、病情、药物、过敏。',
    enterpriseAdmin: '企业管理',
    enterpriseAdminDetail: 'RBAC、审计日志、合规、多租户、SSO、API管理。',
    geminiBuiltIn: '内置Gemini AI',
    geminiSubtitle: '每个模块由Google Gemini 3.1驱动',
    xrayAnalysis: 'X光分析',
    xrayDetail: '上传牙科X光片进行AI龋齿检测。',
    perioAssessment: '牙周评估',
    perioAssessmentDetail: '根据探诊数据自动AAP分期/分级。',
    clinicalScribe: '临床书写员',
    clinicalScribeDetail: '从语音录音或病历数据生成SOAP笔记。',
    riskProfiling: '风险评估',
    riskProfilingDetail: '分析病情、家族史以创建牙科风险档案。',
    treatmentSequencing: '治疗排序',
    treatmentSequencingDetail: 'AI优化的治疗分期，考虑愈合期和保险。',
    patientComm: '患者沟通',
    patientCommDetail: '生成格鲁吉亚语的患者友好型解释。',
    georgianEcosystem: '格鲁吉亚生态系统就绪',
    integrationsSubtitle: '与当地保险、支付和通讯的预建集成',
    insurance: '保险',
    payments: '支付',
    messaging: '通讯',
    ehrLabs: '电子病历与实验室',
    clinicsInDb: '数据库中的诊所',
    platformModules: '平台模块',
    aiTools: 'AI工具（Gemini）',
    integrations: '集成',
    pricingTitle: '价格',
    pricingSubtitle: '免费开始，随需扩展',
    trustedBy: '诊所信赖',
    readyModernize: '准备好现代化了吗？',
    joinCount: '加入格鲁吉亚212+家诊所。',
    startTrial: '免费试用',
    contactSales: '联系销售',
    noCreditCard: '无需信用卡  ·  免费计划  ·  5分钟设置',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: '仪表板',
    navPatients: '患者',
    navChart: '病历',
    navPerio: '牙周',
    navTreatmentPlans: '治疗计划',
    navNotes: '笔记',
    navScheduling: '排班',
    navBilling: '账单',
    navPrescriptions: '处方',
    navLabCases: '实验室病例',
    navReferrals: '转诊',
    navReports: '报告',
    navMedHistory: '病史',
    navIntegrations: '集成',
    navEnterprise: '企业',
    sectionClinical: '临床',
    sectionOperations: '运营',
    sectionAnalytics: '分析',
    sectionAiTools: 'AI工具',
    sectionAdmin: '管理',

    // Booking Page
    chooseClinic: '选择诊所',
    selectAService: '选择服务',
    pickADate: '选择日期',
    pickATime: '选择时间',
    confirmYourBooking: '确认您的预约',
    clinicLabel: '诊所：',
    serviceLabel: '服务：',
    dateLabel: '日期：',
    timeLabel: '时间：',

    // AI Page
    send: '发送',
    procedure: '手术',
    observations: '观察',
    aiThinking: 'AI正在思考...',
    summarizeHistory: '总结患者病史',
    generateTxPlan: '生成治疗计划',
    checkDrugInteractions: '检查药物相互作用',
    writeClinicalNote: '编写临床笔记',
    askAiAssistant: '询问AI助手...',
    dropXray: '拖放X光片或点击上传',
    supportsFormats: '支持DICOM、PNG、JPG',
    analysisResults: '分析结果（演示）',
    aiRecommendation: 'AI建议',
    exportToTxPlan: '导出至治疗计划',
    generateClinicalNote: '生成临床笔记',
    generatedSoap: '生成的临床笔记（SOAP）',
    subjective: 'S — 主观',
    objective: 'O — 客观',
    assessment: 'A — 评估',
    plan: 'P — 计划',
    copyToRecord: '复制到患者记录',
    aiPerioAssessment: 'AI牙周评估',
    enterProbingData: '输入探诊数据以获取AAP分期/分级和治疗建议。',
    analyzeWithGemini: '使用Gemini分析',
    aiRiskAssessment: 'AI风险评估',
    enterConditions: '输入患者状况、家族史和生命体征以生成风险档案。',
    generateRiskProfile: '生成风险档案',
    patientCommunication: '患者沟通',
    generateExplanations: '生成格鲁吉亚语或英语的患者友好型治疗说明。',
    generateExplanation: '生成说明',
    patientFriendly: '患者友好型说明',

    // Billing Page
    claims: '理赔',
    ledger: '台账',
    aging: '账龄',
    paymentPlans: '付款计划',
    eligibility: '资格',
    allFilter: '全部',
    submitted: '已提交',
    paid: '已支付',
    denied: '已拒绝',
    patientLedger: '患者台账',
    agedAccounts: '逾期账户',
    sendStatements: '发送对账单',
    activePaymentPlans: '活跃付款计划',
    insuranceEligibility: '保险资格',

    // Clinical Charting
    odontogram: '牙位图',
    perioTab: '牙周',
    treatmentPlanTab: '治疗计划',
    notesTab: '笔记',
    progressNotes: '进展笔记',
    openFullPerio: '打开完整牙周图 →',
    openFullTxPlanner: '打开完整治疗规划器 →',
    openClinicalNotes: '打开临床笔记 →',
    newExam: '新检查',
    voiceEntry: '语音输入',
    bleedingIndex: '出血指数',
    plaqueIndex: '菌斑指数',
    sitesAbove4: '位点 ≥ 4mm',
    sitesAbove6: '位点 ≥ 6mm',
    planA: '方案A：推荐',
    planB: '方案B：保守',
    newPlan: '+ 新方案',
    presentToPatient: '向患者展示',
    sendToPortal: '发送至门户',
    totalFee: '总费用',
    insuranceEst: '保险估算',
    patientPortion: '患者部分',
    chairSideMode: '椅旁模式',
    adminMode: '管理模式',
    proceduresAcrossPhases: '{1}个阶段中的{0}个程序',

    // Scheduling
    day: '日',
    week: '周',
    today: '今天',
    providerFilter: '所有医生',
    productionGoal: '产出目标',
    waitlist: '候补名单',

    // Prescriptions
    activeRx: '有效',
    pastRx: '历史',
    templates: '模板',
    interactionCheck: '相互作用检查',

    // Lab Cases
    ordered: '已下单',
    sentToLab: '已送实验室',
    inFabrication: '制作中',
    shipped: '已发货',
    received: '已收到',
    labVendors: '实验室供应商',

    // Referrals
    allDirections: '全部',
    inbound: '转入',
    outbound: '转出',
    generateLetter: '生成函件',

    // Reports
    production: '产出',
    collections: '收款',
    schedulingReport: '排班',
    treatmentAcceptance: '治疗接受率',
    recall: '复召',
    grossProduction: '毛产出',
    netProduction: '净产出',
    collectionRate: '收款率',
    plansPresented: '已展示计划',
    accepted: '已接受',
    acceptanceRate: '接受率',
    dueThisMonth: '本月到期',
    scheduled: '已安排',
    completed: '已完成',
    overdue: '逾期',
    reactivationRate: '重新激活率',

    // Medical History
    timeline: '时间线',
    conditions: '病情',
    medications: '药物',
    allergies: '过敏',
    labResults: '化验结果',
    vitals: '生命体征',
    immunizations: '免疫接种',
    familyHistory: '家族史',
    imaging: '影像',
    documents: '文件',

    // Enterprise
    rbac: 'RBAC',
    auditLog: '审计日志',
    compliance: '合规',
    multiTenancy: '多租户',
    sso: 'SSO与安全',
    featureFlags: '功能标志',
    apiManagement: 'API管理',
    dataManagement: '数据管理',

    // Integrations
    ehr: '电子病历',
    labs: '实验室',
    telehealth: '远程医疗',
    aiMl: 'AI/ML',
    wearables: '可穿戴设备',
    connected: '已连接',
    disconnected: '已断开',
    available: '可用',

    // Components
    status: '状态',
    healthy: '健康',
    caries: '龋齿',
    restored: '已修复',
    missing: '缺失',
    implant: '种植体',
    crownStatus: '牙冠',
    bridge: '桥体',
    veneer: '贴面',
    surfaces: '面',
    procedureHistory: '操作历史',
    addProcedure: '添加操作',
    totalCharged: '总收费',
    insurancePayment: '保险支付',
    patientResponsibility: '患者自付',
    expand: '展开',
    policyNumber: '保单号',
    planType: '计划类型',
    annualMax: '年度上限',
    used: '已用',
    remaining: '剩余',
    coverageByCategory: '按类别覆盖',
    preventive: '预防',
    basic: '基础',
    major: '重大',
    ortho: '正畸',
    current: '当前',
    thirtyDay: '30天',
    sixtyDay: '60天',
    ninetyPlus: '90+天',
    totalBalance: '总余额',
    monthlyPayment: '月供',
    paymentsRemaining: '剩余期数',
    nextPayment: '下次付款',
    paymentProgress: '付款进度',
    choosePlan: '选择计划',
    aiInsight: 'AI洞察',
    confidence: '置信度',
    revoke: '撤销',
    exams: '检查',
    phaseTotal: '阶段合计',
    mon: '一',
    tue: '二',
    wed: '三',
    thu: '四',
    fri: '五',
    sat: '六',
    sun: '日',
    thinking: '思考中...',
    followUpPlaceholder: '提出后续问题...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: '首页', features: '功能', pricing: '价格', clinicsNav: '诊所', aiAssistant: 'AI助手', forBusiness: '企业版', dashboard: '仪表板', getStarted: '开始', tryDemo: '试用演示', viewPitch: '查看演示',
    heroTagline: '格鲁吉亚牙科平台', heroTitle: '所有牙科诊所中心', heroSubtitle: '您的AI助手，帮您找到格鲁吉亚最好的牙科护理',
    searchPlaceholder: '搜索诊所、服务或提问...', chipImplant: '第比利斯最佳种植牙诊所', chipWhitening: '附近的牙齿美白', chipEmergency: '紧急牙科护理', chipOrtho: '成人正畸', scrollExplore: '滚动浏览',
    topRated: '第比利斯评分最高的牙科诊所', viewAllClinics: '查看所有诊所', shareLocation: '分享位置查找附近诊所', locationShared: '位置已分享',
    statClinics: '诊所', statNoShows: '减少缺席', statBooking: '在线预约', statDentists: '牙医', statRating: '平均评分', statPatients: '患者',
    findClinics: '查找最佳诊所', clinicsTitle: '格鲁吉亚牙科诊所', verifiedClinics: '已验证诊所', searchByName: '按名称、区域或服务搜索...', reviews: '评价', loadingMore: '加载中...',
    callClinic: '拨打电话', bookAppointment: '预约', services: '服务', workingHours: '营业时间', priceRange: '价格范围', location: '位置',
    bookingTitle: '预约', step: '步骤', selectClinic: '选择诊所', selectService: '选择服务', selectDate: '选择日期', selectTime: '选择时间', confirm: '确认', next: '下一步', back: '返回',
    forBusinessBtn: '企业版',
    ownClinic: '您拥有一家牙科诊所吗？',
    claimText: '在我们的数据库中注册或添加您的诊所。',
    getListed: '立即注册 →',
    hideMap: '隐藏地图',
    showMap: '地图',
    nearMe: '附近',
    clinicsMatch: '诊所匹配',
    visitWebsite: '访问网站',
    clinicsAvailable: '诊所可用',
    clinicsFound: '诊所找到',
    confirmBooking: '确认预约',
    bookingConfirmed: '您的预约已确认！',
    patientName: '患者姓名',
    phoneNumber: '电话号码',
    email: '电子邮箱',
    notes: '备注（可选）',
    businessHeroBadge: '15+ 模块  ·  212+ 诊所  ·  Gemini AI',
    businessHeroTitle: '牙科诊所操作系统',
    businessHeroSubtitle: '临床制图、牙周分析、治疗计划、排班、计费、电子处方、实验室管理和AI诊断——专为格鲁吉亚打造的一站式平台。',
    theProblem: '问题',
    problemSubtitle: '格鲁吉亚牙科诊所因工具碎片化每天损失收入',
    excelChaos: 'Excel和WhatsApp混乱',
    excelChaosDetail: '诊所通过电子表格和聊天群管理预约。零自动化，持续出错。',
    noShowRate: '25%爽约率',
    noShowDetail: '没有自动提醒，患者忘记预约。空椅子意味着每天₾500+的收入损失。',
    paperCharts: '2026年仍用纸质病历',
    paperChartsDetail: '手写临床笔记，没有数字牙位图。关键数据锁在文件柜中。',
    insuranceBlackHole: '保险黑洞',
    insuranceDetail: '向Aldagi、GPI、Imedi L提交人工理赔需数小时。被拒理赔不断积压。',
    oneplatform: '一个平台，所有模块',
    platformSubtitle: '15个为牙科实践量身定制的集成模块',
    clinical: '临床',
    operations: '运营',
    analyticsEnterprise: '分析与企业',
    digitalOdontogram: '数字牙位图',
    digitalOdontogramDetail: 'FDI 32齿图，5面追踪。',
    perioCharting: '牙周制图',
    perioChartingDetail: '192位点牙周网格。6点探诊、BOP、CAL。',
    treatmentPlanning: '治疗计划',
    treatmentPlanningDetail: '带CDT代码的分期计划，保险估算。AI排序。',
    soapNotes: 'SOAP笔记 + AI书写员',
    soapNotesDetail: '带模板的结构化临床文档。Gemini从语音生成笔记。',
    multiChairScheduling: '多椅位排班',
    multiChairDetail: '多操作间周视图。医生颜色编码。',
    billingInsurance: '计费与保险',
    billingDetail: 'Aldagi、GPI、Imedi L理赔追踪。患者台账、付款计划。',
    ePrescribing: '电子处方',
    ePrescribingDetail: '带模板的数字处方。Gemini药物相互作用检查。',
    labTracking: '实验室追踪',
    labTrackingDetail: '看板：已下单 → 制作中 → 已发货 → 已收到。',
    productionReports: '产出报告',
    productionReportsDetail: '毛/净产出、收款率、治疗接受率。',
    referralMgmt: '转诊管理',
    referralMgmtDetail: '向专科医生的转入/转出转诊。AI生成的转诊函。',
    medicalHistory: '病史',
    medicalHistoryDetail: '11视图患者记录：时间线、病情、药物、过敏。',
    enterpriseAdmin: '企业管理',
    enterpriseAdminDetail: 'RBAC、审计日志、合规、多租户、SSO、API管理。',
    geminiBuiltIn: '内置Gemini AI',
    geminiSubtitle: '每个模块由Google Gemini 3.1驱动',
    xrayAnalysis: 'X光分析',
    xrayDetail: '上传牙科X光片进行AI龋齿检测。',
    perioAssessment: '牙周评估',
    perioAssessmentDetail: '根据探诊数据自动AAP分期/分级。',
    clinicalScribe: '临床书写员',
    clinicalScribeDetail: '从语音录音或病历数据生成SOAP笔记。',
    riskProfiling: '风险评估',
    riskProfilingDetail: '分析病情、家族史以创建牙科风险档案。',
    treatmentSequencing: '治疗排序',
    treatmentSequencingDetail: 'AI优化的治疗分期，考虑愈合期和保险。',
    patientComm: '患者沟通',
    patientCommDetail: '生成格鲁吉亚语的患者友好型解释。',
    georgianEcosystem: '格鲁吉亚生态系统就绪',
    integrationsSubtitle: '与当地保险、支付和通讯的预建集成',
    insurance: '保险',
    payments: '支付',
    messaging: '通讯',
    ehrLabs: '电子病历与实验室',
    clinicsInDb: '数据库中的诊所',
    platformModules: '平台模块',
    aiTools: 'AI工具（Gemini）',
    integrations: '集成',
    pricingTitle: '价格',
    pricingSubtitle: '免费开始，随需扩展',
    trustedBy: '诊所信赖',
    readyModernize: '准备好现代化了吗？',
    joinCount: '加入格鲁吉亚212+家诊所。',
    startTrial: '免费试用',
    contactSales: '联系销售',
    noCreditCard: '无需信用卡  ·  免费计划  ·  5分钟设置',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: '仪表板',
    navPatients: '患者',
    navChart: '病历',
    navPerio: '牙周',
    navTreatmentPlans: '治疗计划',
    navNotes: '笔记',
    navScheduling: '排班',
    navBilling: '账单',
    navPrescriptions: '处方',
    navLabCases: '实验室病例',
    navReferrals: '转诊',
    navReports: '报告',
    navMedHistory: '病史',
    navIntegrations: '集成',
    navEnterprise: '企业',
    sectionClinical: '临床',
    sectionOperations: '运营',
    sectionAnalytics: '分析',
    sectionAiTools: 'AI工具',
    sectionAdmin: '管理',

    // Booking Page
    chooseClinic: '选择诊所',
    selectAService: '选择服务',
    pickADate: '选择日期',
    pickATime: '选择时间',
    confirmYourBooking: '确认您的预约',
    clinicLabel: '诊所：',
    serviceLabel: '服务：',
    dateLabel: '日期：',
    timeLabel: '时间：',

    // AI Page
    send: '发送',
    procedure: '手术',
    observations: '观察',
    aiThinking: 'AI正在思考...',
    summarizeHistory: '总结患者病史',
    generateTxPlan: '生成治疗计划',
    checkDrugInteractions: '检查药物相互作用',
    writeClinicalNote: '编写临床笔记',
    askAiAssistant: '询问AI助手...',
    dropXray: '拖放X光片或点击上传',
    supportsFormats: '支持DICOM、PNG、JPG',
    analysisResults: '分析结果（演示）',
    aiRecommendation: 'AI建议',
    exportToTxPlan: '导出至治疗计划',
    generateClinicalNote: '生成临床笔记',
    generatedSoap: '生成的临床笔记（SOAP）',
    subjective: 'S — 主观',
    objective: 'O — 客观',
    assessment: 'A — 评估',
    plan: 'P — 计划',
    copyToRecord: '复制到患者记录',
    aiPerioAssessment: 'AI牙周评估',
    enterProbingData: '输入探诊数据以获取AAP分期/分级和治疗建议。',
    analyzeWithGemini: '使用Gemini分析',
    aiRiskAssessment: 'AI风险评估',
    enterConditions: '输入患者状况、家族史和生命体征以生成风险档案。',
    generateRiskProfile: '生成风险档案',
    patientCommunication: '患者沟通',
    generateExplanations: '生成格鲁吉亚语或英语的患者友好型治疗说明。',
    generateExplanation: '生成说明',
    patientFriendly: '患者友好型说明',

    // Billing Page
    claims: '理赔',
    ledger: '台账',
    aging: '账龄',
    paymentPlans: '付款计划',
    eligibility: '资格',
    allFilter: '全部',
    submitted: '已提交',
    paid: '已支付',
    denied: '已拒绝',
    patientLedger: '患者台账',
    agedAccounts: '逾期账户',
    sendStatements: '发送对账单',
    activePaymentPlans: '活跃付款计划',
    insuranceEligibility: '保险资格',

    // Clinical Charting
    odontogram: '牙位图',
    perioTab: '牙周',
    treatmentPlanTab: '治疗计划',
    notesTab: '笔记',
    progressNotes: '进展笔记',
    openFullPerio: '打开完整牙周图 →',
    openFullTxPlanner: '打开完整治疗规划器 →',
    openClinicalNotes: '打开临床笔记 →',
    newExam: '新检查',
    voiceEntry: '语音输入',
    bleedingIndex: '出血指数',
    plaqueIndex: '菌斑指数',
    sitesAbove4: '位点 ≥ 4mm',
    sitesAbove6: '位点 ≥ 6mm',
    planA: '方案A：推荐',
    planB: '方案B：保守',
    newPlan: '+ 新方案',
    presentToPatient: '向患者展示',
    sendToPortal: '发送至门户',
    totalFee: '总费用',
    insuranceEst: '保险估算',
    patientPortion: '患者部分',
    chairSideMode: '椅旁模式',
    adminMode: '管理模式',
    proceduresAcrossPhases: '{1}个阶段中的{0}个程序',

    // Scheduling
    day: '日',
    week: '周',
    today: '今天',
    providerFilter: '所有医生',
    productionGoal: '产出目标',
    waitlist: '候补名单',

    // Prescriptions
    activeRx: '有效',
    pastRx: '历史',
    templates: '模板',
    interactionCheck: '相互作用检查',

    // Lab Cases
    ordered: '已下单',
    sentToLab: '已送实验室',
    inFabrication: '制作中',
    shipped: '已发货',
    received: '已收到',
    labVendors: '实验室供应商',

    // Referrals
    allDirections: '全部',
    inbound: '转入',
    outbound: '转出',
    generateLetter: '生成函件',

    // Reports
    production: '产出',
    collections: '收款',
    schedulingReport: '排班',
    treatmentAcceptance: '治疗接受率',
    recall: '复召',
    grossProduction: '毛产出',
    netProduction: '净产出',
    collectionRate: '收款率',
    plansPresented: '已展示计划',
    accepted: '已接受',
    acceptanceRate: '接受率',
    dueThisMonth: '本月到期',
    scheduled: '已安排',
    completed: '已完成',
    overdue: '逾期',
    reactivationRate: '重新激活率',

    // Medical History
    timeline: '时间线',
    conditions: '病情',
    medications: '药物',
    allergies: '过敏',
    labResults: '化验结果',
    vitals: '生命体征',
    immunizations: '免疫接种',
    familyHistory: '家族史',
    imaging: '影像',
    documents: '文件',

    // Enterprise
    rbac: 'RBAC',
    auditLog: '审计日志',
    compliance: '合规',
    multiTenancy: '多租户',
    sso: 'SSO与安全',
    featureFlags: '功能标志',
    apiManagement: 'API管理',
    dataManagement: '数据管理',

    // Integrations
    ehr: '电子病历',
    labs: '实验室',
    telehealth: '远程医疗',
    aiMl: 'AI/ML',
    wearables: '可穿戴设备',
    connected: '已连接',
    disconnected: '已断开',
    available: '可用',

    // Components
    status: '状态',
    healthy: '健康',
    caries: '龋齿',
    restored: '已修复',
    missing: '缺失',
    implant: '种植体',
    crownStatus: '牙冠',
    bridge: '桥体',
    veneer: '贴面',
    surfaces: '面',
    procedureHistory: '操作历史',
    addProcedure: '添加操作',
    totalCharged: '总收费',
    insurancePayment: '保险支付',
    patientResponsibility: '患者自付',
    expand: '展开',
    policyNumber: '保单号',
    planType: '计划类型',
    annualMax: '年度上限',
    used: '已用',
    remaining: '剩余',
    coverageByCategory: '按类别覆盖',
    preventive: '预防',
    basic: '基础',
    major: '重大',
    ortho: '正畸',
    current: '当前',
    thirtyDay: '30天',
    sixtyDay: '60天',
    ninetyPlus: '90+天',
    totalBalance: '总余额',
    monthlyPayment: '月供',
    paymentsRemaining: '剩余期数',
    nextPayment: '下次付款',
    paymentProgress: '付款进度',
    choosePlan: '选择计划',
    aiInsight: 'AI洞察',
    confidence: '置信度',
    revoke: '撤销',
    exams: '检查',
    phaseTotal: '阶段合计',
    mon: '一',
    tue: '二',
    wed: '三',
    thu: '四',
    fri: '五',
    sat: '六',
    sun: '日',
    thinking: '思考中...',
    followUpPlaceholder: '提出后续问题...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  },

  hi: {
    home: 'होम', features: 'विशेषताएं', pricing: 'मूल्य', clinicsNav: 'क्लीनिक', aiAssistant: 'AI सहायक', forBusiness: 'व्यापार के लिए', dashboard: 'डैशबोर्ड', getStarted: 'शुरू करें', tryDemo: 'डेमो आज़माएं',
    heroTagline: 'जॉर्जिया के लिए डेंटल प्लेटफॉर्म', heroTitle: 'सभी डेंटल क्लीनिक हब', heroSubtitle: 'जॉर्जिया में सर्वश्रेष्ठ दंत चिकित्सा खोजने के लिए आपका AI सहायक',
    searchPlaceholder: 'क्लीनिक, सेवाएं खोजें या कुछ पूछें...', chipImplant: 'त्बिलिसी में सर्वश्रेष्ठ इम्प्लांट क्लीनिक', chipWhitening: 'मेरे पास दांत सफेद करना', chipEmergency: 'आपातकालीन दंत चिकित्सा', chipOrtho: 'वयस्कों के लिए ऑर्थोडॉन्टिक्स', scrollExplore: 'देखने के लिए स्क्रॉल करें',
    topRated: 'त्बिलिसी के सर्वश्रेष्ठ डेंटल क्लीनिक', viewAllClinics: 'सभी क्लीनिक देखें', statClinics: 'क्लीनिक', statNoShows: 'कम अनुपस्थिति', statBooking: 'ऑनलाइन बुकिंग', statDentists: 'दंत चिकित्सक', statRating: 'औसत रेटिंग', statPatients: 'मरीज',
    findClinics: 'सर्वश्रेष्ठ क्लीनिक खोजें', clinicsTitle: 'जॉर्जिया में डेंटल क्लीनिक', verifiedClinics: 'सत्यापित क्लीनिक', reviews: 'समीक्षाएं',
    callClinic: 'कॉल करें', bookAppointment: 'अपॉइंटमेंट बुक करें', services: 'सेवाएं', workingHours: 'कार्य समय', priceRange: 'मूल्य सीमा', location: 'स्थान',
    bookingTitle: 'अपॉइंटमेंट बुक करें', step: 'चरण', selectClinic: 'क्लीनिक चुनें', selectService: 'सेवा चुनें', selectDate: 'तारीख चुनें', selectTime: 'समय चुनें', confirm: 'पुष्टि करें', next: 'अगला', back: 'पीछे',
    viewPitch: 'प्रस्तुति देखें',
    shareLocation: 'नज़दीकी क्लीनिक के लिए लोकेशन साझा करें',
    locationShared: 'लोकेशन साझा हुई — नज़दीकी दिखा रहे हैं',
    forBusinessBtn: 'व्यापार के लिए',
    ownClinic: 'क्या आप एक डेंटल क्लीनिक के मालिक हैं?',
    claimText: 'अपनी क्लीनिक को हमारे डेटाबेस में रजिस्टर करें या जोड़ें।',
    getListed: 'रजिस्टर करें →',
    searchByName: 'नाम, जिले या सेवा से खोजें...',
    hideMap: 'मानचित्र छुपाएं',
    showMap: 'मानचित्र',
    nearMe: 'मेरे पास',
    clinicsMatch: 'क्लीनिक मिलती हैं',
    loadingMore: 'लोड हो रहा है...',
    visitWebsite: 'वेबसाइट देखें',
    clinicsAvailable: 'क्लीनिक उपलब्ध',
    clinicsFound: 'क्लीनिक मिलीं',
    confirmBooking: 'बुकिंग की पुष्टि करें',
    bookingConfirmed: 'आपकी अपॉइंटमेंट बुक हो गई!',
    patientName: 'मरीज का नाम',
    phoneNumber: 'फोन नंबर',
    email: 'ईमेल',
    notes: 'नोट्स (वैकल्पिक)',
    businessHeroBadge: '15+ मॉड्यूल  ·  212+ क्लीनिक  ·  Gemini AI',
    businessHeroTitle: 'डेंटल क्लीनिक ऑपरेटिंग सिस्टम',
    businessHeroSubtitle: 'क्लिनिकल चार्टिंग, पेरियोडॉन्टल विश्लेषण, उपचार योजना, शेड्यूलिंग, बिलिंग, ई-प्रिस्क्रिप्शन, लैब प्रबंधन और AI डायग्नोस्टिक्स — जॉर्जिया के लिए एक प्लेटफॉर्म।',
    theProblem: 'समस्या',
    problemSubtitle: 'जॉर्जियाई डेंटल क्लीनिक खंडित उपकरणों के कारण दैनिक राजस्व खो रही हैं',
    excelChaos: 'Excel और WhatsApp अराजकता',
    excelChaosDetail: 'क्लीनिक स्प्रेडशीट और चैट से अपॉइंटमेंट प्रबंधित करती हैं। शून्य स्वचालन, निरंतर त्रुटियां।',
    noShowRate: '25% अनुपस्थिति दर',
    noShowDetail: 'स्वचालित रिमाइंडर के बिना मरीज अपॉइंटमेंट भूल जाते हैं। खाली कुर्सियां = ₾500+/दिन नुकसान।',
    paperCharts: '2026 में कागज़ी चार्ट',
    paperChartsDetail: 'हस्तलिखित क्लिनिकल नोट्स, कोई डिजिटल ओडोन्टोग्राम नहीं। महत्वपूर्ण डेटा फाइल कैबिनेट में बंद।',
    insuranceBlackHole: 'बीमा ब्लैक होल',
    insuranceDetail: 'Aldagi, GPI, Imedi L को मैनुअल दावे घंटों लगते हैं। अस्वीकृत दावे जमा होते रहते हैं।',
    oneplatform: 'एक प्लेटफॉर्म, सभी मॉड्यूल',
    platformSubtitle: 'डेंटल प्रैक्टिस के लिए 15 एकीकृत मॉड्यूल',
    clinical: 'नैदानिक',
    operations: 'संचालन',
    analyticsEnterprise: 'विश्लेषण और एंटरप्राइज़',
    digitalOdontogram: 'डिजिटल ओडोन्टोग्राम',
    digitalOdontogramDetail: 'FDI 32 दांत चार्ट, 5 सतह ट्रैकिंग।',
    perioCharting: 'पेरियोडॉन्टल चार्टिंग',
    perioChartingDetail: '192 स्थान पेरियोडॉन्टल ग्रिड। 6 बिंदु प्रोबिंग, BOP, CAL।',
    treatmentPlanning: 'उपचार योजना',
    treatmentPlanningDetail: 'CDT कोड के साथ चरणबद्ध योजनाएं, बीमा अनुमान। AI सीक्वेंसिंग।',
    soapNotes: 'SOAP नोट्स + AI स्क्राइब',
    soapNotesDetail: 'टेम्पलेट के साथ संरचित क्लिनिकल डॉक्यूमेंटेशन। Gemini आवाज़ से नोट्स बनाता है।',
    multiChairScheduling: 'बहु-कुर्सी शेड्यूलिंग',
    multiChairDetail: 'कई ऑपरेटरी के साथ साप्ताहिक दृश्य। डॉक्टर रंग कोडिंग।',
    billingInsurance: 'बिलिंग और बीमा',
    billingDetail: 'Aldagi, GPI, Imedi L दावा ट्रैकिंग। मरीज खाता, भुगतान योजनाएं।',
    ePrescribing: 'ई-प्रिस्क्रिप्शन',
    ePrescribingDetail: 'टेम्पलेट के साथ डिजिटल नुस्खे। Gemini दवा इंटरैक्शन जांच।',
    labTracking: 'लैब ट्रैकिंग',
    labTrackingDetail: 'कानबान: ऑर्डर → निर्माण → शिपमेंट → प्राप्त।',
    productionReports: 'उत्पादन रिपोर्ट',
    productionReportsDetail: 'सकल/शुद्ध उत्पादन, संग्रह दर, उपचार स्वीकृति।',
    referralMgmt: 'रेफरल प्रबंधन',
    referralMgmtDetail: 'विशेषज्ञों को आने/जाने वाले रेफरल। AI जनित पत्र।',
    medicalHistory: 'चिकित्सा इतिहास',
    medicalHistoryDetail: '11 दृश्य मरीज रिकॉर्ड: समयरेखा, स्थितियां, दवाइयां, एलर्जी।',
    enterpriseAdmin: 'एंटरप्राइज़ एडमिन',
    enterpriseAdminDetail: 'RBAC, ऑडिट लॉग, अनुपालन, मल्टी-टेनेंसी, SSO, API प्रबंधन।',
    geminiBuiltIn: 'अंतर्निहित Gemini AI',
    geminiSubtitle: 'हर मॉड्यूल Google Gemini 3.1 द्वारा संचालित',
    xrayAnalysis: 'एक्स-रे विश्लेषण',
    xrayDetail: 'AI कैरीज़ डिटेक्शन के लिए डेंटल एक्स-रे अपलोड करें।',
    perioAssessment: 'पेरियोडॉन्टल मूल्यांकन',
    perioAssessmentDetail: 'प्रोबिंग डेटा से स्वचालित AAP स्टेजिंग/ग्रेडिंग।',
    clinicalScribe: 'क्लिनिकल स्क्राइब',
    clinicalScribeDetail: 'वॉइस रिकॉर्डिंग या चार्ट डेटा से SOAP नोट्स जनरेशन।',
    riskProfiling: 'जोखिम प्रोफाइलिंग',
    riskProfilingDetail: 'डेंटल रिस्क प्रोफाइल के लिए स्थितियों, पारिवारिक इतिहास का विश्लेषण।',
    treatmentSequencing: 'उपचार सीक्वेंसिंग',
    treatmentSequencingDetail: 'उपचार और बीमा को ध्यान में रखते हुए AI अनुकूलित उपचार चरण।',
    patientComm: 'मरीज संवाद',
    patientCommDetail: 'जॉर्जियन में मरीज-अनुकूल स्पष्टीकरण का निर्माण।',
    georgianEcosystem: 'जॉर्जियाई इकोसिस्टम तैयार',
    integrationsSubtitle: 'स्थानीय बीमा, भुगतान और मैसेजिंग के साथ पूर्व-निर्मित एकीकरण',
    insurance: 'बीमा',
    payments: 'भुगतान',
    messaging: 'मैसेजिंग',
    ehrLabs: 'EHR और लैब',
    clinicsInDb: 'डेटाबेस में क्लीनिक',
    platformModules: 'प्लेटफॉर्म मॉड्यूल',
    aiTools: 'AI उपकरण (Gemini)',
    integrations: 'एकीकरण',
    pricingTitle: 'मूल्य',
    pricingSubtitle: 'निःशुल्क शुरू करें, बढ़ने पर स्केल करें',
    trustedBy: 'क्लीनिकों का विश्वास',
    readyModernize: 'आधुनिकीकरण के लिए तैयार?',
    joinCount: 'जॉर्जिया में 212+ क्लीनिकों से जुड़ें।',
    startTrial: 'निःशुल्क शुरू करें',
    contactSales: 'बिक्री से संपर्क करें',
    noCreditCard: 'क्रेडिट कार्ड आवश्यक नहीं  ·  निःशुल्क योजना  ·  5 मिनट में सेटअप',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'डैशबोर्ड',
    navPatients: 'मरीज',
    navChart: 'चार्ट',
    navPerio: 'पेरियो',
    navTreatmentPlans: 'उपचार योजनाएं',
    navNotes: 'नोट्स',
    navScheduling: 'शेड्यूलिंग',
    navBilling: 'बिलिंग',
    navPrescriptions: 'नुस्खे',
    navLabCases: 'लैब केस',
    navReferrals: 'रेफरल',
    navReports: 'रिपोर्ट',
    navMedHistory: 'चिकित्सा इतिहास',
    navIntegrations: 'एकीकरण',
    navEnterprise: 'एंटरप्राइज़',
    sectionClinical: 'नैदानिक',
    sectionOperations: 'संचालन',
    sectionAnalytics: 'विश्लेषण',
    sectionAiTools: 'AI उपकरण',
    sectionAdmin: 'प्रशासन',

    // Booking Page
    chooseClinic: 'क्लीनिक चुनें',
    selectAService: 'सेवा चुनें',
    pickADate: 'तारीख चुनें',
    pickATime: 'समय चुनें',
    confirmYourBooking: 'अपनी बुकिंग की पुष्टि करें',
    clinicLabel: 'क्लीनिक:',
    serviceLabel: 'सेवा:',
    dateLabel: 'तारीख:',
    timeLabel: 'समय:',

    // AI Page
    send: 'भेजें',
    procedure: 'प्रक्रिया',
    observations: 'अवलोकन',
    aiThinking: 'AI सोच रहा है...',
    summarizeHistory: 'मरीज का इतिहास सारांशित करें',
    generateTxPlan: 'उपचार योजना बनाएं',
    checkDrugInteractions: 'दवा इंटरैक्शन जांचें',
    writeClinicalNote: 'क्लिनिकल नोट लिखें',
    askAiAssistant: 'AI सहायक से पूछें...',
    dropXray: 'एक्स-रे छवि डालें या अपलोड करने के लिए क्लिक करें',
    supportsFormats: 'DICOM, PNG, JPG समर्थित',
    analysisResults: 'विश्लेषण परिणाम (डेमो)',
    aiRecommendation: 'AI सिफारिश',
    exportToTxPlan: 'उपचार योजना में निर्यात करें',
    generateClinicalNote: 'क्लिनिकल नोट बनाएं',
    generatedSoap: 'जनरेट किया गया क्लिनिकल नोट (SOAP)',
    subjective: 'S — व्यक्तिपरक',
    objective: 'O — वस्तुनिष्ठ',
    assessment: 'A — मूल्यांकन',
    plan: 'P — योजना',
    copyToRecord: 'मरीज के रिकॉर्ड में कॉपी करें',
    aiPerioAssessment: 'AI पेरियोडॉन्टल मूल्यांकन',
    enterProbingData: 'AAP स्टेजिंग/ग्रेडिंग और उपचार सिफारिशों के लिए प्रोबिंग डेटा दर्ज करें।',
    analyzeWithGemini: 'Gemini से विश्लेषण करें',
    aiRiskAssessment: 'AI जोखिम मूल्यांकन',
    enterConditions: 'जोखिम प्रोफ़ाइल बनाने के लिए मरीज की स्थिति, पारिवारिक इतिहास और वाइटल दर्ज करें।',
    generateRiskProfile: 'जोखिम प्रोफ़ाइल बनाएं',
    patientCommunication: 'मरीज संवाद',
    generateExplanations: 'जॉर्जियन या अंग्रेज़ी में मरीज-अनुकूल उपचार स्पष्टीकरण बनाएं।',
    generateExplanation: 'स्पष्टीकरण बनाएं',
    patientFriendly: 'मरीज-अनुकूल स्पष्टीकरण',

    // Billing Page
    claims: 'दावे',
    ledger: 'खाता बही',
    aging: 'एजिंग',
    paymentPlans: 'भुगतान योजनाएं',
    eligibility: 'पात्रता',
    allFilter: 'सभी',
    submitted: 'प्रस्तुत',
    paid: 'भुगतान हुआ',
    denied: 'अस्वीकृत',
    patientLedger: 'मरीज खाता बही',
    agedAccounts: 'अतिदेय खाते',
    sendStatements: 'विवरण भेजें',
    activePaymentPlans: 'सक्रिय भुगतान योजनाएं',
    insuranceEligibility: 'बीमा पात्रता',

    // Clinical Charting
    odontogram: 'ओडोन्टोग्राम',
    perioTab: 'पेरियो',
    treatmentPlanTab: 'उपचार योजना',
    notesTab: 'नोट्स',
    progressNotes: 'प्रगति नोट्स',
    openFullPerio: 'पूर्ण पेरियोडॉन्टल चार्ट खोलें →',
    openFullTxPlanner: 'पूर्ण उपचार योजनाकार खोलें →',
    openClinicalNotes: 'क्लिनिकल नोट्स खोलें →',
    newExam: 'नई परीक्षा',
    voiceEntry: 'वॉइस एंट्री',
    bleedingIndex: 'रक्तस्राव सूचकांक',
    plaqueIndex: 'प्लाक सूचकांक',
    sitesAbove4: 'स्थान ≥ 4मिमी',
    sitesAbove6: 'स्थान ≥ 6मिमी',
    planA: 'योजना A: अनुशंसित',
    planB: 'योजना B: रूढ़िवादी',
    newPlan: '+ नई योजना',
    presentToPatient: 'मरीज को प्रस्तुत करें',
    sendToPortal: 'पोर्टल पर भेजें',
    totalFee: 'कुल शुल्क',
    insuranceEst: 'बीमा अनुमान',
    patientPortion: 'मरीज का हिस्सा',
    chairSideMode: 'चेयर-साइड मोड',
    adminMode: 'एडमिन मोड',
    proceduresAcrossPhases: '{1} चरणों में {0} प्रक्रियाएं',

    // Scheduling
    day: 'दिन',
    week: 'सप्ताह',
    today: 'आज',
    providerFilter: 'सभी प्रदाता',
    productionGoal: 'उत्पादन लक्ष्य',
    waitlist: 'प्रतीक्षा सूची',

    // Prescriptions
    activeRx: 'सक्रिय',
    pastRx: 'पिछले',
    templates: 'टेम्पलेट',
    interactionCheck: 'इंटरैक्शन जांच',

    // Lab Cases
    ordered: 'ऑर्डर किया',
    sentToLab: 'लैब को भेजा',
    inFabrication: 'निर्माण में',
    shipped: 'भेज दिया',
    received: 'प्राप्त हुआ',
    labVendors: 'लैब विक्रेता',

    // Referrals
    allDirections: 'सभी',
    inbound: 'आने वाले',
    outbound: 'जाने वाले',
    generateLetter: 'पत्र बनाएं',

    // Reports
    production: 'उत्पादन',
    collections: 'संग्रह',
    schedulingReport: 'शेड्यूलिंग',
    treatmentAcceptance: 'उपचार स्वीकृति',
    recall: 'रिकॉल',
    grossProduction: 'सकल उत्पादन',
    netProduction: 'शुद्ध उत्पादन',
    collectionRate: 'संग्रह दर',
    plansPresented: 'प्रस्तुत योजनाएं',
    accepted: 'स्वीकृत',
    acceptanceRate: 'स्वीकृति दर',
    dueThisMonth: 'इस महीने देय',
    scheduled: 'निर्धारित',
    completed: 'पूर्ण',
    overdue: 'अतिदेय',
    reactivationRate: 'पुनर्सक्रियण दर',

    // Medical History
    timeline: 'समयरेखा',
    conditions: 'स्थितियां',
    medications: 'दवाइयां',
    allergies: 'एलर्जी',
    labResults: 'लैब परिणाम',
    vitals: 'वाइटल्स',
    immunizations: 'टीकाकरण',
    familyHistory: 'पारिवारिक इतिहास',
    imaging: 'इमेजिंग',
    documents: 'दस्तावेज़',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'ऑडिट लॉग',
    compliance: 'अनुपालन',
    multiTenancy: 'मल्टी-टेनेंसी',
    sso: 'SSO और सुरक्षा',
    featureFlags: 'फ़ीचर फ़्लैग',
    apiManagement: 'API प्रबंधन',
    dataManagement: 'डेटा प्रबंधन',

    // Integrations
    ehr: 'EHR',
    labs: 'लैब',
    telehealth: 'टेलीहेल्थ',
    aiMl: 'AI/ML',
    wearables: 'पहनने योग्य',
    connected: 'जुड़ा हुआ',
    disconnected: 'डिस्कनेक्ट',
    available: 'उपलब्ध',

    // Components
    status: 'स्थिति',
    healthy: 'स्वस्थ',
    caries: 'कैरीज़',
    restored: 'पुनर्स्थापित',
    missing: 'अनुपस्थित',
    implant: 'इम्प्लांट',
    crownStatus: 'क्राउन',
    bridge: 'ब्रिज',
    veneer: 'वीनियर',
    surfaces: 'सतहें',
    procedureHistory: 'प्रक्रिया इतिहास',
    addProcedure: 'प्रक्रिया जोड़ें',
    totalCharged: 'कुल चार्ज',
    insurancePayment: 'बीमा भुगतान',
    patientResponsibility: 'मरीज की जिम्मेदारी',
    expand: 'विस्तार करें',
    policyNumber: 'पॉलिसी #',
    planType: 'योजना प्रकार',
    annualMax: 'वार्षिक अधिकतम',
    used: 'उपयोग किया',
    remaining: 'शेष',
    coverageByCategory: 'श्रेणी के अनुसार कवरेज',
    preventive: 'निवारक',
    basic: 'बुनियादी',
    major: 'प्रमुख',
    ortho: 'ऑर्थो',
    current: 'वर्तमान',
    thirtyDay: '30 दिन',
    sixtyDay: '60 दिन',
    ninetyPlus: '90+ दिन',
    totalBalance: 'कुल शेष',
    monthlyPayment: 'मासिक भुगतान',
    paymentsRemaining: 'शेष भुगतान',
    nextPayment: 'अगला भुगतान',
    paymentProgress: 'भुगतान प्रगति',
    choosePlan: 'योजना चुनें',
    aiInsight: 'AI अंतर्दृष्टि',
    confidence: 'विश्वास',
    revoke: 'रद्द करें',
    exams: 'परीक्षाएं',
    phaseTotal: 'चरण कुल',
    mon: 'सोम',
    tue: 'मंगल',
    wed: 'बुध',
    thu: 'गुरु',
    fri: 'शुक्र',
    sat: 'शनि',
    sun: 'रवि',
    thinking: 'सोच रहा है...',
    followUpPlaceholder: 'अनुवर्ती प्रश्न पूछें...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: 'होम', features: 'विशेषताएं', pricing: 'मूल्य', clinicsNav: 'क्लीनिक', aiAssistant: 'AI सहायक', forBusiness: 'व्यापार के लिए', dashboard: 'डैशबोर्ड', getStarted: 'शुरू करें', tryDemo: 'डेमो आज़माएं',
    heroTagline: 'जॉर्जिया के लिए डेंटल प्लेटफॉर्म', heroTitle: 'सभी डेंटल क्लीनिक हब', heroSubtitle: 'जॉर्जिया में सर्वश्रेष्ठ दंत चिकित्सा खोजने के लिए आपका AI सहायक',
    searchPlaceholder: 'क्लीनिक, सेवाएं खोजें या कुछ पूछें...', chipImplant: 'त्बिलिसी में सर्वश्रेष्ठ इम्प्लांट क्लीनिक', chipWhitening: 'मेरे पास दांत सफेद करना', chipEmergency: 'आपातकालीन दंत चिकित्सा', chipOrtho: 'वयस्कों के लिए ऑर्थोडॉन्टिक्स', scrollExplore: 'देखने के लिए स्क्रॉल करें',
    topRated: 'त्बिलिसी के सर्वश्रेष्ठ डेंटल क्लीनिक', viewAllClinics: 'सभी क्लीनिक देखें', statClinics: 'क्लीनिक', statNoShows: 'कम अनुपस्थिति', statBooking: 'ऑनलाइन बुकिंग', statDentists: 'दंत चिकित्सक', statRating: 'औसत रेटिंग', statPatients: 'मरीज',
    findClinics: 'सर्वश्रेष्ठ क्लीनिक खोजें', clinicsTitle: 'जॉर्जिया में डेंटल क्लीनिक', verifiedClinics: 'सत्यापित क्लीनिक', reviews: 'समीक्षाएं',
    callClinic: 'कॉल करें', bookAppointment: 'अपॉइंटमेंट बुक करें', services: 'सेवाएं', workingHours: 'कार्य समय', priceRange: 'मूल्य सीमा', location: 'स्थान',
    bookingTitle: 'अपॉइंटमेंट बुक करें', step: 'चरण', selectClinic: 'क्लीनिक चुनें', selectService: 'सेवा चुनें', selectDate: 'तारीख चुनें', selectTime: 'समय चुनें', confirm: 'पुष्टि करें', next: 'अगला', back: 'पीछे',
    viewPitch: 'प्रस्तुति देखें',
    shareLocation: 'नज़दीकी क्लीनिक के लिए लोकेशन साझा करें',
    locationShared: 'लोकेशन साझा हुई — नज़दीकी दिखा रहे हैं',
    forBusinessBtn: 'व्यापार के लिए',
    ownClinic: 'क्या आप एक डेंटल क्लीनिक के मालिक हैं?',
    claimText: 'अपनी क्लीनिक को हमारे डेटाबेस में रजिस्टर करें या जोड़ें।',
    getListed: 'रजिस्टर करें →',
    searchByName: 'नाम, जिले या सेवा से खोजें...',
    hideMap: 'मानचित्र छुपाएं',
    showMap: 'मानचित्र',
    nearMe: 'मेरे पास',
    clinicsMatch: 'क्लीनिक मिलती हैं',
    loadingMore: 'लोड हो रहा है...',
    visitWebsite: 'वेबसाइट देखें',
    clinicsAvailable: 'क्लीनिक उपलब्ध',
    clinicsFound: 'क्लीनिक मिलीं',
    confirmBooking: 'बुकिंग की पुष्टि करें',
    bookingConfirmed: 'आपकी अपॉइंटमेंट बुक हो गई!',
    patientName: 'मरीज का नाम',
    phoneNumber: 'फोन नंबर',
    email: 'ईमेल',
    notes: 'नोट्स (वैकल्पिक)',
    businessHeroBadge: '15+ मॉड्यूल  ·  212+ क्लीनिक  ·  Gemini AI',
    businessHeroTitle: 'डेंटल क्लीनिक ऑपरेटिंग सिस्टम',
    businessHeroSubtitle: 'क्लिनिकल चार्टिंग, पेरियोडॉन्टल विश्लेषण, उपचार योजना, शेड्यूलिंग, बिलिंग, ई-प्रिस्क्रिप्शन, लैब प्रबंधन और AI डायग्नोस्टिक्स — जॉर्जिया के लिए एक प्लेटफॉर्म।',
    theProblem: 'समस्या',
    problemSubtitle: 'जॉर्जियाई डेंटल क्लीनिक खंडित उपकरणों के कारण दैनिक राजस्व खो रही हैं',
    excelChaos: 'Excel और WhatsApp अराजकता',
    excelChaosDetail: 'क्लीनिक स्प्रेडशीट और चैट से अपॉइंटमेंट प्रबंधित करती हैं। शून्य स्वचालन, निरंतर त्रुटियां।',
    noShowRate: '25% अनुपस्थिति दर',
    noShowDetail: 'स्वचालित रिमाइंडर के बिना मरीज अपॉइंटमेंट भूल जाते हैं। खाली कुर्सियां = ₾500+/दिन नुकसान।',
    paperCharts: '2026 में कागज़ी चार्ट',
    paperChartsDetail: 'हस्तलिखित क्लिनिकल नोट्स, कोई डिजिटल ओडोन्टोग्राम नहीं। महत्वपूर्ण डेटा फाइल कैबिनेट में बंद।',
    insuranceBlackHole: 'बीमा ब्लैक होल',
    insuranceDetail: 'Aldagi, GPI, Imedi L को मैनुअल दावे घंटों लगते हैं। अस्वीकृत दावे जमा होते रहते हैं।',
    oneplatform: 'एक प्लेटफॉर्म, सभी मॉड्यूल',
    platformSubtitle: 'डेंटल प्रैक्टिस के लिए 15 एकीकृत मॉड्यूल',
    clinical: 'नैदानिक',
    operations: 'संचालन',
    analyticsEnterprise: 'विश्लेषण और एंटरप्राइज़',
    digitalOdontogram: 'डिजिटल ओडोन्टोग्राम',
    digitalOdontogramDetail: 'FDI 32 दांत चार्ट, 5 सतह ट्रैकिंग।',
    perioCharting: 'पेरियोडॉन्टल चार्टिंग',
    perioChartingDetail: '192 स्थान पेरियोडॉन्टल ग्रिड। 6 बिंदु प्रोबिंग, BOP, CAL।',
    treatmentPlanning: 'उपचार योजना',
    treatmentPlanningDetail: 'CDT कोड के साथ चरणबद्ध योजनाएं, बीमा अनुमान। AI सीक्वेंसिंग।',
    soapNotes: 'SOAP नोट्स + AI स्क्राइब',
    soapNotesDetail: 'टेम्पलेट के साथ संरचित क्लिनिकल डॉक्यूमेंटेशन। Gemini आवाज़ से नोट्स बनाता है।',
    multiChairScheduling: 'बहु-कुर्सी शेड्यूलिंग',
    multiChairDetail: 'कई ऑपरेटरी के साथ साप्ताहिक दृश्य। डॉक्टर रंग कोडिंग।',
    billingInsurance: 'बिलिंग और बीमा',
    billingDetail: 'Aldagi, GPI, Imedi L दावा ट्रैकिंग। मरीज खाता, भुगतान योजनाएं।',
    ePrescribing: 'ई-प्रिस्क्रिप्शन',
    ePrescribingDetail: 'टेम्पलेट के साथ डिजिटल नुस्खे। Gemini दवा इंटरैक्शन जांच।',
    labTracking: 'लैब ट्रैकिंग',
    labTrackingDetail: 'कानबान: ऑर्डर → निर्माण → शिपमेंट → प्राप्त।',
    productionReports: 'उत्पादन रिपोर्ट',
    productionReportsDetail: 'सकल/शुद्ध उत्पादन, संग्रह दर, उपचार स्वीकृति।',
    referralMgmt: 'रेफरल प्रबंधन',
    referralMgmtDetail: 'विशेषज्ञों को आने/जाने वाले रेफरल। AI जनित पत्र।',
    medicalHistory: 'चिकित्सा इतिहास',
    medicalHistoryDetail: '11 दृश्य मरीज रिकॉर्ड: समयरेखा, स्थितियां, दवाइयां, एलर्जी।',
    enterpriseAdmin: 'एंटरप्राइज़ एडमिन',
    enterpriseAdminDetail: 'RBAC, ऑडिट लॉग, अनुपालन, मल्टी-टेनेंसी, SSO, API प्रबंधन।',
    geminiBuiltIn: 'अंतर्निहित Gemini AI',
    geminiSubtitle: 'हर मॉड्यूल Google Gemini 3.1 द्वारा संचालित',
    xrayAnalysis: 'एक्स-रे विश्लेषण',
    xrayDetail: 'AI कैरीज़ डिटेक्शन के लिए डेंटल एक्स-रे अपलोड करें।',
    perioAssessment: 'पेरियोडॉन्टल मूल्यांकन',
    perioAssessmentDetail: 'प्रोबिंग डेटा से स्वचालित AAP स्टेजिंग/ग्रेडिंग।',
    clinicalScribe: 'क्लिनिकल स्क्राइब',
    clinicalScribeDetail: 'वॉइस रिकॉर्डिंग या चार्ट डेटा से SOAP नोट्स जनरेशन।',
    riskProfiling: 'जोखिम प्रोफाइलिंग',
    riskProfilingDetail: 'डेंटल रिस्क प्रोफाइल के लिए स्थितियों, पारिवारिक इतिहास का विश्लेषण।',
    treatmentSequencing: 'उपचार सीक्वेंसिंग',
    treatmentSequencingDetail: 'उपचार और बीमा को ध्यान में रखते हुए AI अनुकूलित उपचार चरण।',
    patientComm: 'मरीज संवाद',
    patientCommDetail: 'जॉर्जियन में मरीज-अनुकूल स्पष्टीकरण का निर्माण।',
    georgianEcosystem: 'जॉर्जियाई इकोसिस्टम तैयार',
    integrationsSubtitle: 'स्थानीय बीमा, भुगतान और मैसेजिंग के साथ पूर्व-निर्मित एकीकरण',
    insurance: 'बीमा',
    payments: 'भुगतान',
    messaging: 'मैसेजिंग',
    ehrLabs: 'EHR और लैब',
    clinicsInDb: 'डेटाबेस में क्लीनिक',
    platformModules: 'प्लेटफॉर्म मॉड्यूल',
    aiTools: 'AI उपकरण (Gemini)',
    integrations: 'एकीकरण',
    pricingTitle: 'मूल्य',
    pricingSubtitle: 'निःशुल्क शुरू करें, बढ़ने पर स्केल करें',
    trustedBy: 'क्लीनिकों का विश्वास',
    readyModernize: 'आधुनिकीकरण के लिए तैयार?',
    joinCount: 'जॉर्जिया में 212+ क्लीनिकों से जुड़ें।',
    startTrial: 'निःशुल्क शुरू करें',
    contactSales: 'बिक्री से संपर्क करें',
    noCreditCard: 'क्रेडिट कार्ड आवश्यक नहीं  ·  निःशुल्क योजना  ·  5 मिनट में सेटअप',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'डैशबोर्ड',
    navPatients: 'मरीज',
    navChart: 'चार्ट',
    navPerio: 'पेरियो',
    navTreatmentPlans: 'उपचार योजनाएं',
    navNotes: 'नोट्स',
    navScheduling: 'शेड्यूलिंग',
    navBilling: 'बिलिंग',
    navPrescriptions: 'नुस्खे',
    navLabCases: 'लैब केस',
    navReferrals: 'रेफरल',
    navReports: 'रिपोर्ट',
    navMedHistory: 'चिकित्सा इतिहास',
    navIntegrations: 'एकीकरण',
    navEnterprise: 'एंटरप्राइज़',
    sectionClinical: 'नैदानिक',
    sectionOperations: 'संचालन',
    sectionAnalytics: 'विश्लेषण',
    sectionAiTools: 'AI उपकरण',
    sectionAdmin: 'प्रशासन',

    // Booking Page
    chooseClinic: 'क्लीनिक चुनें',
    selectAService: 'सेवा चुनें',
    pickADate: 'तारीख चुनें',
    pickATime: 'समय चुनें',
    confirmYourBooking: 'अपनी बुकिंग की पुष्टि करें',
    clinicLabel: 'क्लीनिक:',
    serviceLabel: 'सेवा:',
    dateLabel: 'तारीख:',
    timeLabel: 'समय:',

    // AI Page
    send: 'भेजें',
    procedure: 'प्रक्रिया',
    observations: 'अवलोकन',
    aiThinking: 'AI सोच रहा है...',
    summarizeHistory: 'मरीज का इतिहास सारांशित करें',
    generateTxPlan: 'उपचार योजना बनाएं',
    checkDrugInteractions: 'दवा इंटरैक्शन जांचें',
    writeClinicalNote: 'क्लिनिकल नोट लिखें',
    askAiAssistant: 'AI सहायक से पूछें...',
    dropXray: 'एक्स-रे छवि डालें या अपलोड करने के लिए क्लिक करें',
    supportsFormats: 'DICOM, PNG, JPG समर्थित',
    analysisResults: 'विश्लेषण परिणाम (डेमो)',
    aiRecommendation: 'AI सिफारिश',
    exportToTxPlan: 'उपचार योजना में निर्यात करें',
    generateClinicalNote: 'क्लिनिकल नोट बनाएं',
    generatedSoap: 'जनरेट किया गया क्लिनिकल नोट (SOAP)',
    subjective: 'S — व्यक्तिपरक',
    objective: 'O — वस्तुनिष्ठ',
    assessment: 'A — मूल्यांकन',
    plan: 'P — योजना',
    copyToRecord: 'मरीज के रिकॉर्ड में कॉपी करें',
    aiPerioAssessment: 'AI पेरियोडॉन्टल मूल्यांकन',
    enterProbingData: 'AAP स्टेजिंग/ग्रेडिंग और उपचार सिफारिशों के लिए प्रोबिंग डेटा दर्ज करें।',
    analyzeWithGemini: 'Gemini से विश्लेषण करें',
    aiRiskAssessment: 'AI जोखिम मूल्यांकन',
    enterConditions: 'जोखिम प्रोफ़ाइल बनाने के लिए मरीज की स्थिति, पारिवारिक इतिहास और वाइटल दर्ज करें।',
    generateRiskProfile: 'जोखिम प्रोफ़ाइल बनाएं',
    patientCommunication: 'मरीज संवाद',
    generateExplanations: 'जॉर्जियन या अंग्रेज़ी में मरीज-अनुकूल उपचार स्पष्टीकरण बनाएं।',
    generateExplanation: 'स्पष्टीकरण बनाएं',
    patientFriendly: 'मरीज-अनुकूल स्पष्टीकरण',

    // Billing Page
    claims: 'दावे',
    ledger: 'खाता बही',
    aging: 'एजिंग',
    paymentPlans: 'भुगतान योजनाएं',
    eligibility: 'पात्रता',
    allFilter: 'सभी',
    submitted: 'प्रस्तुत',
    paid: 'भुगतान हुआ',
    denied: 'अस्वीकृत',
    patientLedger: 'मरीज खाता बही',
    agedAccounts: 'अतिदेय खाते',
    sendStatements: 'विवरण भेजें',
    activePaymentPlans: 'सक्रिय भुगतान योजनाएं',
    insuranceEligibility: 'बीमा पात्रता',

    // Clinical Charting
    odontogram: 'ओडोन्टोग्राम',
    perioTab: 'पेरियो',
    treatmentPlanTab: 'उपचार योजना',
    notesTab: 'नोट्स',
    progressNotes: 'प्रगति नोट्स',
    openFullPerio: 'पूर्ण पेरियोडॉन्टल चार्ट खोलें →',
    openFullTxPlanner: 'पूर्ण उपचार योजनाकार खोलें →',
    openClinicalNotes: 'क्लिनिकल नोट्स खोलें →',
    newExam: 'नई परीक्षा',
    voiceEntry: 'वॉइस एंट्री',
    bleedingIndex: 'रक्तस्राव सूचकांक',
    plaqueIndex: 'प्लाक सूचकांक',
    sitesAbove4: 'स्थान ≥ 4मिमी',
    sitesAbove6: 'स्थान ≥ 6मिमी',
    planA: 'योजना A: अनुशंसित',
    planB: 'योजना B: रूढ़िवादी',
    newPlan: '+ नई योजना',
    presentToPatient: 'मरीज को प्रस्तुत करें',
    sendToPortal: 'पोर्टल पर भेजें',
    totalFee: 'कुल शुल्क',
    insuranceEst: 'बीमा अनुमान',
    patientPortion: 'मरीज का हिस्सा',
    chairSideMode: 'चेयर-साइड मोड',
    adminMode: 'एडमिन मोड',
    proceduresAcrossPhases: '{1} चरणों में {0} प्रक्रियाएं',

    // Scheduling
    day: 'दिन',
    week: 'सप्ताह',
    today: 'आज',
    providerFilter: 'सभी प्रदाता',
    productionGoal: 'उत्पादन लक्ष्य',
    waitlist: 'प्रतीक्षा सूची',

    // Prescriptions
    activeRx: 'सक्रिय',
    pastRx: 'पिछले',
    templates: 'टेम्पलेट',
    interactionCheck: 'इंटरैक्शन जांच',

    // Lab Cases
    ordered: 'ऑर्डर किया',
    sentToLab: 'लैब को भेजा',
    inFabrication: 'निर्माण में',
    shipped: 'भेज दिया',
    received: 'प्राप्त हुआ',
    labVendors: 'लैब विक्रेता',

    // Referrals
    allDirections: 'सभी',
    inbound: 'आने वाले',
    outbound: 'जाने वाले',
    generateLetter: 'पत्र बनाएं',

    // Reports
    production: 'उत्पादन',
    collections: 'संग्रह',
    schedulingReport: 'शेड्यूलिंग',
    treatmentAcceptance: 'उपचार स्वीकृति',
    recall: 'रिकॉल',
    grossProduction: 'सकल उत्पादन',
    netProduction: 'शुद्ध उत्पादन',
    collectionRate: 'संग्रह दर',
    plansPresented: 'प्रस्तुत योजनाएं',
    accepted: 'स्वीकृत',
    acceptanceRate: 'स्वीकृति दर',
    dueThisMonth: 'इस महीने देय',
    scheduled: 'निर्धारित',
    completed: 'पूर्ण',
    overdue: 'अतिदेय',
    reactivationRate: 'पुनर्सक्रियण दर',

    // Medical History
    timeline: 'समयरेखा',
    conditions: 'स्थितियां',
    medications: 'दवाइयां',
    allergies: 'एलर्जी',
    labResults: 'लैब परिणाम',
    vitals: 'वाइटल्स',
    immunizations: 'टीकाकरण',
    familyHistory: 'पारिवारिक इतिहास',
    imaging: 'इमेजिंग',
    documents: 'दस्तावेज़',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'ऑडिट लॉग',
    compliance: 'अनुपालन',
    multiTenancy: 'मल्टी-टेनेंसी',
    sso: 'SSO और सुरक्षा',
    featureFlags: 'फ़ीचर फ़्लैग',
    apiManagement: 'API प्रबंधन',
    dataManagement: 'डेटा प्रबंधन',

    // Integrations
    ehr: 'EHR',
    labs: 'लैब',
    telehealth: 'टेलीहेल्थ',
    aiMl: 'AI/ML',
    wearables: 'पहनने योग्य',
    connected: 'जुड़ा हुआ',
    disconnected: 'डिस्कनेक्ट',
    available: 'उपलब्ध',

    // Components
    status: 'स्थिति',
    healthy: 'स्वस्थ',
    caries: 'कैरीज़',
    restored: 'पुनर्स्थापित',
    missing: 'अनुपस्थित',
    implant: 'इम्प्लांट',
    crownStatus: 'क्राउन',
    bridge: 'ब्रिज',
    veneer: 'वीनियर',
    surfaces: 'सतहें',
    procedureHistory: 'प्रक्रिया इतिहास',
    addProcedure: 'प्रक्रिया जोड़ें',
    totalCharged: 'कुल चार्ज',
    insurancePayment: 'बीमा भुगतान',
    patientResponsibility: 'मरीज की जिम्मेदारी',
    expand: 'विस्तार करें',
    policyNumber: 'पॉलिसी #',
    planType: 'योजना प्रकार',
    annualMax: 'वार्षिक अधिकतम',
    used: 'उपयोग किया',
    remaining: 'शेष',
    coverageByCategory: 'श्रेणी के अनुसार कवरेज',
    preventive: 'निवारक',
    basic: 'बुनियादी',
    major: 'प्रमुख',
    ortho: 'ऑर्थो',
    current: 'वर्तमान',
    thirtyDay: '30 दिन',
    sixtyDay: '60 दिन',
    ninetyPlus: '90+ दिन',
    totalBalance: 'कुल शेष',
    monthlyPayment: 'मासिक भुगतान',
    paymentsRemaining: 'शेष भुगतान',
    nextPayment: 'अगला भुगतान',
    paymentProgress: 'भुगतान प्रगति',
    choosePlan: 'योजना चुनें',
    aiInsight: 'AI अंतर्दृष्टि',
    confidence: 'विश्वास',
    revoke: 'रद्द करें',
    exams: 'परीक्षाएं',
    phaseTotal: 'चरण कुल',
    mon: 'सोम',
    tue: 'मंगल',
    wed: 'बुध',
    thu: 'गुरु',
    fri: 'शुक्र',
    sat: 'शनि',
    sun: 'रवि',
    thinking: 'सोच रहा है...',
    followUpPlaceholder: 'अनुवर्ती प्रश्न पूछें...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  },

  msa: {
    home: 'الرئيسية', features: 'الميزات', pricing: 'الأسعار', clinicsNav: 'العيادات', aiAssistant: 'مساعد AI', forBusiness: 'للأعمال', dashboard: 'لوحة التحكم', getStarted: 'ابدأ', tryDemo: 'جرب العرض',
    heroTagline: 'منصة طب الأسنان لجورجيا', heroTitle: 'مركز جميع عيادات الأسنان', heroSubtitle: 'مساعدك AI للعثور على أفضل رعاية أسنان في جورجيا',
    searchPlaceholder: 'ابحث عن عيادات أو خدمات...', chipImplant: 'أفضل عيادات الزراعة في تبليسي', chipWhitening: 'تبييض الأسنان بالقرب مني', chipEmergency: 'رعاية أسنان طارئة', chipOrtho: 'تقويم الأسنان للبالغين', scrollExplore: 'مرر للاستكشاف',
    topRated: 'أفضل عيادات الأسنان في تبليسي', viewAllClinics: 'عرض جميع العيادات', statClinics: 'العيادات', statNoShows: 'غياب أقل', statBooking: 'حجز عبر الإنترنت', statDentists: 'أطباء أسنان', statRating: 'متوسط التقييم', statPatients: 'المرضى',
    findClinics: 'ابحث عن أفضل العيادات', clinicsTitle: 'عيادات الأسنان في جورجيا', verifiedClinics: 'عيادات موثقة', reviews: 'تقييمات',
    callClinic: 'اتصل', bookAppointment: 'احجز موعد', services: 'الخدمات', workingHours: 'ساعات العمل', priceRange: 'نطاق الأسعار', location: 'الموقع',
    bookingTitle: 'احجز موعد', step: 'خطوة', selectClinic: 'اختر العيادة', selectService: 'اختر الخدمة', selectDate: 'اختر التاريخ', selectTime: 'اختر الوقت', confirm: 'تأكيد', next: 'التالي', back: 'رجوع',
    viewPitch: 'عرض العرض التقديمي',
    shareLocation: 'شارك موقعك للعيادات القريبة',
    locationShared: 'تم مشاركة الموقع — عرض القريبة',
    forBusinessBtn: 'للأعمال',
    ownClinic: 'هل تملك عيادة أسنان؟',
    claimText: 'سجّل عيادتك أو أضفها إلى قاعدة بياناتنا.',
    getListed: 'سجّل الآن →',
    searchByName: 'بحث بالاسم أو المنطقة أو الخدمة...',
    hideMap: 'إخفاء الخريطة',
    showMap: 'الخريطة',
    nearMe: 'بالقرب مني',
    clinicsMatch: 'عيادات مطابقة',
    loadingMore: 'جارٍ التحميل...',
    visitWebsite: 'زيارة الموقع',
    clinicsAvailable: 'عيادات متاحة',
    clinicsFound: 'عيادات وُجدت',
    confirmBooking: 'تأكيد الحجز',
    bookingConfirmed: 'تم تأكيد موعدك!',
    patientName: 'اسم المريض',
    phoneNumber: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    notes: 'ملاحظات (اختياري)',
    businessHeroBadge: '15+ وحدة  ·  212+ عيادة  ·  Gemini AI',
    businessHeroTitle: 'نظام تشغيل عيادات الأسنان',
    businessHeroSubtitle: 'الرسم السريري، تحليل اللثة، تخطيط العلاج، الجدولة، الفوترة، الوصفات الإلكترونية، إدارة المختبر وتشخيص AI — كلها في منصة واحدة لجورجيا.',
    theProblem: 'المشكلة',
    problemSubtitle: 'عيادات الأسنان الجورجية تخسر إيرادات يومياً بسبب الأدوات المجزأة',
    excelChaos: 'فوضى Excel وWhatsApp',
    excelChaosDetail: 'العيادات تدير المواعيد عبر الجداول ومجموعات الدردشة. صفر أتمتة، أخطاء مستمرة.',
    noShowRate: 'معدل غياب 25%',
    noShowDetail: 'بدون تذكيرات تلقائية، ينسى المرضى المواعيد. الكراسي الفارغة تعني خسارة ₾500+/يوم.',
    paperCharts: 'سجلات ورقية في 2026',
    paperChartsDetail: 'ملاحظات سريرية مكتوبة بخط اليد، بدون مخطط أسنان رقمي. بيانات حرجة محبوسة في الخزائن.',
    insuranceBlackHole: 'الثقب الأسود للتأمين',
    insuranceDetail: 'المطالبات اليدوية إلى Aldagi وGPI وImedi L تستغرق ساعات. المطالبات المرفوضة تتراكم.',
    oneplatform: 'منصة واحدة، كل الوحدات',
    platformSubtitle: '15 وحدة متكاملة مصممة لممارسات طب الأسنان',
    clinical: 'سريري',
    operations: 'العمليات',
    analyticsEnterprise: 'التحليلات والمؤسسة',
    digitalOdontogram: 'مخطط أسنان رقمي',
    digitalOdontogramDetail: 'مخطط FDI 32 سن مع تتبع 5 أسطح.',
    perioCharting: 'رسم اللثة',
    perioChartingDetail: 'شبكة لثوية 192 نقطة. سبر 6 نقاط، BOP، CAL.',
    treatmentPlanning: 'تخطيط العلاج',
    treatmentPlanningDetail: 'خطط مرحلية مع أكواد CDT، تقديرات التأمين. تسلسل AI.',
    soapNotes: 'ملاحظات SOAP + كاتب AI',
    soapNotesDetail: 'توثيق سريري منظم بقوالب. Gemini يولد ملاحظات من الصوت.',
    multiChairScheduling: 'جدولة متعددة الكراسي',
    multiChairDetail: 'عرض أسبوعي مع عدة غرف عمليات. ترميز لوني للأطباء.',
    billingInsurance: 'الفوترة والتأمين',
    billingDetail: 'تتبع مطالبات Aldagi وGPI وImedi L. دفتر المريض، خطط الدفع.',
    ePrescribing: 'الوصفات الإلكترونية',
    ePrescribingDetail: 'وصفات رقمية بقوالب. فحص تفاعلات الأدوية عبر Gemini.',
    labTracking: 'تتبع المختبر',
    labTrackingDetail: 'كانبان: تم الطلب → التصنيع → الشحن → الاستلام.',
    productionReports: 'تقارير الإنتاج',
    productionReportsDetail: 'الإنتاج الإجمالي/الصافي، معدل التحصيل، قبول العلاج.',
    referralMgmt: 'إدارة الإحالات',
    referralMgmtDetail: 'إحالات واردة/صادرة للمتخصصين. خطابات مولدة بالـ AI.',
    medicalHistory: 'التاريخ الطبي',
    medicalHistoryDetail: 'سجل مريض 11 عرض: الجدول الزمني، الحالات، الأدوية، الحساسيات.',
    enterpriseAdmin: 'إدارة المؤسسة',
    enterpriseAdminDetail: 'RBAC، سجل التدقيق، الامتثال، تعدد المستأجرين، SSO، إدارة API.',
    geminiBuiltIn: 'Gemini AI مدمج',
    geminiSubtitle: 'كل وحدة مدعومة بـ Google Gemini 3.1',
    xrayAnalysis: 'تحليل الأشعة السينية',
    xrayDetail: 'ارفع صور الأشعة السينية للأسنان للكشف عن التسوس بالـ AI.',
    perioAssessment: 'تقييم اللثة',
    perioAssessmentDetail: 'تصنيف/تدريج AAP تلقائي من بيانات السبر.',
    clinicalScribe: 'الكاتب السريري',
    clinicalScribeDetail: 'إنشاء ملاحظات SOAP من التسجيلات الصوتية أو بيانات السجل.',
    riskProfiling: 'تقييم المخاطر',
    riskProfilingDetail: 'تحليل الحالات والتاريخ العائلي لإنشاء ملف مخاطر الأسنان.',
    treatmentSequencing: 'تسلسل العلاج',
    treatmentSequencingDetail: 'تسلسل علاج محسّن بالـ AI مع مراعاة الشفاء والتأمين.',
    patientComm: 'تواصل المريض',
    patientCommDetail: 'إنشاء شروحات مفهومة للمريض بالجورجية.',
    georgianEcosystem: 'النظام البيئي الجورجي جاهز',
    integrationsSubtitle: 'تكاملات مسبقة مع التأمين والمدفوعات والمراسلات المحلية',
    insurance: 'التأمين',
    payments: 'المدفوعات',
    messaging: 'المراسلات',
    ehrLabs: 'السجل الصحي الإلكتروني والمختبرات',
    clinicsInDb: 'العيادات في قاعدة البيانات',
    platformModules: 'وحدات المنصة',
    aiTools: 'أدوات AI (Gemini)',
    integrations: 'التكاملات',
    pricingTitle: 'الأسعار',
    pricingSubtitle: 'ابدأ مجاناً، توسع مع النمو',
    trustedBy: 'ثقة العيادات',
    readyModernize: 'مستعد للتحديث؟',
    joinCount: 'انضم إلى 212+ عيادة في جورجيا.',
    startTrial: 'ابدأ مجاناً',
    contactSales: 'تواصل مع المبيعات',
    noCreditCard: 'لا حاجة لبطاقة ائتمان  ·  خطة مجانية  ·  إعداد في 5 دقائق',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'لوحة التحكم',
    navPatients: 'المرضى',
    navChart: 'السجل',
    navPerio: 'اللثة',
    navTreatmentPlans: 'خطط العلاج',
    navNotes: 'الملاحظات',
    navScheduling: 'الجدولة',
    navBilling: 'الفوترة',
    navPrescriptions: 'الوصفات',
    navLabCases: 'حالات المختبر',
    navReferrals: 'الإحالات',
    navReports: 'التقارير',
    navMedHistory: 'التاريخ الطبي',
    navIntegrations: 'التكاملات',
    navEnterprise: 'المؤسسة',
    sectionClinical: 'سريري',
    sectionOperations: 'العمليات',
    sectionAnalytics: 'التحليلات',
    sectionAiTools: 'أدوات AI',
    sectionAdmin: 'الإدارة',

    // Booking Page
    chooseClinic: 'اختر عيادة',
    selectAService: 'اختر خدمة',
    pickADate: 'اختر تاريخاً',
    pickATime: 'اختر وقتاً',
    confirmYourBooking: 'أكد حجزك',
    clinicLabel: 'العيادة:',
    serviceLabel: 'الخدمة:',
    dateLabel: 'التاريخ:',
    timeLabel: 'الوقت:',

    // AI Page
    send: 'إرسال',
    procedure: 'إجراء',
    observations: 'ملاحظات',
    aiThinking: 'AI يفكر...',
    summarizeHistory: 'تلخيص تاريخ المريض',
    generateTxPlan: 'إنشاء خطة علاج',
    checkDrugInteractions: 'فحص تفاعلات الأدوية',
    writeClinicalNote: 'كتابة ملاحظة سريرية',
    askAiAssistant: 'اسأل مساعد AI...',
    dropXray: 'أسقط صورة الأشعة أو انقر للرفع',
    supportsFormats: 'يدعم DICOM، PNG، JPG',
    analysisResults: 'نتائج التحليل (عرض)',
    aiRecommendation: 'توصية AI',
    exportToTxPlan: 'تصدير إلى خطة العلاج',
    generateClinicalNote: 'إنشاء ملاحظة سريرية',
    generatedSoap: 'ملاحظة سريرية مُنشأة (SOAP)',
    subjective: 'S — ذاتي',
    objective: 'O — موضوعي',
    assessment: 'A — التقييم',
    plan: 'P — الخطة',
    copyToRecord: 'نسخ إلى سجل المريض',
    aiPerioAssessment: 'تقييم AI لأمراض اللثة',
    enterProbingData: 'أدخل بيانات السبر للحصول على تصنيف AAP وتوصيات العلاج.',
    analyzeWithGemini: 'تحليل مع Gemini',
    aiRiskAssessment: 'تقييم AI للمخاطر',
    enterConditions: 'أدخل حالات المريض والتاريخ العائلي والعلامات الحيوية لإنشاء ملف المخاطر.',
    generateRiskProfile: 'إنشاء ملف المخاطر',
    patientCommunication: 'تواصل المريض',
    generateExplanations: 'إنشاء شروحات علاجية مفهومة للمريض بالجورجية أو الإنجليزية.',
    generateExplanation: 'إنشاء شرح',
    patientFriendly: 'شرح مفهوم للمريض',

    // Billing Page
    claims: 'المطالبات',
    ledger: 'دفتر الحسابات',
    aging: 'تقادم الديون',
    paymentPlans: 'خطط الدفع',
    eligibility: 'الأهلية',
    allFilter: 'الكل',
    submitted: 'مقدم',
    paid: 'مدفوع',
    denied: 'مرفوض',
    patientLedger: 'حساب المريض',
    agedAccounts: 'حسابات متأخرة',
    sendStatements: 'إرسال كشوفات',
    activePaymentPlans: 'خطط دفع نشطة',
    insuranceEligibility: 'أهلية التأمين',

    // Clinical Charting
    odontogram: 'مخطط الأسنان',
    perioTab: 'اللثة',
    treatmentPlanTab: 'خطة العلاج',
    notesTab: 'الملاحظات',
    progressNotes: 'ملاحظات التقدم',
    openFullPerio: 'فتح مخطط اللثة الكامل →',
    openFullTxPlanner: 'فتح مخطط العلاج الكامل →',
    openClinicalNotes: 'فتح الملاحظات السريرية →',
    newExam: 'فحص جديد',
    voiceEntry: 'إدخال صوتي',
    bleedingIndex: 'مؤشر النزيف',
    plaqueIndex: 'مؤشر اللويحة',
    sitesAbove4: 'مواقع ≥ 4مم',
    sitesAbove6: 'مواقع ≥ 6مم',
    planA: 'الخطة أ: الموصى بها',
    planB: 'الخطة ب: التحفظية',
    newPlan: '+ خطة جديدة',
    presentToPatient: 'تقديم للمريض',
    sendToPortal: 'إرسال إلى البوابة',
    totalFee: 'إجمالي الرسوم',
    insuranceEst: 'تقدير التأمين',
    patientPortion: 'حصة المريض',
    chairSideMode: 'وضع جانب الكرسي',
    adminMode: 'وضع المسؤول',
    proceduresAcrossPhases: '{0} إجراء عبر {1} مراحل',

    // Scheduling
    day: 'يوم',
    week: 'أسبوع',
    today: 'اليوم',
    providerFilter: 'جميع مقدمي الخدمة',
    productionGoal: 'هدف الإنتاج',
    waitlist: 'قائمة الانتظار',

    // Prescriptions
    activeRx: 'نشطة',
    pastRx: 'سابقة',
    templates: 'قوالب',
    interactionCheck: 'فحص التفاعلات',

    // Lab Cases
    ordered: 'تم الطلب',
    sentToLab: 'أُرسل للمختبر',
    inFabrication: 'قيد التصنيع',
    shipped: 'تم الشحن',
    received: 'تم الاستلام',
    labVendors: 'موردو المختبرات',

    // Referrals
    allDirections: 'الكل',
    inbound: 'واردة',
    outbound: 'صادرة',
    generateLetter: 'إنشاء خطاب',

    // Reports
    production: 'الإنتاج',
    collections: 'التحصيلات',
    schedulingReport: 'الجدولة',
    treatmentAcceptance: 'قبول العلاج',
    recall: 'إعادة الاستدعاء',
    grossProduction: 'الإنتاج الإجمالي',
    netProduction: 'الإنتاج الصافي',
    collectionRate: 'معدل التحصيل',
    plansPresented: 'الخطط المقدمة',
    accepted: 'مقبول',
    acceptanceRate: 'معدل القبول',
    dueThisMonth: 'مستحق هذا الشهر',
    scheduled: 'مجدول',
    completed: 'مكتمل',
    overdue: 'متأخر',
    reactivationRate: 'معدل إعادة التنشيط',

    // Medical History
    timeline: 'الجدول الزمني',
    conditions: 'الحالات',
    medications: 'الأدوية',
    allergies: 'الحساسيات',
    labResults: 'نتائج المختبر',
    vitals: 'العلامات الحيوية',
    immunizations: 'التطعيمات',
    familyHistory: 'التاريخ العائلي',
    imaging: 'التصوير',
    documents: 'المستندات',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'سجل التدقيق',
    compliance: 'الامتثال',
    multiTenancy: 'تعدد المستأجرين',
    sso: 'SSO والأمان',
    featureFlags: 'أعلام الميزات',
    apiManagement: 'إدارة API',
    dataManagement: 'إدارة البيانات',

    // Integrations
    ehr: 'السجل الصحي الإلكتروني',
    labs: 'المختبرات',
    telehealth: 'الطب عن بُعد',
    aiMl: 'AI/ML',
    wearables: 'الأجهزة القابلة للارتداء',
    connected: 'متصل',
    disconnected: 'غير متصل',
    available: 'متاح',

    // Components
    status: 'الحالة',
    healthy: 'سليم',
    caries: 'تسوس',
    restored: 'مرمم',
    missing: 'مفقود',
    implant: 'زرعة',
    crownStatus: 'تاج',
    bridge: 'جسر',
    veneer: 'قشرة',
    surfaces: 'الأسطح',
    procedureHistory: 'تاريخ الإجراءات',
    addProcedure: 'إضافة إجراء',
    totalCharged: 'إجمالي المحمّل',
    insurancePayment: 'دفعة التأمين',
    patientResponsibility: 'مسؤولية المريض',
    expand: 'توسيع',
    policyNumber: 'رقم البوليصة',
    planType: 'نوع الخطة',
    annualMax: 'الحد السنوي الأقصى',
    used: 'مستخدم',
    remaining: 'متبقي',
    coverageByCategory: 'التغطية حسب الفئة',
    preventive: 'وقائي',
    basic: 'أساسي',
    major: 'رئيسي',
    ortho: 'تقويم',
    current: 'حالي',
    thirtyDay: '30 يوم',
    sixtyDay: '60 يوم',
    ninetyPlus: '90+ يوم',
    totalBalance: 'الرصيد الإجمالي',
    monthlyPayment: 'الدفعة الشهرية',
    paymentsRemaining: 'الدفعات المتبقية',
    nextPayment: 'الدفعة التالية',
    paymentProgress: 'تقدم الدفع',
    choosePlan: 'اختر خطة',
    aiInsight: 'رؤية AI',
    confidence: 'الثقة',
    revoke: 'إلغاء',
    exams: 'الفحوصات',
    phaseTotal: 'إجمالي المرحلة',
    mon: 'اثن',
    tue: 'ثلا',
    wed: 'أرب',
    thu: 'خمي',
    fri: 'جمع',
    sat: 'سبت',
    sun: 'أحد',
    thinking: 'يفكر...',
    followUpPlaceholder: 'اطرح سؤال متابعة...',
    priorityCompleteRctOn: 'Priority: Complete RCT on #14, then restore #36. Schedule periodontal evaluation for bone loss assessment. Consider CBCT for more detailed 3D view of #14 lesion.',
    patientReportsPersistentDull: 'Patient reports persistent dull pain in upper left quadrant for 2 weeks. Pain increases with hot beverages. No spontaneous bleeding. Patient rates pain 5/10.',
    tooth14PositivePercussion: 'Tooth #14: Positive percussion test. Negative vitality (cold test). Periapical radiograph reveals 3mm radiolucency at apex. Probing depths WNL (2-3mm). No mobility. Adjacent teeth vital.',
    chronicPeriapicalAbscess14: 'Chronic periapical abscess #14. Pulp necrosis secondary to deep caries. No signs of acute infection.',
    english: 'English',
    patientLedgerU2014Giorgi: 'Patient Ledger \u2014 Giorgi Beridze',
    xrayAnalysis2: 'X-ray Analysis',
    uploadDentalRadiographsFor: 'Upload dental radiographs for AI-powered caries detection, bone level assessment, and periapical pathology identification.',
    perioAssessment2: 'Perio Assessment',
    automaticAapStaginggradingFrom: 'Automatic AAP staging/grading from probing data. Identifies progression, recommends SRP or surgical intervention.',
    clinicalScribe2: 'Clinical Scribe',
    generatesSoapNotesFrom: 'Generates SOAP notes from voice recordings or charting data. Uses CDT codes and ICD-10 automatically.',
    riskProfiling2: 'Risk Profiling',
    analyzesConditionsFamilyHistor: 'Analyzes conditions, family history, and vitals to generate comprehensive dental risk profiles.',
    treatmentSequencing2: 'Treatment Sequencing',
    aioptimizedTreatmentPhasingCon: 'AI-optimized treatment phasing considering healing periods, insurance benefit years, and clinical priorities.',
    patientCommunication2: 'Patient Communication',
    generatesPatientfriendlyExplan: 'Generates patient-friendly explanations in Georgian. Translates clinical jargon into understandable language.',
    insurance2: 'INSURANCE',
    automatedClaimsEligibilityVeri: 'Automated claims, eligibility verification, ERA posting',
    payments2: 'PAYMENTS',
    onlinePaymentsPaymentPlans: 'Online payments, payment plans, auto-billing',
    messaging2: 'MESSAGING',
    appointmentRemindersRecallCamp: 'Appointment reminders, recall campaigns, portal messaging',
    ehrLabs2: 'EHR & LABS',
    interoperableHealthRecordsLab: 'Interoperable health records, lab orders, imaging sync',
    clinicsInDatabase: 'Clinics in Database',
    platformModules2: 'Platform Modules',
    integrations2: 'Integrations',
    home2: 'Home',
    features2: 'Features',
    pricing2: 'Pricing',
    dashboard2: 'Dashboard',
    u00a92026McaiU2014: '\u00A9 2026 MCAI \u2014 Dental Clinic Operating System',
    openFullPeriodontalChart: 'Open Full Periodontal Chart →',
    openFullTreatmentPlanner: 'Open Full Treatment Planner →',
    openClinicalNotes2: 'Open Clinical Notes →',
    backToAllClinics: '← Back to all clinics',
    priceRange2: 'Price range:',
    bookAnAppointment: 'Book an Appointment',
    selectDate2: 'Select date',
    selectTime2: 'Select time',
    confirmBooking2: 'Confirm Booking →',
    clinics: 'Clinics',
    forBusiness2: 'For Business',
    u00a92026Mcai: '\u00A9 2026 MCAI',
    clinicalNotes: 'Clinical Notes',
    newNote: '+ New Note',
    template: 'Template:',
    crownPrep: 'Crown Prep',
    aiScribe: 'AI Scribe',
    recordYourClinicalEncounter: 'Record your clinical encounter and let AI generate structured SOAP notes automatically.',
    startRecording: 'Start Recording',
    generateNote: 'Generate Note',
    general: 'General',
    prosthetics: 'Prosthetics',
    typeToSearch: 'Type to search dental terms...',
    revenueToday: 'Revenue Today',
    noshows: 'No-shows',
    confirmed: 'Confirmed',
    time: 'TIME',
    patient: 'PATIENT',
    service: 'SERVICE',
    doctor: 'DOCTOR',
    status2: 'STATUS',
    addPatient: '+ Add Patient',
    mondayMarch19: 'Monday, March 19',
    gBeridzeCheckup: 'G. Beridze — Checkup',
    nKapanadzeWhitening: 'N. Kapanadze — Whitening',
    dGelashviliImplantPhase: 'D. Gelashvili — Implant Phase 2',
    lunchBreak: '— Lunch Break —',
    mTsiklauriOrthodontics: 'M. Tsiklauri — Orthodontics',
    aJavakhishviliRootCanal: 'A. Javakhishvili — Root Canal',
    lMchedlishviliExtraction: 'L. Mchedlishvili — Extraction',
    tLomidzeCheckup: 'T. Lomidze — Checkup',
    clinicName: 'Clinic Name',
    phone: 'Phone',
    address: 'Address',
    acceptedInsurance: 'Accepted Insurance',
    unison: 'Unison',
    saveSettings: 'Save Settings',
    aiToolsAreAvailable: 'AI tools are available in the full assistant view.',
    openTheFullAi: 'Open the full AI Assistant →',
    enterprise: 'Enterprise',
    rolebasedAccessControl: 'Role-Based Access Control',
    permissionMatrix: 'Permission Matrix',
    module: 'Module',
    admin: 'Admin',
    doctor2: 'Doctor',
    hygienist: 'Hygienist',
    reception: 'Reception',
    lab: 'Lab',
    patient2: 'Patient',
    patients: 'Patients',
    full: 'Full',
    read: 'Read',
    none: 'None',
    own: 'Own',
    billing: 'Billing',
    scheduling: 'Scheduling',
    reports: 'Reports',
    settings: 'Settings',
    labOrders: 'Lab Orders',
    auditLog2: 'Audit Log',
    allTypes: 'All Types',
    last7Days: 'Last 7 days',
    complianceDashboard: 'Compliance Dashboard',
    complianceChecklist: 'Compliance Checklist',
    pass: 'PASS',
    dataEncryptedAtRest: 'Data encrypted at rest (AES-256)',
    dataEncryptedInTransit: 'Data encrypted in transit (TLS 1.3)',
    mfaEnabledForAll: 'MFA enabled for all admin accounts',
    warn: 'WARN',
    dataRetentionPolicyReview: 'Data retention policy review overdue by 14 days',
    auditLoggingActiveOn: 'Audit logging active on all modules',
    multitenancyManagement: 'Multi-Tenancy Management',
    singleSignonSso: 'Single Sign-On (SSO)',
    saml20: 'SAML 2.0',
    enterpriseIdentityProviderInte: 'Enterprise identity provider integration',
    configured: 'Configured',
    openidConnect: 'OpenID Connect',
    oauth20BasedAuthentication: 'OAuth 2.0 based authentication',
    available2: 'Available',
    signInWithGoogle: 'Sign in with Google organization accounts',
    connected2: 'Connected',
    azureAd: 'Azure AD',
    microsoftAzureActiveDirectory: 'Microsoft Azure Active Directory',
    featureFlags2: 'Feature Flags',
    aixrayanalysis: 'ai_xray_analysis',
    aipoweredXrayAnalysisAnd: 'AI-powered X-ray analysis and anomaly detection',
    voiceperio: 'voice_perio',
    voiceactivatedPeriodontalChart: 'Voice-activated periodontal charting',
    patientportalv2: 'patient_portal_v2',
    nextgenerationPatientSelfservi: 'Next-generation patient self-service portal',
    whatsappreminders: 'whatsapp_reminders',
    multilanguage: 'multi_language',
    multilanguageSupportGeorgianEn: 'Multi-language support (Georgian, English, Russian)',
    apiManagement2: 'API Management',
    requests24h: 'Requests (24h)',
    avgLatency: 'Avg Latency',
    uptime: 'Uptime',
    apiKeys: 'API Keys',
    dataManagement2: 'Data Management',
    storageUsed: 'Storage Used',
    of100Gb: 'of 100 GB',
    totalRecords: 'Total Records',
    lastBackup: 'Last Backup',
    nextIn4h: 'Next: in 4h',
    dataOperations: 'Data Operations',
    exportAllData: 'Export All Data',
    downloadCompleteDatabaseExport: 'Download complete database export in FHIR R4 format',
    export: 'Export',
    purgeOldRecords: 'Purge Old Records',
    removeRecordsPastRetention: 'Remove records past retention period (7+ years)',
    purge: 'Purge',
    dataMigration: 'Data Migration',
    importDataFromExternal: 'Import data from external systems (CSV, HL7, FHIR)',
    import: 'Import',
    finance: 'Finance',
    revenueInvoicesPayments: 'Revenue, invoices & payments',
    exportReport: 'Export Report',
    monthlyRevenue: 'Monthly Revenue',
    u20be12400: '\u20BE12,400',
    pending: 'Pending',
    u20be2100: '\u20BE2,100',
    str208: '-5%',
    thisWeek: 'This Week',
    u20be3800: '\u20BE3,800',
    weeklyRevenue: 'Weekly Revenue',
    mon2: 'Mon',
    tue2: 'Tue',
    wed2: 'Wed',
    thu2: 'Thu',
    fri2: 'Fri',
    sat2: 'Sat',
    invoice: 'INVOICE',
    amount: 'AMOUNT',
    inv001: 'INV-001',
    giorgiBeridze: 'Giorgi Beridze',
    checkupXray: 'Checkup + X-ray',
    u20be80: '\u20BE80',
    inv002: 'INV-002',
    ninoKapanadze: 'Nino Kapanadze',
    whitening: 'Whitening',
    u20be120: '\u20BE120',
    inv003: 'INV-003',
    davitGelashvili: 'Davit Gelashvili',
    implantPhase1: 'Implant Phase 1',
    u20be300: '\u20BE300+',
    inv004: 'INV-004',
    anaJavakhishvili: 'Ana Javakhishvili',
    rootCanal: 'Root Canal',
    u20be149: '\u20BE149',
    u2715: '\u2715',
    configuration: 'Configuration',
    apiKey: 'API Key',
    endpointUrl: 'Endpoint URL',
    protocol: 'Protocol',
    syncSettings: 'Sync Settings',
    syncFrequency: 'Sync Frequency',
    every5Minutes: 'Every 5 minutes',
    every15Minutes: 'Every 15 minutes',
    everyHour: 'Every hour',
    manualOnly: 'Manual only',
    autosyncOnChanges: 'Auto-sync on changes',
    lastSynced: 'Last synced',
    disconnect: 'Disconnect',
    testConnection: 'Test Connection',
    labCasePipeline: 'Lab Case Pipeline',
    labVendors2: 'Lab Vendors',
    tbilisidentLab: 'TbilisiDent Lab',
    turnaround710Days: 'Turnaround: 7-10 days',
    rating485: 'Rating: 4.8/5',
    activeCases4: 'Active Cases: 4',
    caucasusDentalLab: 'Caucasus Dental Lab',
    turnaround57Days: 'Turnaround: 5-7 days',
    rating465: 'Rating: 4.6/5',
    activeCases2: 'Active Cases: 2',
    euroDentalGeorgia: 'Euro Dental Georgia',
    turnaround1014Days: 'Turnaround: 10-14 days',
    rating445: 'Rating: 4.4/5',
    enterSpaceForClinics: 'Enter space for clinics →',
    book: 'Book',
    followupConsultation: 'Follow-up Consultation',
    postoperativeCheckAfterRoot: 'Post-operative check after root canal on #14. Healing well, no signs of infection. Crown preparation scheduled.',
    rootCanalTreatmentPhase: 'Root Canal Treatment - Phase 2',
    completedObturationOnTooth: 'Completed obturation on tooth #14. Gutta percha fill, lateral condensation technique. Post-op radiograph confirmed adequate fill.',
    periapicalXray: 'Periapical X-ray',
    workingLengthRadiographFor: 'Working length radiograph for tooth #14. Canal preparation confirmed at 21mm. No periapical changes noted.',
    medicationPrescribedAmoxicilli: 'Medication Prescribed: Amoxicillin 500mg',
    prescribed7dayCourseOf: 'Prescribed 7-day course of Amoxicillin for periapical infection. Patient advised re: Penicillin allergy - confirmed Amoxicillin tolerance via skin test.',
    diagnosisAcutePulpitis14: 'Diagnosis: Acute Pulpitis #14',
    patientPresentedWithSevere: 'Patient presented with severe spontaneous pain in upper right quadrant. Cold test positive, percussion sensitive. Diagnosed acute irreversible pulpitis.',
    compositeFillingTooth21: 'Composite Filling - Tooth #21',
    classIiCompositeRestoration: 'Class II composite restoration on #21. Shade A2 selected. Rubber dam isolation. Incremental layering technique. Occlusal adjustment completed.',
    labResultsCbcPanel: 'Lab Results: CBC Panel',
    completeBloodCountWithin: 'Complete blood count within normal limits. WBC 6.2, RBC 4.8, Hemoglobin 14.2 g/dL, Platelets 245K. Cleared for surgical procedures.',
    fullmouthRadiographs: 'Full-mouth Radiographs',
    panoramicOpgAndFull: 'Panoramic OPG and full periapical series completed. Findings: periapical radiolucency on #14, early carious lesion on #21, generalized mild bone loss.',
    comprehensiveExamination: 'Comprehensive Examination',
    initialComprehensiveExamFull: 'Initial comprehensive exam. Full periodontal charting completed. BPE scores: 2,2,3,2,3,2. Treatment plan discussed and consent obtained. BP recorded 128/82.',
    medicationUpdateLisinopril10mg: 'Medication Update: Lisinopril 10mg',
    patientReportedCurrentMedicati: 'Patient reported current medication: Lisinopril 10mg daily for hypertension. No other medications. GP: Dr. Maisuradze, Tbilisi Medical Center.',
    patientRegistration: 'Patient Registration',
    newPatientRegistrationMedical: 'New patient registration. Medical history questionnaire completed. Allergies documented: Penicillin (severe), Latex (moderate), Lidocaine (mild). Insurance: GPI Health.',
    activeConditions: 'Active Conditions',
    chronicPeriodontitis: 'Chronic Periodontitis',
    active: 'Active',
    generalizedMildChronicPeriodon: 'Generalized mild chronic periodontitis with localized moderate involvement. BPE scores indicate need for periodontal management.',
    onsetJan2026: 'Onset: Jan 2026',
    dentalCaries: 'Dental Caries',
    resolved: 'Resolved',
    cariousLesionOnTooth: 'Carious lesion on tooth #21, mesio-occlusal surface. Treated with composite restoration on Feb 15, 2026.',
    resolvedFeb2026: 'Resolved: Feb 2026',
    bruxism: 'Bruxism',
    nocturnalBruxismWearFacets: 'Nocturnal bruxism. Wear facets noted on anterior teeth. Night guard recommended but patient has not yet started use.',
    activeMedications: 'Active Medications',
    lisinopril10mg: 'Lisinopril 10mg',
    onceDailyOral: 'Once daily, oral',
    hypertensionManagement: 'Hypertension management',
    chlorhexidine012Rinse: 'Chlorhexidine 0.12% Rinse',
    twiceDailyOralRinse: 'Twice daily, oral rinse',
    periodontalMaintenance: 'Periodontal maintenance',
    ibuprofen400mg: 'Ibuprofen 400mg',
    asNeededForPain: 'As needed for pain, max 3x daily',
    postprocedurePainManagement: 'Post-procedure pain management',
    pastMedications: 'Past Medications',
    amoxicillin500mg: 'Amoxicillin 500mg',
    periapicalInfectionProphylaxis: 'Periapical infection prophylaxis',
    completed2: 'Completed',
    metronidazole250mg: 'Metronidazole 250mg',
    adjunctPeriodontalTherapy: 'Adjunct periodontal therapy',
    paracetamol500mg: 'Paracetamol 500mg',
    asNeededFeb1518: 'As needed (Feb 15-18, 2026)',
    postfillingSensitivity: 'Post-filling sensitivity',
    diclofenac50mg: 'Diclofenac 50mg',
    twiceDailyFor3: 'Twice daily for 3 days (Jan 22-24, 2026)',
    postexamSoreness: 'Post-exam soreness',
    documentedAllergies: 'Documented Allergies',
    penicillin: 'Penicillin',
    severe: 'SEVERE',
    reactionAnaphylaxisUrticariaAn: 'Reaction: Anaphylaxis, urticaria, angioedema',
    crossreactivityWithCephalospor: 'Cross-reactivity with cephalosporins possible. Amoxicillin tolerance confirmed via supervised skin test. Document in all referral letters.',
    documentedJan102026: 'Documented: Jan 10, 2026',
    latex: 'Latex',
    moderate: 'MODERATE',
    reactionContactDermatitisLocal: 'Reaction: Contact dermatitis, localized swelling',
    useNitrileGlovesOnly: 'Use nitrile gloves only. Latex-free environment required for all procedures. Flag prominently in appointment notes.',
    lidocaine: 'Lidocaine',
    mild: 'MILD',
    reactionMildTinglingProlonged: 'Reaction: Mild tingling, prolonged numbness beyond expected duration',
    useArticaineAsAlternative: 'Use Articaine as alternative local anesthetic. Patient tolerates Mepivacaine well. Monitor for unusual reactions.',
    latestVitalsMar15: 'Latest Vitals — Mar 15, 2026',
    labResults2: 'Lab Results',
    test: 'TEST',
    result: 'RESULT',
    reference: 'REFERENCE',
    date: 'DATE',
    hemoglobin: 'Hemoglobin',
    platelets: 'Platelets',
    glucoseFasting: 'Glucose (fasting)',
    immunizationRecords: 'Immunization Records',
    hepatitisB: 'Hepatitis B',
    completed3doseSeries2019: 'Completed: 3-dose series, 2019',
    upToDate: 'Up to date',
    tetanusdiphtheriaTd: 'Tetanus/Diphtheria (Td)',
    lastBooster2022: 'Last booster: 2022',
    covid19: 'COVID-19',
    lastDoseSep2024: 'Last dose: Sep 2024',
    dueForBooster: 'Due for booster',
    familyMedicalHistory: 'Family Medical History',
    father: 'Father',
    hypertensionType2Diabetes: 'Hypertension, Type 2 Diabetes, Periodontal disease',
    mother: 'Mother',
    osteoporosisDrugAllergySulfona: 'Osteoporosis, Drug allergy (Sulfonamides)',
    sibling: 'Sibling',
    bruxismDentalAnxiety: 'Bruxism, Dental anxiety',
    imagingRecords: 'Imaging Records',
    panoramicOpg: 'Panoramic OPG',
    periapical14: 'Periapical #14',
    bitewingRl: 'Bitewing R+L',
    patientDocuments: 'Patient Documents',
    consentFormRootCanal: 'Consent Form - Root Canal',
    treatmentPlanAgreement: 'Treatment Plan Agreement',
    medicalHistoryQuestionnaire: 'Medical History Questionnaire',
    insuranceAuthorizationGpi: 'Insurance Authorization - GPI',
    insuranceInformation: 'Insurance Information',
    provider: 'Provider:',
    policy: 'Policy #:',
    group: 'Group:',
    corporatePlanPremium: 'Corporate Plan - Premium',
    coverage: 'Coverage:',
    deductible: 'Deductible:',
    annualMax2: 'Annual Max:',
    valid: 'Valid:',
    age34: 'Age: 34',
    lastVisitMar10: 'Last visit: Mar 10',
    nextMar19: 'Next: Mar 19',
    overview: 'Overview',
    dentalChart: 'Dental Chart',
    treatmentPlan: 'Treatment Plan',
    history: 'History',
    documents2: 'Documents',
    allergies2: 'Allergies',
    medicalNotes: 'Medical Notes',
    insurance3: 'Insurance',
    upperArch: 'Upper Arch',
    lowerArch: 'Lower Arch',
    tooth: 'TOOTH',
    procedure2: 'PROCEDURE',
    price: 'PRICE',
    rootCanalTreatment: 'Root Canal Treatment',
    ceramicCrown: 'Ceramic Crown',
    compositeFilling: 'Composite Filling',
    implantPlacement: 'Implant Placement',
    total: 'Total',
    addProcedure2: '+ Add Procedure',
    march102026: 'March 10, 2026',
    periapicalXrayRootCanal: 'Periapical X-ray, Root canal treatment initiated on #14. Working length determined. Calcium hydroxide dressing placed.',
    february152026: 'February 15, 2026',
    compositeFillingOn21: 'Composite filling on #21. Shade A2. Occlusal adjustment performed. Patient tolerated procedure well.',
    january202026: 'January 20, 2026',
    comprehensiveExaminationFullmo: 'Comprehensive examination. Full-mouth periapical radiographs. Treatment plan discussed with patient. Consent forms signed.',
    bitewingRight: 'Bitewing Right',
    bitewingLeft: 'Bitewing Left',
    uploadDocument: '+ Upload Document',
    all: 'All',
    new: 'New',
    phone2: 'PHONE',
    lastVisit: 'LAST VISIT',
    nextAppt: 'NEXT APPT',
    balance: 'BALANCE',
    pt001: 'PT-001',
    pt002: 'PT-002',
    pt003: 'PT-003',
    mariamTsiklauri: 'Mariam Tsiklauri',
    pt004: 'PT-004',
    pt005: 'PT-005',
    lukaMchedlishvili: 'Luka Mchedlishvili',
    pt006: 'PT-006',
    tamtaLomidze: 'Tamta Lomidze',
    pt007: 'PT-007',
    periodontalChart: 'Periodontal Chart',
    newExam2: '+ New Exam',
    voiceEntry2: 'Voice Entry',
    dcai: 'DCAI',
    dentalBookingOpsPlatform: 'Dental Booking & Ops Platform',
    theMissingInfrastructureFor: 'The missing infrastructure for Georgian dental clinics',
    manage: 'Manage',
    grow: 'Grow',
    marketSize: 'Market Size',
    dentalClinicsInGeorgia: 'dental clinics in Georgia',
    inTbilisiAlone: 'in Tbilisi alone',
    unifiedBookingOrOps: 'unified booking or ops platforms',
    dentosgeIsTheOnly: '⚠️  dentos.ge is the only partial incumbent — no full ops layer',
    theProblem2: 'The Problem',
    str511: '📋',
    clinicsRunOnExcel: 'Clinics run on Excel + WhatsApp + paper',
    noStructuredWorkflowConstant: 'No structured workflow, constant human error',
    str514: '📉',
    noshowsCost1525Of: 'No-shows cost 15–25% of revenue',
    noAutomatedRemindersOr: 'No automated reminders or confirmation system',
    str517: '🏦',
    insuranceBillingIsManual: 'Insurance billing is manual and painful',
    str519: '📵',
    dentalTourismPatientsEspeciall: 'Dental tourism patients especially expect digital-first booking',
    theSolution: 'The Solution',
    str523: '📅',
    onlineBookingWidgetMarketplace: 'Online booking widget + marketplace',
    patientsBook247From: 'Patients book 24/7 from any device',
    str526: '🦷',
    patientRecordsTreatmentManagem: 'Patient records & treatment management',
    fullHistoryTreatmentPlans: 'Full history, treatment plans, e-docs',
    str529: '🏥',
    insuranceIntegrations: 'Insurance integrations',
    str531: '💬',
    smsWhatsappReminders: 'SMS / WhatsApp reminders',
    cutNoshowsByUp: 'Cut no-shows by up to 40%',
    str534: '📊',
    financialReportingDashboard: 'Financial reporting dashboard',
    revenueSalariesExpensesRealtim: 'Revenue, salaries, expenses — realtime',
    willingnessToPay: 'Willingness to Pay',
    free: 'Free',
    month: '/month',
    listingBookingWidget: 'Listing + booking widget',
    growth: 'Growth',
    calendarRemindersPatientCards: 'Calendar + reminders + patient cards',
    pro: 'Pro',
    fullOpsInsuranceAnalytics: 'Full ops + insurance + analytics',
    multibranchApiAccessReporting: 'Multi-branch + API access + reporting',
    wtp0515OfMonthly: '💡 WTP: 0.5–1.5% of monthly revenue — clinics earning ₾15K–50K/mo pay ₾100–350/mo comfortably',
    marketOpportunity: 'Market Opportunity',
    addressableClinicsAtLaunch: 'addressable clinics at launch',
    mrrAtFullPenetration: 'MRR at full penetration (₾49 avg)',
    home: 'الرئيسية', features: 'الميزات', pricing: 'الأسعار', clinicsNav: 'العيادات', aiAssistant: 'مساعد AI', forBusiness: 'للأعمال', dashboard: 'لوحة التحكم', getStarted: 'ابدأ', tryDemo: 'جرب العرض',
    heroTagline: 'منصة طب الأسنان لجورجيا', heroTitle: 'مركز جميع عيادات الأسنان', heroSubtitle: 'مساعدك AI للعثور على أفضل رعاية أسنان في جورجيا',
    searchPlaceholder: 'ابحث عن عيادات أو خدمات...', chipImplant: 'أفضل عيادات الزراعة في تبليسي', chipWhitening: 'تبييض الأسنان بالقرب مني', chipEmergency: 'رعاية أسنان طارئة', chipOrtho: 'تقويم الأسنان للبالغين', scrollExplore: 'مرر للاستكشاف',
    topRated: 'أفضل عيادات الأسنان في تبليسي', viewAllClinics: 'عرض جميع العيادات', statClinics: 'العيادات', statNoShows: 'غياب أقل', statBooking: 'حجز عبر الإنترنت', statDentists: 'أطباء أسنان', statRating: 'متوسط التقييم', statPatients: 'المرضى',
    findClinics: 'ابحث عن أفضل العيادات', clinicsTitle: 'عيادات الأسنان في جورجيا', verifiedClinics: 'عيادات موثقة', reviews: 'تقييمات',
    callClinic: 'اتصل', bookAppointment: 'احجز موعد', services: 'الخدمات', workingHours: 'ساعات العمل', priceRange: 'نطاق الأسعار', location: 'الموقع',
    bookingTitle: 'احجز موعد', step: 'خطوة', selectClinic: 'اختر العيادة', selectService: 'اختر الخدمة', selectDate: 'اختر التاريخ', selectTime: 'اختر الوقت', confirm: 'تأكيد', next: 'التالي', back: 'رجوع',
    viewPitch: 'عرض العرض التقديمي',
    shareLocation: 'شارك موقعك للعيادات القريبة',
    locationShared: 'تم مشاركة الموقع — عرض القريبة',
    forBusinessBtn: 'للأعمال',
    ownClinic: 'هل تملك عيادة أسنان؟',
    claimText: 'سجّل عيادتك أو أضفها إلى قاعدة بياناتنا.',
    getListed: 'سجّل الآن →',
    searchByName: 'بحث بالاسم أو المنطقة أو الخدمة...',
    hideMap: 'إخفاء الخريطة',
    showMap: 'الخريطة',
    nearMe: 'بالقرب مني',
    clinicsMatch: 'عيادات مطابقة',
    loadingMore: 'جارٍ التحميل...',
    visitWebsite: 'زيارة الموقع',
    clinicsAvailable: 'عيادات متاحة',
    clinicsFound: 'عيادات وُجدت',
    confirmBooking: 'تأكيد الحجز',
    bookingConfirmed: 'تم تأكيد موعدك!',
    patientName: 'اسم المريض',
    phoneNumber: 'رقم الهاتف',
    email: 'البريد الإلكتروني',
    notes: 'ملاحظات (اختياري)',
    businessHeroBadge: '15+ وحدة  ·  212+ عيادة  ·  Gemini AI',
    businessHeroTitle: 'نظام تشغيل عيادات الأسنان',
    businessHeroSubtitle: 'الرسم السريري، تحليل اللثة، تخطيط العلاج، الجدولة، الفوترة، الوصفات الإلكترونية، إدارة المختبر وتشخيص AI — كلها في منصة واحدة لجورجيا.',
    theProblem: 'المشكلة',
    problemSubtitle: 'عيادات الأسنان الجورجية تخسر إيرادات يومياً بسبب الأدوات المجزأة',
    excelChaos: 'فوضى Excel وWhatsApp',
    excelChaosDetail: 'العيادات تدير المواعيد عبر الجداول ومجموعات الدردشة. صفر أتمتة، أخطاء مستمرة.',
    noShowRate: 'معدل غياب 25%',
    noShowDetail: 'بدون تذكيرات تلقائية، ينسى المرضى المواعيد. الكراسي الفارغة تعني خسارة ₾500+/يوم.',
    paperCharts: 'سجلات ورقية في 2026',
    paperChartsDetail: 'ملاحظات سريرية مكتوبة بخط اليد، بدون مخطط أسنان رقمي. بيانات حرجة محبوسة في الخزائن.',
    insuranceBlackHole: 'الثقب الأسود للتأمين',
    insuranceDetail: 'المطالبات اليدوية إلى Aldagi وGPI وImedi L تستغرق ساعات. المطالبات المرفوضة تتراكم.',
    oneplatform: 'منصة واحدة، كل الوحدات',
    platformSubtitle: '15 وحدة متكاملة مصممة لممارسات طب الأسنان',
    clinical: 'سريري',
    operations: 'العمليات',
    analyticsEnterprise: 'التحليلات والمؤسسة',
    digitalOdontogram: 'مخطط أسنان رقمي',
    digitalOdontogramDetail: 'مخطط FDI 32 سن مع تتبع 5 أسطح.',
    perioCharting: 'رسم اللثة',
    perioChartingDetail: 'شبكة لثوية 192 نقطة. سبر 6 نقاط، BOP، CAL.',
    treatmentPlanning: 'تخطيط العلاج',
    treatmentPlanningDetail: 'خطط مرحلية مع أكواد CDT، تقديرات التأمين. تسلسل AI.',
    soapNotes: 'ملاحظات SOAP + كاتب AI',
    soapNotesDetail: 'توثيق سريري منظم بقوالب. Gemini يولد ملاحظات من الصوت.',
    multiChairScheduling: 'جدولة متعددة الكراسي',
    multiChairDetail: 'عرض أسبوعي مع عدة غرف عمليات. ترميز لوني للأطباء.',
    billingInsurance: 'الفوترة والتأمين',
    billingDetail: 'تتبع مطالبات Aldagi وGPI وImedi L. دفتر المريض، خطط الدفع.',
    ePrescribing: 'الوصفات الإلكترونية',
    ePrescribingDetail: 'وصفات رقمية بقوالب. فحص تفاعلات الأدوية عبر Gemini.',
    labTracking: 'تتبع المختبر',
    labTrackingDetail: 'كانبان: تم الطلب → التصنيع → الشحن → الاستلام.',
    productionReports: 'تقارير الإنتاج',
    productionReportsDetail: 'الإنتاج الإجمالي/الصافي، معدل التحصيل، قبول العلاج.',
    referralMgmt: 'إدارة الإحالات',
    referralMgmtDetail: 'إحالات واردة/صادرة للمتخصصين. خطابات مولدة بالـ AI.',
    medicalHistory: 'التاريخ الطبي',
    medicalHistoryDetail: 'سجل مريض 11 عرض: الجدول الزمني، الحالات، الأدوية، الحساسيات.',
    enterpriseAdmin: 'إدارة المؤسسة',
    enterpriseAdminDetail: 'RBAC، سجل التدقيق، الامتثال، تعدد المستأجرين، SSO، إدارة API.',
    geminiBuiltIn: 'Gemini AI مدمج',
    geminiSubtitle: 'كل وحدة مدعومة بـ Google Gemini 3.1',
    xrayAnalysis: 'تحليل الأشعة السينية',
    xrayDetail: 'ارفع صور الأشعة السينية للأسنان للكشف عن التسوس بالـ AI.',
    perioAssessment: 'تقييم اللثة',
    perioAssessmentDetail: 'تصنيف/تدريج AAP تلقائي من بيانات السبر.',
    clinicalScribe: 'الكاتب السريري',
    clinicalScribeDetail: 'إنشاء ملاحظات SOAP من التسجيلات الصوتية أو بيانات السجل.',
    riskProfiling: 'تقييم المخاطر',
    riskProfilingDetail: 'تحليل الحالات والتاريخ العائلي لإنشاء ملف مخاطر الأسنان.',
    treatmentSequencing: 'تسلسل العلاج',
    treatmentSequencingDetail: 'تسلسل علاج محسّن بالـ AI مع مراعاة الشفاء والتأمين.',
    patientComm: 'تواصل المريض',
    patientCommDetail: 'إنشاء شروحات مفهومة للمريض بالجورجية.',
    georgianEcosystem: 'النظام البيئي الجورجي جاهز',
    integrationsSubtitle: 'تكاملات مسبقة مع التأمين والمدفوعات والمراسلات المحلية',
    insurance: 'التأمين',
    payments: 'المدفوعات',
    messaging: 'المراسلات',
    ehrLabs: 'السجل الصحي الإلكتروني والمختبرات',
    clinicsInDb: 'العيادات في قاعدة البيانات',
    platformModules: 'وحدات المنصة',
    aiTools: 'أدوات AI (Gemini)',
    integrations: 'التكاملات',
    pricingTitle: 'الأسعار',
    pricingSubtitle: 'ابدأ مجاناً، توسع مع النمو',
    trustedBy: 'ثقة العيادات',
    readyModernize: 'مستعد للتحديث؟',
    joinCount: 'انضم إلى 212+ عيادة في جورجيا.',
    startTrial: 'ابدأ مجاناً',
    contactSales: 'تواصل مع المبيعات',
    noCreditCard: 'لا حاجة لبطاقة ائتمان  ·  خطة مجانية  ·  إعداد في 5 دقائق',
    copyright: '© 2026 MCAI',

    // ─── NEW KEYS ────────────────────────────────────────

    // Navigation & Layout
    navDashboard: 'لوحة التحكم',
    navPatients: 'المرضى',
    navChart: 'السجل',
    navPerio: 'اللثة',
    navTreatmentPlans: 'خطط العلاج',
    navNotes: 'الملاحظات',
    navScheduling: 'الجدولة',
    navBilling: 'الفوترة',
    navPrescriptions: 'الوصفات',
    navLabCases: 'حالات المختبر',
    navReferrals: 'الإحالات',
    navReports: 'التقارير',
    navMedHistory: 'التاريخ الطبي',
    navIntegrations: 'التكاملات',
    navEnterprise: 'المؤسسة',
    sectionClinical: 'سريري',
    sectionOperations: 'العمليات',
    sectionAnalytics: 'التحليلات',
    sectionAiTools: 'أدوات AI',
    sectionAdmin: 'الإدارة',

    // Booking Page
    chooseClinic: 'اختر عيادة',
    selectAService: 'اختر خدمة',
    pickADate: 'اختر تاريخاً',
    pickATime: 'اختر وقتاً',
    confirmYourBooking: 'أكد حجزك',
    clinicLabel: 'العيادة:',
    serviceLabel: 'الخدمة:',
    dateLabel: 'التاريخ:',
    timeLabel: 'الوقت:',

    // AI Page
    send: 'إرسال',
    procedure: 'إجراء',
    observations: 'ملاحظات',
    aiThinking: 'AI يفكر...',
    summarizeHistory: 'تلخيص تاريخ المريض',
    generateTxPlan: 'إنشاء خطة علاج',
    checkDrugInteractions: 'فحص تفاعلات الأدوية',
    writeClinicalNote: 'كتابة ملاحظة سريرية',
    askAiAssistant: 'اسأل مساعد AI...',
    dropXray: 'أسقط صورة الأشعة أو انقر للرفع',
    supportsFormats: 'يدعم DICOM، PNG، JPG',
    analysisResults: 'نتائج التحليل (عرض)',
    aiRecommendation: 'توصية AI',
    exportToTxPlan: 'تصدير إلى خطة العلاج',
    generateClinicalNote: 'إنشاء ملاحظة سريرية',
    generatedSoap: 'ملاحظة سريرية مُنشأة (SOAP)',
    subjective: 'S — ذاتي',
    objective: 'O — موضوعي',
    assessment: 'A — التقييم',
    plan: 'P — الخطة',
    copyToRecord: 'نسخ إلى سجل المريض',
    aiPerioAssessment: 'تقييم AI لأمراض اللثة',
    enterProbingData: 'أدخل بيانات السبر للحصول على تصنيف AAP وتوصيات العلاج.',
    analyzeWithGemini: 'تحليل مع Gemini',
    aiRiskAssessment: 'تقييم AI للمخاطر',
    enterConditions: 'أدخل حالات المريض والتاريخ العائلي والعلامات الحيوية لإنشاء ملف المخاطر.',
    generateRiskProfile: 'إنشاء ملف المخاطر',
    patientCommunication: 'تواصل المريض',
    generateExplanations: 'إنشاء شروحات علاجية مفهومة للمريض بالجورجية أو الإنجليزية.',
    generateExplanation: 'إنشاء شرح',
    patientFriendly: 'شرح مفهوم للمريض',

    // Billing Page
    claims: 'المطالبات',
    ledger: 'دفتر الحسابات',
    aging: 'تقادم الديون',
    paymentPlans: 'خطط الدفع',
    eligibility: 'الأهلية',
    allFilter: 'الكل',
    submitted: 'مقدم',
    paid: 'مدفوع',
    denied: 'مرفوض',
    patientLedger: 'حساب المريض',
    agedAccounts: 'حسابات متأخرة',
    sendStatements: 'إرسال كشوفات',
    activePaymentPlans: 'خطط دفع نشطة',
    insuranceEligibility: 'أهلية التأمين',

    // Clinical Charting
    odontogram: 'مخطط الأسنان',
    perioTab: 'اللثة',
    treatmentPlanTab: 'خطة العلاج',
    notesTab: 'الملاحظات',
    progressNotes: 'ملاحظات التقدم',
    openFullPerio: 'فتح مخطط اللثة الكامل →',
    openFullTxPlanner: 'فتح مخطط العلاج الكامل →',
    openClinicalNotes: 'فتح الملاحظات السريرية →',
    newExam: 'فحص جديد',
    voiceEntry: 'إدخال صوتي',
    bleedingIndex: 'مؤشر النزيف',
    plaqueIndex: 'مؤشر اللويحة',
    sitesAbove4: 'مواقع ≥ 4مم',
    sitesAbove6: 'مواقع ≥ 6مم',
    planA: 'الخطة أ: الموصى بها',
    planB: 'الخطة ب: التحفظية',
    newPlan: '+ خطة جديدة',
    presentToPatient: 'تقديم للمريض',
    sendToPortal: 'إرسال إلى البوابة',
    totalFee: 'إجمالي الرسوم',
    insuranceEst: 'تقدير التأمين',
    patientPortion: 'حصة المريض',
    chairSideMode: 'وضع جانب الكرسي',
    adminMode: 'وضع المسؤول',
    proceduresAcrossPhases: '{0} إجراء عبر {1} مراحل',

    // Scheduling
    day: 'يوم',
    week: 'أسبوع',
    today: 'اليوم',
    providerFilter: 'جميع مقدمي الخدمة',
    productionGoal: 'هدف الإنتاج',
    waitlist: 'قائمة الانتظار',

    // Prescriptions
    activeRx: 'نشطة',
    pastRx: 'سابقة',
    templates: 'قوالب',
    interactionCheck: 'فحص التفاعلات',

    // Lab Cases
    ordered: 'تم الطلب',
    sentToLab: 'أُرسل للمختبر',
    inFabrication: 'قيد التصنيع',
    shipped: 'تم الشحن',
    received: 'تم الاستلام',
    labVendors: 'موردو المختبرات',

    // Referrals
    allDirections: 'الكل',
    inbound: 'واردة',
    outbound: 'صادرة',
    generateLetter: 'إنشاء خطاب',

    // Reports
    production: 'الإنتاج',
    collections: 'التحصيلات',
    schedulingReport: 'الجدولة',
    treatmentAcceptance: 'قبول العلاج',
    recall: 'إعادة الاستدعاء',
    grossProduction: 'الإنتاج الإجمالي',
    netProduction: 'الإنتاج الصافي',
    collectionRate: 'معدل التحصيل',
    plansPresented: 'الخطط المقدمة',
    accepted: 'مقبول',
    acceptanceRate: 'معدل القبول',
    dueThisMonth: 'مستحق هذا الشهر',
    scheduled: 'مجدول',
    completed: 'مكتمل',
    overdue: 'متأخر',
    reactivationRate: 'معدل إعادة التنشيط',

    // Medical History
    timeline: 'الجدول الزمني',
    conditions: 'الحالات',
    medications: 'الأدوية',
    allergies: 'الحساسيات',
    labResults: 'نتائج المختبر',
    vitals: 'العلامات الحيوية',
    immunizations: 'التطعيمات',
    familyHistory: 'التاريخ العائلي',
    imaging: 'التصوير',
    documents: 'المستندات',

    // Enterprise
    rbac: 'RBAC',
    auditLog: 'سجل التدقيق',
    compliance: 'الامتثال',
    multiTenancy: 'تعدد المستأجرين',
    sso: 'SSO والأمان',
    featureFlags: 'أعلام الميزات',
    apiManagement: 'إدارة API',
    dataManagement: 'إدارة البيانات',

    // Integrations
    ehr: 'السجل الصحي الإلكتروني',
    labs: 'المختبرات',
    telehealth: 'الطب عن بُعد',
    aiMl: 'AI/ML',
    wearables: 'الأجهزة القابلة للارتداء',
    connected: 'متصل',
    disconnected: 'غير متصل',
    available: 'متاح',

    // Components
    status: 'الحالة',
    healthy: 'سليم',
    caries: 'تسوس',
    restored: 'مرمم',
    missing: 'مفقود',
    implant: 'زرعة',
    crownStatus: 'تاج',
    bridge: 'جسر',
    veneer: 'قشرة',
    surfaces: 'الأسطح',
    procedureHistory: 'تاريخ الإجراءات',
    addProcedure: 'إضافة إجراء',
    totalCharged: 'إجمالي المحمّل',
    insurancePayment: 'دفعة التأمين',
    patientResponsibility: 'مسؤولية المريض',
    expand: 'توسيع',
    policyNumber: 'رقم البوليصة',
    planType: 'نوع الخطة',
    annualMax: 'الحد السنوي الأقصى',
    used: 'مستخدم',
    remaining: 'متبقي',
    coverageByCategory: 'التغطية حسب الفئة',
    preventive: 'وقائي',
    basic: 'أساسي',
    major: 'رئيسي',
    ortho: 'تقويم',
    current: 'حالي',
    thirtyDay: '30 يوم',
    sixtyDay: '60 يوم',
    ninetyPlus: '90+ يوم',
    totalBalance: 'الرصيد الإجمالي',
    monthlyPayment: 'الدفعة الشهرية',
    paymentsRemaining: 'الدفعات المتبقية',
    nextPayment: 'الدفعة التالية',
    paymentProgress: 'تقدم الدفع',
    choosePlan: 'اختر خطة',
    aiInsight: 'رؤية AI',
    confidence: 'الثقة',
    revoke: 'إلغاء',
    exams: 'الفحوصات',
    phaseTotal: 'إجمالي المرحلة',
    mon: 'اثن',
    tue: 'ثلا',
    wed: 'أرب',
    thu: 'خمي',
    fri: 'جمع',
    sat: 'سبت',
    sun: 'أحد',
    thinking: 'يفكر...',
    followUpPlaceholder: 'اطرح سؤال متابعة...',
    initialMrrCeilingUsd: 'initial MRR ceiling (USD)',
    nextExpansionArmeniaAzerbaijan: '🌍  Next expansion: Armenia → Azerbaijan → broader Caucasus dental market',
    whyNow: 'Why Now',
    str561: '✈️',
    dentalTourismBoom: 'Dental tourism boom',
    internationalPatientsNeedEngli: 'International patients need English-language online booking now',
    str564: '📱',
    postcovidDigitizationPressure: 'Post-COVID digitization pressure',
    clinicsThatSurvivedAre: 'Clinics that survived are ready to invest in tech',
    str567: '🏆',
    noStrongLocalIncumbent: 'No strong local incumbent',
    dentosgeOnlyCoversDiscovery: 'dentos.ge only covers discovery — zero full ops platform exists',
    str570: '🇬🇪',
    georgiaIsAHealthcare: 'Georgia is a healthcare hub in the Caucasus',
    lowCostHighQuality: 'Low cost, high quality — 50–70% cheaper than Western Europe',
    joinThePartnerClinic: 'Join the Partner Clinic Program — first 3 months free',
    builtForGeorgianClinics: '🦷 Built for Georgian clinics, by people who live here',
    prev: '← Prev',
    next2: 'Next →',
    getInTouch: '🦷 Get in Touch',
    activePrescriptions: 'Active Prescriptions',
    pastPrescriptions: 'Past Prescriptions',
    prescriptionTemplates: 'Prescription Templates',
    drugInteractionChecker: 'Drug Interaction Checker',
    referrals: 'Referrals',
    newReferral: '+ New Referral',
    inbound2: 'Inbound',
    outbound2: 'Outbound',
    reportsAnalytics: 'Reports & Analytics',
    productionByProvider: 'Production by Provider',
    productionByCategory: 'Production by Category',
    preventive2: 'Preventive',
    restorative: 'Restorative',
    endodontics: 'Endodontics',
    periodontics: 'Periodontics',
    prosthodontics: 'Prosthodontics',
    surgery: 'Surgery',
    agingReport: 'Aging Report',
    appointmentsByDay: 'Appointments by Day',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    topDeclinedTreatments: 'Top Declined Treatments',
    costConcerns: 'Cost concerns',
    wantsToWait: 'Wants to wait',
    orthodontics: 'Orthodontics',
    insuranceNotCovering: 'Insurance not covering',
    notAPriority: 'Not a priority',
    seekingSecondOpinion: 'Seeking second opinion',
    u2190: '\u2190',
    u2192: '\u2192',
    allProviders: 'All Providers',
    hygienistNino: 'Hygienist Nino',
    mon17: 'MON 17',
    tue18: 'TUE 18',
    wed19: 'WED 19',
    thu20: 'THU 20',
    fri21: 'FRI 21',
    crownPrep14: 'Crown Prep #14',
    tKapanadze: 'T. Kapanadze',
    srpQuad1: 'SRP Quad 1',
    dGelashvili: 'D. Gelashvili',
    examXray: 'Exam + X-ray',
    mTsiklauri: 'M. Tsiklauri',
    unconfirmed: 'Unconfirmed',
    rct36: 'RCT #36',
    gBeridze: 'G. Beridze',
    prophyPolish: 'Prophy + Polish',
    iDiasamidze: 'I. Diasamidze',
    perioMaintenance: 'Perio Maintenance',
    tLomidze: 'T. Lomidze',
    prophy: 'Prophy',
    aJavakhishvili: 'A. Javakhishvili',
    inChair: 'In Chair',
    sealantsX4: 'Sealants x4',
    nKapanadze: 'N. Kapanadze',
    lMchedlishvili: 'L. Mchedlishvili',
    u2014LunchU2014: '\u2014 Lunch \u2014',
    veneerPrep11: 'Veneer Prep #11',
    kGabrichidze: 'K. Gabrichidze',
    composite25: 'Composite #25',
    sMeladze: 'S. Meladze',
    bridgePrep3436: 'Bridge Prep #34-36',
    rKharazishvili: 'R. Kharazishvili',
    composite22: 'Composite #22',
    zDolidze: 'Z. Dolidze',
    noShow: 'No Show',
    extraction48: 'Extraction #48',
    vPapunashvili: 'V. Papunashvili',
    implantConsult: 'Implant Consult',
    eTsereteli: 'E. Tsereteli',
    nGogiberidze: 'N. Gogiberidze',
    crownSeat14: 'Crown Seat #14',
    checkup: 'Checkup',
    bShengelia: 'B. Shengelia',
    fluorideTreatment: 'Fluoride Treatment',
    emergencyWalkin: 'Emergency Walk-in',
    scaling: 'Scaling',
    wantsMonwedAmSlot: 'Wants Mon/Wed AM slot \u2022 Whitening',
    assignToSchedule: 'Assign to Schedule',
    autoAssign: 'Auto Assign',
    high: 'High',
    anyMorningSlotU2022: 'Any morning slot \u2022 Implant Follow-up',
    medium: 'Medium',
    irakliDiasamidze: 'Irakli Diasamidze',
    friPmPreferredU2022: 'Fri PM preferred \u2022 Checkup',
    low: 'Low',
    planARecommended: 'Plan A: Recommended',
    planBConservative: 'Plan B: Conservative',
    newPlan2: '+ New Plan',
    conservativeApproach: 'Conservative Approach',
    thisPlanPrioritizesDisease: 'This plan prioritizes disease control and monitoring before committing to major restorative work. Implant placement is deferred pending perio re-evaluation.',
    u00b7: '\u00B7',
    treatmentPlanComparison: 'Treatment Plan Comparison',
    u00b72: '\u00b7',
    exams2: 'Exams:',
    metric: 'Metric',
    pdMm: 'PD (mm)',
    gmMm: 'GM (mm)',
    calMm: 'CAL (mm)',
    suppuration: 'Suppuration',
    furcation: 'Furcation',
    mobility: 'Mobility',
    qty: 'Qty',
    refills: 'Refills',
    goal: 'Goal',
    current2: 'Current',
    totalDue: 'Total Due',
    scheduled2: 'Scheduled',
    overdue2: 'Overdue',
    reactivation: 'Reactivation',
    chiefComplaint: 'Chief Complaint',
    painScale: 'Pain Scale:',
    clinicalFindings: 'Clinical Findings',
    diagnosis: 'Diagnosis',
    prescriptions: 'Prescriptions',
    u201c: '\u201C',
    xray: 'X-Ray',
    cleaning: 'Cleaning',
    amountPaid: 'Amount Paid',
    annotate: 'Annotate',
    anonymousPatient: 'Anonymous Patient',
    autoImport: 'Auto Import',
    away: 'Away',
    bankTransfer: 'Bank Transfer',
    beforeAfter: 'Before After',
    bookPrerequisiteFirst: 'Book Prerequisite First',
    breakdown: 'Breakdown',
    bridgePrep: 'Bridge Prep',
    brightness: 'Brightness',
    cabinet: 'Cabinet',
    cabinet1: 'Cabinet 1',
    cabinet2: 'Cabinet 2',
    cabinetSchedule: 'Cabinet Schedule',
    cabinetScheduleDesc: 'Cabinet Schedule Desc',
    card: 'Card',
    cash: 'Cash',
    cbct: 'Cbct',
    cephalometric: 'Cephalometric',
    channels: 'Channels',
    clinicalQuestion: 'Clinical Question',
    clinicAvgRating: 'Clinic Avg Rating',
    collapse: 'Collapse',
    completedToday: 'Completed Today',
    compositeF: 'Composite F',
    continueToScheduling: 'Continue To Scheduling',
    contrast: 'Contrast',
    ctScans: 'Ct Scans',
    customAmount: 'Custom Amount',
    days: 'Days',
    delivered: 'Delivered',
    directMessages: 'Direct Messages',
    disposables: 'Disposables',
    doctorResponse: 'Doctor Response',
    doctors: 'Doctors',
    documentMgmtSubtitle: 'Document Mgmt Subtitle',
    documentPreview: 'Document Preview',
    download: 'Download',
    endodontic: 'Endodontic',
    enterAmount: 'Enter Amount',
    equipmentDevices: 'Equipment Devices',
    estDelivery: 'Est Delivery',
    examConsult: 'Exam Consult',
    explanationQuality: 'Explanation Quality',
    fluorideTx: 'Fluoride Tx',
    fullMouthView: 'Full Mouth View',
    hasBracesQuestion: 'Has Braces Question',
    hasConsultationQuestion: 'Has Consultation Question',
    hasCtScanQuestion: 'Has Ct Scan Question',
    hasRecentXrayQuestion: 'Has Recent Xray Question',
    helpfulQuestion: 'Helpful Question',
    highest: 'Highest',
    hygiene: 'Hygiene',
    imagingType: 'Imaging Type',
    implantPlace: 'Implant Place',
    important: 'Important',
    importLatest: 'Import Latest',
    inProgress: 'In Progress',
    installment: 'Installment',
    insuranceCoverage: 'Insurance Coverage',
    interpreted: 'Interpreted',
    inUse: 'In Use',
    invoices: 'Invoices',
    lastCleaningQuestion: 'Last Cleaning Question',
    lateralSkullView: 'Lateral Skull View',
    lowest: 'Lowest',
    lowStock: 'Low Stock',
    lowStockAlerts: 'Low Stock Alerts',
    maintenance: 'Maintenance',
    management: 'Management',
    markComplete: 'Mark Complete',
    material: 'Material',
    method: 'Method',
    minOrder: 'Min Order',
    monthlySpend: 'Monthly Spend',
    newPayment: 'New Payment',
    newRadiologyReferral: 'New Radiology Referral',
    nextAppointment: 'Next Appointment',
    noDocumentsFound: 'No Documents Found',
    noNoteSelected: 'No Note Selected',
    normal: 'Normal',
    noteInterpreter: 'Note Interpreter',
    occupied: 'Occupied',
    online: 'Online',
    orderNow: 'Order Now',
    orders: 'Orders',
    original: 'Original',
    outstanding: 'Outstanding',
    painManagement: 'Pain Management',
    panoramic: 'Panoramic',
    patientDue: 'Patient Due',
    paymentHistory: 'Payment History',
    paymentMethod: 'Payment Method',
    pendingOrders: 'Pending Orders',
    periapical: 'Periapical',
    perioMaint: 'Perio Maint',
    photos: 'Photos',
    placeOrder: 'Place Order',
    preCheck: 'Pre Check',
    preCheckPassed: 'Pre Check Passed',
    preCheckSubtitle: 'Pre Check Subtitle',
    preCheckTitle: 'Pre Check Title',
    prerequisiteWarning: 'Prerequisite Warning',
    print: 'Print',
    processing: 'Processing',
    processPayment: 'Process Payment',
    processPaymentBtn: 'Process Payment Btn',
    professionalism: 'Professionalism',
    prophyClean: 'Prophy Clean',
    prosthetic: 'Prosthetic',
    punctuality: 'Punctuality',
    qtyUsed: 'Qty Used',
    quantity: 'Quantity',
    queue: 'Queue',
    receiptPreview: 'Receipt Preview',
    recent: 'Recent',
    recentMaterialUsage: 'Recent Material Usage',
    recentReceipts: 'Recent Receipts',
    reliability: 'Reliability',
    remainingBalance: 'Remaining Balance',
    reorderLevel: 'Reorder Level',
    scanning: 'Scanning',
    sealants: 'Sealants',
    sent: 'Sent',
    singleToothView: 'Single Tooth View',
    slotDetails: 'Slot Details',
    sortBy: 'Sort By',
    srpQuad: 'Srp Quad',
    startImaging: 'Start Imaging',
    stock: 'Stock',
    stockLevel: 'Stock Level',
    submitReferral: 'Submit Referral',
    subtotal: 'Subtotal',
    suppliers: 'Suppliers',
    surgical: 'Surgical',
    targetArea: 'Target Area',
    teamChat: 'Team Chat',
    termsNormalized: 'Terms Normalized',
    threeDImaging: 'Three D Imaging',
    totalItems: 'Total Items',
    totalReceived: 'Total Received',
    typeAMessage: 'Type A Message',
    unavailable: 'Unavailable',
    unit: 'Unit',
    urgency: 'Urgency',
    urgent: 'Urgent',
    usageLog: 'Usage Log',
    veneerPrep: 'Veneer Prep',
    viewOnGoogle: 'View On Google',
    xrays: 'Xrays'
  }
}
